import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type DocumentInterfaceObject = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  fileSize: Scalars['Float'];
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  id: Scalars['Int'];
  insertId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  label: Scalars['String'];
  email: Scalars['Boolean'];
  text: Scalars['Boolean'];
};

export type Role = {
  __typename?: 'Role';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  label: Scalars['String'];
  name: Scalars['String'];
  sequence?: Maybe<Scalars['Int']>;
};

export type Country = {
  __typename?: 'Country';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  label: Scalars['String'];
  code: Scalars['String'];
};

export type State = {
  __typename?: 'State';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  label: Scalars['String'];
  country?: Maybe<Country>;
};

export type App = {
  __typename?: 'App';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  adminDomain: Scalars['String'];
  name: Scalars['String'];
  address: Scalars['String'];
  city: Scalars['String'];
  stateId: Scalars['Float'];
  postalCode: Scalars['String'];
  users: Array<Maybe<User>>;
  state: State;
};

export type PlanCommunityAssignment = {
  __typename?: 'PlanCommunityAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  community: Community;
  plan: Plan;
};

export type Plan = {
  __typename?: 'Plan';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  floorplanUrl?: Maybe<Scalars['String']>;
  status: PlanStatus;
  app: App;
  elevations?: Maybe<Array<Maybe<Elevation>>>;
  communityAssignments?: Maybe<Array<PlanCommunityAssignment>>;
  communities?: Maybe<Array<Maybe<Community>>>;
  elevationsCount?: Maybe<Scalars['Int']>;
  editable?: Maybe<Scalars['Boolean']>;
};

/** Available plan statuses. */
export enum PlanStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Elevation = {
  __typename?: 'Elevation';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sequence?: Maybe<Scalars['Float']>;
  default?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  floorplanUrl?: Maybe<Scalars['String']>;
  e1id?: Maybe<Scalars['String']>;
  status: ElevationStatus;
  plan?: Maybe<Plan>;
};

/** Available elevation statuses. */
export enum ElevationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type DefaultPhase = {
  __typename?: 'DefaultPhase';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  videoPreviewImage?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  status: PhaseStatus;
  divisionPhases?: Maybe<Array<Phase>>;
  tips?: Maybe<Array<DefaultPhaseTip>>;
};

/** Available phase statuses. */
export enum PhaseStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type DefaultPhaseTip = {
  __typename?: 'DefaultPhaseTip';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  status: CommonStatus;
  sequence?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  defaultPhase: DefaultPhase;
  phaseTips?: Maybe<Array<PhaseTip>>;
};

/** Available statuses that are common across multiple entities. */
export enum CommonStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PhaseTip = {
  __typename?: 'PhaseTip';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  status: CommonStatus;
  sequence?: Maybe<Scalars['Int']>;
  phase: Phase;
  defaultPhaseTip?: Maybe<DefaultPhaseTip>;
};

export type Phase = {
  __typename?: 'Phase';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  videoPreviewImage?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  app?: Maybe<App>;
  tips?: Maybe<Array<PhaseTip>>;
  defaultPhaseId?: Maybe<Scalars['Int']>;
  defaultPhase?: Maybe<DefaultPhase>;
  divisionId?: Maybe<Scalars['Int']>;
  status: PhaseStatus;
  division?: Maybe<Division>;
};

export type Buyer = {
  __typename?: 'Buyer';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  relationship: Scalars['String'];
  messageIndex: Scalars['Float'];
  activated: Scalars['Boolean'];
  activationEmailSent: Scalars['Boolean'];
  allowLogin: Scalars['Boolean'];
  activationDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  appId: Scalars['Float'];
  userId: Scalars['Float'];
  lotId: Scalars['Float'];
  roleId?: Maybe<Scalars['Int']>;
  updatesLastViewedDate?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  lot?: Maybe<Lot>;
  role?: Maybe<Role>;
  fullName: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
};

export type LotGalleryImage = {
  __typename?: 'LotGalleryImage';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  fullImgSrc: Scalars['String'];
  smallImgSrc: Scalars['String'];
  mediumImgSrc: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  default: Scalars['Boolean'];
  lot: Lot;
  type: GalleryType;
  mediaType?: Maybe<Scalars['Int']>;
};

/** Lot gallery statuses. */
export enum GalleryType {
  Gallery = 'GALLERY',
  OneFourNinePhotos = 'ONE_FOUR_NINE_PHOTOS'
}

export type DocumentCommunityPhaseAssignment = {
  __typename?: 'DocumentCommunityPhaseAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  phaseId: Scalars['Int'];
  document: Document;
  community: Community;
  phase: Phase;
};

export type Category = {
  __typename?: 'Category';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type LotDocumentPhaseAssignment = {
  __typename?: 'LotDocumentPhaseAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  lotDocumentId: Scalars['Float'];
  phaseId: Scalars['Float'];
  lotDocument?: Maybe<LotDocument>;
  phase?: Maybe<Phase>;
};

export type LotDocument = DocumentInterfaceObject & {
  __typename?: 'LotDocument';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  fileSize: Scalars['Float'];
  lot?: Maybe<Lot>;
  category?: Maybe<Category>;
  phaseAssignments: Array<LotDocumentPhaseAssignment>;
  phases?: Maybe<Array<Phase>>;
  phase?: Maybe<Phase>;
  phaseId?: Maybe<Scalars['Int']>;
  status?: Maybe<LotDocumentStatus>;
};

/** Available lot document statuses. */
export enum LotDocumentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Document = DocumentInterfaceObject & {
  __typename?: 'Document';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  fileSize: Scalars['Float'];
  appId: Scalars['Float'];
  app: App;
  lotDocumentAssignments?: Maybe<Array<Maybe<LotDocumentAssignment>>>;
  communityPhaseAssignments?: Maybe<Array<Maybe<DocumentCommunityPhaseAssignment>>>;
  communities?: Maybe<Array<Maybe<Community>>>;
  phases?: Maybe<Array<Phase>>;
  status: DocumentStatus;
  editable?: Maybe<Scalars['Boolean']>;
};

/** Available document statuses. */
export enum DocumentStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type LotDocumentAssignment = {
  __typename?: 'LotDocumentAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  lotId: Scalars['Int'];
  visible?: Maybe<Scalars['Boolean']>;
};

export type Lot149PhotosGallery = {
  __typename?: 'Lot149PhotosGallery';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  apiId: Scalars['Float'];
  lotId: Scalars['Float'];
  url: Scalars['String'];
  stage: Scalars['String'];
  batchNum: Scalars['Float'];
  isExterior: Scalars['Boolean'];
  isExteriorFront: Scalars['Boolean'];
  type: Scalars['Float'];
  lot: Lot;
};

export type Lot = {
  __typename?: 'Lot';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  city: Scalars['String'];
  stateId: Scalars['Float'];
  zip: Scalars['String'];
  buyerFirstName: Scalars['String'];
  buyerLastName: Scalars['String'];
  buyerEmail: Scalars['String'];
  buyerHomePhone: Scalars['String'];
  buyerWorkPhone?: Maybe<Scalars['String']>;
  salesPrice?: Maybe<Scalars['Float']>;
  elevationId?: Maybe<Scalars['Float']>;
  planDescription?: Maybe<Scalars['String']>;
  elevationRendering?: Maybe<Scalars['String']>;
  lot149PhotosLotNum?: Maybe<Scalars['String']>;
  messageIndex: Scalars['Float'];
  status: LotStatus;
  contractDate?: Maybe<Scalars['DateTime']>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']>;
  closingDate?: Maybe<Scalars['DateTime']>;
  contractCancelledDate?: Maybe<Scalars['DateTime']>;
  app: App;
  lot149PhotosGallery?: Maybe<Array<Lot149PhotosGallery>>;
  elevation?: Maybe<Elevation>;
  state: State;
  community: Community;
  phase?: Maybe<Phase>;
  buyers?: Maybe<Array<Buyer>>;
  teamMembersAssignments?: Maybe<Array<TeamMemberLotAssignment>>;
  gallery?: Maybe<Array<LotGalleryImage>>;
  documents: Array<LotDocument>;
  documentAssignments: Array<LotDocumentAssignment>;
  lotPhases?: Maybe<Array<Phase>>;
  planName?: Maybe<Scalars['String']>;
  elevationName?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
};

/** Available lot statuses. */
export enum LotStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type TeamMemberLotAssignment = {
  __typename?: 'TeamMemberLotAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  lot: Lot;
  teamMember: TeamMember;
};

export type TeamMemberType = {
  __typename?: 'TeamMemberType';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  affiliation?: Maybe<ContactAffiliation>;
  editable: Scalars['Boolean'];
  allowUserLink: Scalars['Boolean'];
  displayToBuyer: Scalars['Boolean'];
  status: TeamMemberTypeStatus;
  appId: Scalars['Float'];
  app: App;
};

/** Available contacts affiliations. */
export enum ContactAffiliation {
  Vendor = 'VENDOR',
  Staff = 'STAFF'
}

/** Available team member type statuses. */
export enum TeamMemberTypeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Company = {
  __typename?: 'Company';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  stateId: Scalars['Float'];
  state?: Maybe<State>;
  status: CompanyStatus;
};

/** Available statuses for the company entity. */
export enum CompanyStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type TeamMember = {
  __typename?: 'TeamMember';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  isGroupContact: Scalars['Boolean'];
  groupName?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  workPhone?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  affiliation?: Maybe<ContactAffiliation>;
  companyName?: Maybe<Scalars['String']>;
  companyUrl?: Maybe<Scalars['String']>;
  allowSMS: Scalars['Boolean'];
  displayWorkPhone: Scalars['Boolean'];
  displayMobilePhone: Scalars['Boolean'];
  status: TeamMemberStatus;
  appId: Scalars['Int'];
  app: App;
  typeId?: Maybe<Scalars['Int']>;
  type?: Maybe<TeamMemberType>;
  companyId?: Maybe<Scalars['Int']>;
  company?: Maybe<Company>;
  userId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  communities?: Maybe<Array<Community>>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

/** Available team member statuses. */
export enum TeamMemberStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type TeamMemberCommunityAssignment = {
  __typename?: 'TeamMemberCommunityAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  community: Community;
  teamMember: TeamMember;
  isDefault: Scalars['Boolean'];
};

export type Community = {
  __typename?: 'Community';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  zip: Scalars['String'];
  stateId: Scalars['Float'];
  timezone?: Maybe<Scalars['String']>;
  status: CommunityStatus;
  state: State;
  app: App;
  division?: Maybe<Division>;
  teamMemberCommuniyAssignments?: Maybe<Array<TeamMemberCommunityAssignment>>;
};

/** Available communities statuses. */
export enum CommunityStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Division149photosSync = {
  __typename?: 'Division149photosSync';
  divisionId: Scalars['Int'];
  syncInProgress: Scalars['Boolean'];
  division?: Maybe<Division>;
};

export type Division = {
  __typename?: 'Division';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  city: Scalars['String'];
  address: Scalars['String'];
  zip: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  designStudioUrl?: Maybe<Scalars['String']>;
  timeZone: TimeZone;
  logo?: Maybe<Scalars['String']>;
  status: DivisionStatus;
  contactPhone?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  division149PhotosId?: Maybe<Scalars['String']>;
  division149photosSync?: Maybe<Array<Division149photosSync>>;
  contactUser?: Maybe<User>;
  app: App;
  country?: Maybe<Country>;
  state: State;
  communities?: Maybe<Array<Maybe<Community>>>;
  phases?: Maybe<Array<Maybe<Phase>>>;
};

/** Available time zones. */
export enum TimeZone {
  Pacific = 'PACIFIC',
  Mountain = 'MOUNTAIN',
  Central = 'CENTRAL',
  Eastern = 'EASTERN'
}

/** Available divisions statuses. */
export enum DivisionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  label: Scalars['String'];
  type: NotificationSettingType;
};

/** Notification settings type */
export enum NotificationSettingType {
  General = 'GENERAL',
  BuyersOnly = 'BUYERS_ONLY',
  UsersOnly = 'USERS_ONLY'
}

export type Permission = {
  __typename?: 'Permission';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  label: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
};

export type Conversation = {
  __typename?: 'Conversation';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  sid?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
  accountSid?: Maybe<Scalars['String']>;
  chatServiceSid?: Maybe<Scalars['String']>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  buyerUser?: Maybe<User>;
  teamMember?: Maybe<TeamMember>;
  lot?: Maybe<Lot>;
  app?: Maybe<App>;
  status?: Maybe<ConversationStatusEnum>;
  participants?: Maybe<Array<ConversationParticipant>>;
  lastMessageCreatedAt?: Maybe<Scalars['DateTime']>;
};

/** Conversation state statuses. */
export enum ConversationStatusEnum {
  Active = 'ACTIVE',
  Resolved = 'RESOLVED'
}

export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  conversationSid?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  identity?: Maybe<Scalars['String']>;
  app: App;
  conversation?: Maybe<Conversation>;
  conversationUser?: Maybe<ConversationUser>;
};

export type ConversationUser = {
  __typename?: 'ConversationUser';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  sid?: Maybe<Scalars['String']>;
  identity?: Maybe<Scalars['String']>;
  app?: Maybe<App>;
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  status: UserStatus;
  phone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  termsAccepted: Scalars['Boolean'];
  initialPasswordSet: Scalars['Boolean'];
  app?: Maybe<App>;
  role?: Maybe<Role>;
  notificationsSettings?: Maybe<Array<UserNotificationSetting>>;
  homepage?: Maybe<Permission>;
  divisions?: Maybe<Array<Division>>;
  communities?: Maybe<Array<Community>>;
  permissions?: Maybe<Array<Permission>>;
  teamMember?: Maybe<TeamMember>;
  buyers?: Maybe<Array<Buyer>>;
  conversations?: Maybe<Array<Conversation>>;
  conversationUser?: Maybe<ConversationUser>;
};

/** Available users statuses. */
export enum UserStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type LotAppointmentBuyer = {
  __typename?: 'LotAppointmentBuyer';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  lotAppointmentId: Scalars['Float'];
  buyerId: Scalars['Float'];
  status: LotAppointmentBuyerStatus;
  lotAppointment?: Maybe<LotAppointment>;
  buyer?: Maybe<Buyer>;
};

/** Available lot statuses. */
export enum LotAppointmentBuyerStatus {
  Pending = 'PENDING',
  Attending = 'ATTENDING',
  NotAttending = 'NOT_ATTENDING'
}

export type EventCommunityPhaseAssignment = {
  __typename?: 'EventCommunityPhaseAssignment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  event: Event;
  community?: Maybe<Community>;
  phase?: Maybe<Phase>;
};

export type Event = {
  __typename?: 'Event';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  rsvpRequired: Scalars['Boolean'];
  estimatedDuration?: Maybe<Scalars['Float']>;
  status: EventStatus;
  appId: Scalars['Float'];
  app: App;
  communityPhaseAssignments?: Maybe<Array<EventCommunityPhaseAssignment>>;
  communities?: Maybe<Array<Community>>;
  phases?: Maybe<Array<Phase>>;
  editable?: Maybe<Scalars['Boolean']>;
};

/** Available lot statuses. */
export enum EventStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type LotAppointment = {
  __typename?: 'LotAppointment';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  phaseId: Scalars['Float'];
  eventId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  rsvpRequired: Scalars['Boolean'];
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  stateId: Scalars['Float'];
  zip: Scalars['String'];
  requestReschedule: Scalars['Boolean'];
  status: LotAppointmentStatus;
  lotId: Scalars['Float'];
  lot: Lot;
  phase: Phase;
  event?: Maybe<Event>;
  state: State;
  requestedBy?: Maybe<Scalars['String']>;
  attendees?: Maybe<Array<AttendeesUnion>>;
  lotAppointmentBuyers: Array<Maybe<LotAppointmentBuyer>>;
  buyers: Array<Maybe<Buyer>>;
  lotAppointmentTeamMembers: Array<Maybe<LotAppointmentTeamMember>>;
  teamMembers: Array<Maybe<TeamMember>>;
  originalEventId?: Maybe<Scalars['Int']>;
  originalEvent?: Maybe<LotAppointment>;
  newEvent?: Maybe<LotAppointment>;
};

/** Available lot statuses. */
export enum LotAppointmentStatus {
  Pending = 'PENDING',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Held = 'HELD',
  NoShow = 'NO_SHOW',
  Rescheduled = 'RESCHEDULED'
}

export type AttendeesUnion = Buyer | TeamMember;

export type LotAppointmentTeamMember = {
  __typename?: 'LotAppointmentTeamMember';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  lotAppointmentId: Scalars['Float'];
  teamMemberId: Scalars['Float'];
  status: LotAppointmentTeamMemberStatus;
  lotAppointment?: Maybe<LotAppointment>;
  teamMember?: Maybe<TeamMember>;
};

/** Available lot statuses. */
export enum LotAppointmentTeamMemberStatus {
  Pending = 'PENDING',
  Attending = 'ATTENDING',
  NotAttending = 'NOT_ATTENDING'
}

export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  /** The amount of items on this specific page */
  itemCount: Scalars['Int'];
  /** The total amount of items */
  totalItems: Scalars['Int'];
  /** The amount of items that were requested per page */
  itemsPerPage: Scalars['Int'];
  /** The total amount of pages in this paginator */
  totalPages: Scalars['Int'];
  /** The the current page this paginator "points" to */
  currentPage: Scalars['Int'];
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<User>>;
  meta?: Maybe<PaginationMeta>;
};

export type ExportResultResponse = {
  __typename?: 'ExportResultResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  content?: Maybe<Scalars['String']>;
};

export type LotGalleryImageList = {
  __typename?: 'LotGalleryImageList';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotGallery?: Maybe<Array<Maybe<LotGalleryImage>>>;
};

export type LotGalleryImageResponse = {
  __typename?: 'LotGalleryImageResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotGalleryImage?: Maybe<LotGalleryImage>;
};

export type LotUpdate = {
  __typename?: 'LotUpdate';
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  createdBy: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  lastIP?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['Float']>;
  appId: Scalars['Float'];
  type?: Maybe<LotUpdateType>;
  app: App;
  lotId: Scalars['Float'];
  lot: Lot;
  appointment?: Maybe<LotAppointment>;
};

/** Available lot update types. */
export enum LotUpdateType {
  LotAppointment = 'LOT_APPOINTMENT',
  LotDocument = 'LOT_DOCUMENT',
  LotDocumentAssignments = 'LOT_DOCUMENT_ASSIGNMENTS',
  LotGallery = 'LOT_GALLERY',
  Lot_149PhotosGallery = 'LOT_149PHOTOS_GALLERY',
  Lot = 'LOT'
}

export type LotsList = {
  __typename?: 'LotsList';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lots?: Maybe<Array<Maybe<Lot>>>;
};

export type PaginatedLots = {
  __typename?: 'PaginatedLots';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Lot>>;
  meta?: Maybe<PaginationMeta>;
};

export type LotResponse = {
  __typename?: 'LotResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lot?: Maybe<Lot>;
};

export type PhaseNamesFromLotsResponse = {
  __typename?: 'PhaseNamesFromLotsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseNames?: Maybe<Array<Scalars['String']>>;
};

export type LotAppointmentAttendeesResponse = {
  __typename?: 'LotAppointmentAttendeesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  attendees?: Maybe<Array<AttendeesUnion>>;
};

export type PaginatedBuyers = {
  __typename?: 'PaginatedBuyers';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Buyer>>;
  meta?: Maybe<PaginationMeta>;
};

export type BuyerResponse = {
  __typename?: 'BuyerResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  buyer?: Maybe<Buyer>;
};

export type BuyersListResponse = {
  __typename?: 'BuyersListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  buyers?: Maybe<Array<Buyer>>;
};

export type ConversationsListResponse = {
  __typename?: 'ConversationsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  conversations?: Maybe<Array<Conversation>>;
};

export type PaginatedConversations = {
  __typename?: 'PaginatedConversations';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Conversation>>;
  meta?: Maybe<PaginationMeta>;
};

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  conversation?: Maybe<Conversation>;
};

export type ConversationMessageCreatedResponseObject = {
  __typename?: 'ConversationMessageCreatedResponseObject';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  conversation?: Maybe<Conversation>;
};

export type TwilioTokensResponse = {
  __typename?: 'TwilioTokensResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  accessToken?: Maybe<Scalars['String']>;
};

export type PaginatedLotDocuments = {
  __typename?: 'PaginatedLotDocuments';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<DocumentInterfaceObject>>;
  meta?: Maybe<PaginationMeta>;
};

export type LotDocumentResponse = {
  __typename?: 'LotDocumentResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotDocument?: Maybe<LotDocument>;
};

export type LotDocumentsResponse = {
  __typename?: 'LotDocumentsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotDocuments?: Maybe<Array<LotDocument>>;
};

export type LotDocumentPhaseNamesResponse = {
  __typename?: 'LotDocumentPhaseNamesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseNames?: Maybe<Array<Scalars['String']>>;
};

export type DocumentsListResponse = {
  __typename?: 'DocumentsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  documents?: Maybe<Array<DocumentInterfaceObject>>;
};

export type PaginatedTeamMembers = {
  __typename?: 'PaginatedTeamMembers';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<TeamMember>>;
  meta?: Maybe<PaginationMeta>;
};

export type TeamMemberResponse = {
  __typename?: 'TeamMemberResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMember?: Maybe<TeamMember>;
};

export type TeamMemberTypesListResponse = {
  __typename?: 'TeamMemberTypesListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberTypes?: Maybe<Array<Maybe<TeamMemberType>>>;
};

export type PaginatedTeamMemberTypes = {
  __typename?: 'PaginatedTeamMemberTypes';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<TeamMemberType>>;
  meta?: Maybe<PaginationMeta>;
};

export type TeamMemberTypesResponse = {
  __typename?: 'TeamMemberTypesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberTypes?: Maybe<Array<TeamMemberType>>;
};

export type NamesFromTeamMemberTypesResponse = {
  __typename?: 'NamesFromTeamMemberTypesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberTypeNames?: Maybe<Array<Scalars['String']>>;
};

export type CompaniesListResponse = {
  __typename?: 'CompaniesListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  companies?: Maybe<Array<Company>>;
};

export type PaginatedCompanies = {
  __typename?: 'PaginatedCompanies';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Company>>;
  meta?: Maybe<PaginationMeta>;
};

export type TeamMemberLotAssignmentsListResponse = {
  __typename?: 'TeamMemberLotAssignmentsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberLotAssignments?: Maybe<Array<TeamMemberLotAssignment>>;
};

export type LotTeamMemberIds = {
  __typename?: 'LotTeamMemberIds';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberIds?: Maybe<Array<Scalars['Int']>>;
};

export type TeamMembersNamesResponse = {
  __typename?: 'TeamMembersNamesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMembersNames?: Maybe<Array<Scalars['String']>>;
};

export type CommunityDefaultTeamMemberIds = {
  __typename?: 'CommunityDefaultTeamMemberIds';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberIds?: Maybe<Array<Scalars['Int']>>;
};

export type TeamMemberCommunityAssignmentsListResponse = {
  __typename?: 'TeamMemberCommunityAssignmentsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberCommunityAssignments?: Maybe<Array<TeamMemberCommunityAssignment>>;
};

export type LotPhotos149List = {
  __typename?: 'LotPhotos149List';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lot149PhotosGallery?: Maybe<Array<Lot149PhotosGallery>>;
};

export type DivisionsList = {
  __typename?: 'DivisionsList';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  divisions?: Maybe<Array<Maybe<Division>>>;
};

export type PaginatedDivisions = {
  __typename?: 'PaginatedDivisions';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Division>>;
  meta?: Maybe<PaginationMeta>;
};

export type DivisionResponse = {
  __typename?: 'DivisionResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  division?: Maybe<Division>;
};

export type StatesList = {
  __typename?: 'StatesList';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  states?: Maybe<Array<Maybe<State>>>;
};

export type CommunitiesList = {
  __typename?: 'CommunitiesList';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  communities?: Maybe<Array<Maybe<Community>>>;
};

export type PaginatedCommunities = {
  __typename?: 'PaginatedCommunities';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Community>>;
  meta?: Maybe<PaginationMeta>;
};

export type CommunityResponse = {
  __typename?: 'CommunityResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  community?: Maybe<Community>;
};

export type PhasesListResponse = {
  __typename?: 'PhasesListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phases?: Maybe<Array<Phase>>;
};

export type PaginatedPhases = {
  __typename?: 'PaginatedPhases';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Phase>>;
  meta?: Maybe<PaginationMeta>;
};

export type DefaultPhasesListResponse = {
  __typename?: 'DefaultPhasesListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  defaultPhases?: Maybe<Array<DefaultPhase>>;
};

export type PaginatedDefaultPhases = {
  __typename?: 'PaginatedDefaultPhases';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<DefaultPhase>>;
  meta?: Maybe<PaginationMeta>;
};

export type PhaseTipsListResponse = {
  __typename?: 'PhaseTipsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<PhaseTip>>;
};

export type PaginatedPhaseTips = {
  __typename?: 'PaginatedPhaseTips';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<PhaseTip>>;
  meta?: Maybe<PaginationMeta>;
};

export type DefaultPhaseTipsListResponse = {
  __typename?: 'DefaultPhaseTipsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<DefaultPhaseTip>>;
};

export type PaginatedDefaultPhaseTips = {
  __typename?: 'PaginatedDefaultPhaseTips';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<DefaultPhaseTip>>;
  meta?: Maybe<PaginationMeta>;
};

export type PasswordResetCreated = {
  __typename?: 'PasswordResetCreated';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
};

export type PasswordResetConfirmed = {
  __typename?: 'PasswordResetConfirmed';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
};

export type Jwt = {
  __typename?: 'Jwt';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type JwtRefreshSuccessResponse = {
  __typename?: 'JwtRefreshSuccessResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  tokens?: Maybe<Jwt>;
};

export type LoginSuccessResponse = {
  __typename?: 'LoginSuccessResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  tokens?: Maybe<Jwt>;
  user?: Maybe<User>;
};

export type CountriesList = {
  __typename?: 'CountriesList';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  countries?: Maybe<Array<Country>>;
};

export type PhaseNamesFromEventsResponse = {
  __typename?: 'PhaseNamesFromEventsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseNames?: Maybe<Array<Scalars['String']>>;
};

export type PaginatedEvents = {
  __typename?: 'PaginatedEvents';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Event>>;
  meta?: Maybe<PaginationMeta>;
};

export type EventResponse = {
  __typename?: 'EventResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  event?: Maybe<Event>;
};

export type LotUpdatesListResponseObject = {
  __typename?: 'LotUpdatesListResponseObject';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<LotUpdate>>;
  meta?: Maybe<PaginationMeta>;
};

export type PaginatedDocument = {
  __typename?: 'PaginatedDocument';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Document>>;
  meta?: Maybe<PaginationMeta>;
};

export type DocumentResponse = {
  __typename?: 'DocumentResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  document?: Maybe<Document>;
};

export type DocumentPhaseNamesResponse = {
  __typename?: 'DocumentPhaseNamesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseNames?: Maybe<Array<Scalars['String']>>;
};

export type LotUpdatesListForClientResponseObject = {
  __typename?: 'LotUpdatesListForClientResponseObject';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotUpdates?: Maybe<Array<LotUpdate>>;
};

export type PaginatedPlan = {
  __typename?: 'PaginatedPlan';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Plan>>;
  meta?: Maybe<PaginationMeta>;
};

export type PlanListResponse = {
  __typename?: 'PlanListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  plans?: Maybe<Array<Plan>>;
};

export type PlanResponse = {
  __typename?: 'PlanResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  plan?: Maybe<Plan>;
};

export type ElevationsListResponse = {
  __typename?: 'ElevationsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  elevations?: Maybe<Array<Elevation>>;
};

export type ElevationResponse = {
  __typename?: 'ElevationResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  elevation?: Maybe<Elevation>;
};

export type PaginatedElevations = {
  __typename?: 'PaginatedElevations';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<Elevation>>;
  meta?: Maybe<PaginationMeta>;
};

export type PaginatedLotAppointments = {
  __typename?: 'PaginatedLotAppointments';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  items?: Maybe<Array<LotAppointment>>;
  meta?: Maybe<PaginationMeta>;
};

export type PhaseNamesFromLotAppointmentsResponse = {
  __typename?: 'PhaseNamesFromLotAppointmentsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseNames?: Maybe<Array<Scalars['String']>>;
};

export type LotAppointmentNamesResponse = {
  __typename?: 'LotAppointmentNamesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  names?: Maybe<Array<Scalars['String']>>;
};

export type TotalHomesByConstructionPhaseItem = {
  __typename?: 'TotalHomesByConstructionPhaseItem';
  count: Scalars['Int'];
  name: Scalars['String'];
  id: Scalars['Int'];
};

export type TotalHomesByConstructionPhase = {
  __typename?: 'TotalHomesByConstructionPhase';
  items: Array<TotalHomesByConstructionPhaseItem>;
  name: Scalars['String'];
  id: Scalars['Int'];
};

export type TotalHomeownerAccounts = {
  __typename?: 'TotalHomeownerAccounts';
  totalHomes: Scalars['Int'];
  activeLogins: Scalars['Int'];
  name: Scalars['String'];
  id: Scalars['Int'];
};

export type ReportsResponse = {
  __typename?: 'ReportsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  totalHomeownerAccounts?: Maybe<Array<TotalHomeownerAccounts>>;
  totalHomesByConstructionPhase?: Maybe<Array<TotalHomesByConstructionPhase>>;
};

export type Query = {
  __typename?: 'Query';
  login: LoginSuccessResponse;
  loginWithSso: LoginSuccessResponse;
  buyerLogin: LoginSuccessResponse;
  refreshTokens: JwtRefreshSuccessResponse;
  findEventById: EventResponse;
  getEventsWithPagination: PaginatedEvents;
  getEvents: EventsListResponse;
  getPhaseNamesFromEvents: PhaseNamesFromEventsResponse;
  fetchEventsCount: EventsCountResponse;
  getLotPhotos149List: LotPhotos149List;
  getTeamMemberAssignedToLotForClient: TeamMemberAssignedToLotForClientResponse;
  getTeamMemberAssignedToLotForCMS: TeamMemberAssignedToLotForCmsResponse;
  fetchProfile: UserResponse;
  findUsers: PaginatedUser;
  findUserById: UserResponse;
  validateUserCommunityAssignments: UsersCommunityAssignemntsResponse;
  fetchUsersCount: UsersCountResponse;
  findUsersForContactAutocomplete: UsersResponse;
  findNotificationsSettings: NotificationsSettingsResponse;
  findPages: PagesResponse;
  findLots: LotsList;
  getLots: PaginatedLots;
  findLotById: LotResponse;
  fetchLotsCount: LotsCountResponse;
  findLotAttendees: LotAppointmentAttendeesResponse;
  getPhaseNamesFromLots: PhaseNamesFromLotsResponse;
  getHomesByCommunityId: LotsList;
  findLotsForClientApp: LotsList;
  findLotByIdForClientApp: LotResponse;
  getLotGalleryImages: LotGalleryImageList;
  getTwilioToken: TwilioTokensResponse;
  getTwilioTokenForConversation: TwilioTokensResponse;
  findConversationById: ConversationResponse;
  findConversations: ConversationsListResponse;
  findConversationsPaginated: PaginatedConversations;
  getConversationsCount: ConversationsCountResponse;
  getConversationsForClientApp: ConversationsListResponse;
  findConversationByLotId: ConversationResponse;
  findLotDocumentsByLotId: DocumentsListResponse;
  findLotDocumentsPaginated: PaginatedLotDocuments;
  findLotDocumentById: LotDocumentResponse;
  getLotDocumentsCount: LotDocumentsCountResponse;
  getPhaseNamesFromLotDocuments: LotDocumentPhaseNamesResponse;
  getLotDocumentsForAutocomplete: LotDocumentsUnionResponse;
  getBuyersForClientApp: BuyersListResponse;
  findBuyerByIdForClientApp: BuyerResponse;
  getBuyers: BuyersListResponse;
  getBuyersWithPagination: PaginatedBuyers;
  getBuyerById: BuyerResponse;
  findTeamMembers: PaginatedTeamMembers;
  findTeamMembersForAutocomplete: PaginatedTeamMembers;
  getTeamMemberById: TeamMemberResponse;
  fetchTeamMembersCount: TeamMembersCountResponse;
  getTeamMemberTypes: TeamMemberTypesListResponse;
  findTeamMemberTypes: PaginatedTeamMemberTypes;
  findAllTeamMemberTypes: TeamMemberTypesResponse;
  getNamesFromTeamMemberTypes: NamesFromTeamMemberTypesResponse;
  fetchTeamMemberTypesCount: TeamMemberTypesCountResponse;
  getTeamMemberTypeById: TeamMemberTypeResponse;
  findCompanies: CompaniesListResponse;
  fetchCompaniesCount: CompaniesCountResponse;
  findCompaniesPaginated: PaginatedCompanies;
  getCompanyById: CompanyResponse;
  findCommunityTeamMembersForLot: PaginatedTeamMembers;
  getCommunityTeamMembersNamesForLot: TeamMembersNamesResponse;
  getLotTeamMembersIds: LotTeamMemberIds;
  findCommunityTeamMembers: PaginatedTeamMembers;
  getCommunityDefaultTeamMembersIds: CommunityDefaultTeamMemberIds;
  findPermissions: PermissionsResponse;
  getDefaultPhases: DefaultPhasesListResponse;
  getDefaultPhasesWithPagination: PaginatedDefaultPhases;
  getDefaultPhaseById: DefaultPhaseResponseObject;
  fetchDefaultPhasesCount: DefaultPhasesCountResponse;
  getPhases: PhasesListResponse;
  getPhaseNames: PhasesListResponse;
  getPhasesWithPagination: PaginatedPhases;
  getPhaseById: PhaseResponse;
  fetchPhasesCount: PhasesCountResponse;
  findDefaultPhaseTips: DefaultPhaseTipsListResponse;
  getDefaultPhaseTipsPaginated: PaginatedDefaultPhaseTips;
  getDefaultPhaseTipById: DefaultPhaseTipResponse;
  fetchDefaultPhaseTipsCount: DefaultPhaseTipsCountResponse;
  getPhaseTips: PhaseTipsListResponse;
  getPhaseTipsWithPagination: PaginatedPhaseTips;
  getPhaseTipById: PhaseTipResponse;
  fetchPhaseTipsCount: PhaseTipsCountResponse;
  getReports: ReportsResponse;
  findRoles: RolesResponse;
  getDivisions: PaginatedDivisions;
  findDivisions: DivisionsList;
  findDivisionsWithHomes: DivisionsList;
  findDivisionsWithPhases: DivisionsList;
  findDivisionById: DivisionResponse;
  fetchDivisionsCount: DivisionsCountResponse;
  getDivisionStates: StatesList;
  findCommunities: CommunitiesList;
  getCommunities: PaginatedCommunities;
  getCommunitiesByDivisionId: CommunitiesList;
  findCommunityById: CommunityResponse;
  fetchCommunitiesCount: CommunitiesCountResponse;
  getCommunityStates: StatesList;
  getStates: StatesList;
  getCountries: CountriesList;
  getPlansWithPagination: PaginatedPlan;
  getPlans: PlanListResponse;
  getPlansCount: PlansCountResponse;
  findPlanById: PlanResponse;
  findElevations: ElevationsListResponse;
  findElevationsPaginated: PaginatedElevations;
  findElevation: ElevationResponse;
  fetchElevationsCount: ElevationsCountResponse;
  getDocumentsWithPagination: PaginatedDocument;
  getDocumentsCount: DocumentsCountResponse;
  getDocuments: DocumentsListResponse;
  getPhaseNamesFromDocuments: DocumentPhaseNamesResponse;
  getDocument: DocumentResponse;
  getLotUpdates: LotUpdatesListResponseObject;
  getLotUpdatesForClient: LotUpdatesListForClientResponseObject;
  findLotAppointmentsWithPagination: PaginatedLotAppointments;
  findLotAppointmentById: LotAppointmentResponse;
  findLotAppointmentsAttendees: LotAppointmentAttendeesResponse;
  getPhaseNamesFromLotAppointments: PhaseNamesFromLotAppointmentsResponse;
  getLotAppointmentNamesForAutocomplete: LotAppointmentNamesResponse;
  getEventsForLotAppointmentAutocomplete: EventsListResponse;
  getLotAppointmentsForClient: LotAppointmentsForClientResponse;
  getLotAppointmentByIdForClient: LotAppointmentByIdForClientResponse;
};

export type QueryLoginArgs = {
  loginInput: LoginInput;
};

export type QueryLoginWithSsoArgs = {
  loginWithSsoInput: LoginWithSsoInput;
};

export type QueryBuyerLoginArgs = {
  loginInput: LoginInput;
};

export type QueryRefreshTokensArgs = {
  refreshToken: Scalars['String'];
};

export type QueryFindEventByIdArgs = {
  id: Scalars['Int'];
};

export type QueryGetEventsWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
  appId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetEventsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
  appId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhaseNamesFromEventsArgs = {
  appId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetLotPhotos149ListArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetTeamMemberAssignedToLotForClientArgs = {
  id: Scalars['Int'];
};

export type QueryGetTeamMemberAssignedToLotForCmsArgs = {
  id: Scalars['Int'];
};

export type QueryFindUsersArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedUsersSortFields>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  rolesIds?: Maybe<Array<Scalars['Int']>>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  ignoreUserRole?: Maybe<Scalars['Boolean']>;
  includeSelf?: Maybe<Scalars['Boolean']>;
};

export type QueryFindUserByIdArgs = {
  id: Scalars['Int'];
};

export type QueryValidateUserCommunityAssignmentsArgs = {
  divisionId: Scalars['Int'];
};

export type QueryFetchUsersCountArgs = {
  ignoreUserRole?: Maybe<Scalars['Boolean']>;
  includeSelf?: Maybe<Scalars['Boolean']>;
};

export type QueryFindUsersForContactAutocompleteArgs = {
  action?: Maybe<DivisionAction>;
  divisionId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  withoutContacts?: Maybe<Scalars['Boolean']>;
};

export type QueryFindNotificationsSettingsArgs = {
  type?: Maybe<NotificationSettingType>;
};

export type QueryFindLotsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedLotsSortFields>;
  appId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Float']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  planId?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  phasesNames?: Maybe<Array<Scalars['String']>>;
  contractDateFrom?: Maybe<Scalars['DateTime']>;
  contractDateTo?: Maybe<Scalars['DateTime']>;
  lastLoginDateFrom?: Maybe<Scalars['DateTime']>;
  lastLoginDateTo?: Maybe<Scalars['DateTime']>;
  contractCancelledDateFrom?: Maybe<Scalars['DateTime']>;
  contractCancelledDateTo?: Maybe<Scalars['DateTime']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetLotsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedLotsSortFields>;
  appId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Float']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  planId?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  phasesNames?: Maybe<Array<Scalars['String']>>;
  contractDateFrom?: Maybe<Scalars['DateTime']>;
  contractDateTo?: Maybe<Scalars['DateTime']>;
  lastLoginDateFrom?: Maybe<Scalars['DateTime']>;
  lastLoginDateTo?: Maybe<Scalars['DateTime']>;
  contractCancelledDateFrom?: Maybe<Scalars['DateTime']>;
  contractCancelledDateTo?: Maybe<Scalars['DateTime']>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindLotByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindLotAttendeesArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetPhaseNamesFromLotsArgs = {
  appId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Float']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  planId?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  phasesNames?: Maybe<Array<Scalars['String']>>;
  contractDateFrom?: Maybe<Scalars['DateTime']>;
  contractDateTo?: Maybe<Scalars['DateTime']>;
  lastLoginDateFrom?: Maybe<Scalars['DateTime']>;
  lastLoginDateTo?: Maybe<Scalars['DateTime']>;
  contractCancelledDateFrom?: Maybe<Scalars['DateTime']>;
  contractCancelledDateTo?: Maybe<Scalars['DateTime']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetHomesByCommunityIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindLotByIdForClientAppArgs = {
  id: Scalars['Int'];
};

export type QueryGetLotGalleryImagesArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetTwilioTokenForConversationArgs = {
  conversationId: Scalars['Int'];
};

export type QueryFindConversationByIdArgs = {
  conversationId: Scalars['Int'];
};

export type QueryFindConversationsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<ConversationsSortFields>;
  buyerName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindConversationsPaginatedArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<ConversationsSortFields>;
  buyerName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetConversationsForClientAppArgs = {
  lotId: Scalars['Int'];
};

export type QueryFindConversationByLotIdArgs = {
  lotId: Scalars['Int'];
};

export type QueryFindLotDocumentsByLotIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindLotDocumentsPaginatedArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotDocumentsSortTypes>;
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindLotDocumentByIdArgs = {
  lotDocumentId: Scalars['Int'];
};

export type QueryGetLotDocumentsCountArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetPhaseNamesFromLotDocumentsArgs = {
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetLotDocumentsForAutocompleteArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotDocumentsSortTypes>;
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetBuyersForClientAppArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedBuyersSortFields>;
  lotId: Scalars['Int'];
};

export type QueryFindBuyerByIdForClientAppArgs = {
  buyerId: Scalars['Int'];
};

export type QueryGetBuyersArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedBuyersSortFields>;
  lotId: Scalars['Int'];
};

export type QueryGetBuyersWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedBuyersSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  lotId: Scalars['Int'];
};

export type QueryGetBuyerByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindTeamMembersArgs = {
  appId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  contactTypesIds?: Maybe<Array<Scalars['Int']>>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  communityId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  teamMembersIds?: Maybe<Array<Scalars['Int']>>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindTeamMembersForAutocompleteArgs = {
  appId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  contactTypesIds?: Maybe<Array<Scalars['Int']>>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  communityId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  teamMembersIds?: Maybe<Array<Scalars['Int']>>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetTeamMemberByIdArgs = {
  id: Scalars['Int'];
};

export type QueryGetTeamMemberTypesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
  typesIds?: Maybe<Array<Scalars['Int']>>;
  typesNames?: Maybe<Array<Scalars['String']>>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindTeamMemberTypesArgs = {
  typesIds?: Maybe<Array<Scalars['Int']>>;
  typesNames?: Maybe<Array<Scalars['String']>>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindAllTeamMemberTypesArgs = {
  typesIds?: Maybe<Array<Scalars['Int']>>;
  typesNames?: Maybe<Array<Scalars['String']>>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetNamesFromTeamMemberTypesArgs = {
  typesIds?: Maybe<Array<Scalars['Int']>>;
  typesNames?: Maybe<Array<Scalars['String']>>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetTeamMemberTypeByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindCompaniesArgs = {
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindCompaniesPaginatedArgs = {
  stateIds?: Maybe<Array<Scalars['Int']>>;
  names?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<CompanySortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetCompanyByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindCommunityTeamMembersForLotArgs = {
  getAll?: Maybe<Scalars['Boolean']>;
  communityId: Scalars['Int'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetCommunityTeamMembersNamesForLotArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetLotTeamMembersIdsArgs = {
  lotId: Scalars['Int'];
};

export type QueryFindCommunityTeamMembersArgs = {
  getAll?: Maybe<Scalars['Boolean']>;
  communityId: Scalars['Int'];
  contactTypesIds?: Maybe<Array<Scalars['Int']>>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetCommunityDefaultTeamMembersIdsArgs = {
  communityId: Scalars['Int'];
};

export type QueryGetDefaultPhasesArgs = {
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetDefaultPhasesWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhasesSortFields>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetDefaultPhaseByIdArgs = {
  defaultPhaseId: Scalars['Int'];
};

export type QueryGetPhasesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhasesSortFields>;
  divisionId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  withEventsAssigned?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhaseNamesArgs = {
  divisionId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  withEventsAssigned?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhasesWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhasesSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  divisionId: Scalars['Int'];
  withEventsAssigned?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhaseByIdArgs = {
  phaseId: Scalars['Int'];
};

export type QueryFetchPhasesCountArgs = {
  divisionId?: Maybe<Scalars['Int']>;
};

export type QueryFindDefaultPhaseTipsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DefaultPhaseTipsSortFields>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  defaultPhaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetDefaultPhaseTipsPaginatedArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DefaultPhaseTipsSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  defaultPhaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetDefaultPhaseTipByIdArgs = {
  defaultPhaseTipId: Scalars['Int'];
};

export type QueryFetchDefaultPhaseTipsCountArgs = {
  defaultPhaseId: Scalars['Int'];
};

export type QueryGetPhaseTipsArgs = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhaseTipsWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhaseTipsSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhaseTipByIdArgs = {
  phaseTipId: Scalars['Int'];
};

export type QueryFetchPhaseTipsCountArgs = {
  phaseId: Scalars['Int'];
};

export type QueryGetReportsArgs = {
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  date?: Maybe<Scalars['String']>;
};

export type QueryGetDivisionsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
  phone?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  divisionId?: Maybe<Scalars['Int']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindDivisionsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
  phone?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  divisionId?: Maybe<Scalars['Int']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindDivisionsWithPhasesArgs = {
  defaultPhaseId: Scalars['Int'];
};

export type QueryFindDivisionByIdArgs = {
  id: Scalars['Int'];
};

export type QueryGetDivisionStatesArgs = {
  phone?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  divisionId?: Maybe<Scalars['Int']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindCommunitiesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
  divisionId?: Maybe<Scalars['Float']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  ignoreUserRole?: Maybe<Scalars['Boolean']>;
};

export type QueryGetCommunitiesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
  divisionId?: Maybe<Scalars['Float']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetCommunitiesByDivisionIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindCommunityByIdArgs = {
  id: Scalars['Int'];
};

export type QueryGetCommunityStatesArgs = {
  divisionId?: Maybe<Scalars['Float']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPlansWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPlansSortFields>;
  name?: Maybe<Scalars['String']>;
  hasElevations?: Maybe<Scalars['Boolean']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetPlansArgs = {
  name?: Maybe<Scalars['String']>;
  hasElevations?: Maybe<Scalars['Boolean']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindPlanByIdArgs = {
  planId: Scalars['Int'];
};

export type QueryFindElevationsArgs = {
  planId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryFindElevationsPaginatedArgs = {
  planId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindElevationArgs = {
  elevationId: Scalars['Int'];
};

export type QueryFetchElevationsCountArgs = {
  planId: Scalars['Int'];
};

export type QueryGetDocumentsWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DocumentsSortingFields>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryGetDocumentsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DocumentsSortingFields>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetPhaseNamesFromDocumentsArgs = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type QueryGetDocumentArgs = {
  documentId: Scalars['Int'];
};

export type QueryGetLotUpdatesArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  lotId: Scalars['Int'];
};

export type QueryGetLotUpdatesForClientArgs = {
  lotId: Scalars['Int'];
};

export type QueryFindLotAppointmentsWithPaginationArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotAppointmentsSortFields>;
  lotId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  buyersIds?: Maybe<Array<Scalars['Int']>>;
  statuses?: Maybe<Array<LotAppointmentStatus>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  attendees?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type QueryFindLotAppointmentByIdArgs = {
  lotAppointmentId: Scalars['Int'];
};

export type QueryFindLotAppointmentsAttendeesArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetPhaseNamesFromLotAppointmentsArgs = {
  lotId: Scalars['Int'];
};

export type QueryGetLotAppointmentNamesForAutocompleteArgs = {
  lotId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  buyersIds?: Maybe<Array<Scalars['Int']>>;
  statuses?: Maybe<Array<LotAppointmentStatus>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  attendees?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Scalars['Int']>;
};

export type QueryGetEventsForLotAppointmentAutocompleteArgs = {
  archived?: Maybe<Scalars['Boolean']>;
  phaseId?: Maybe<Scalars['Int']>;
  lotId: Scalars['Int'];
  name: Scalars['String'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
};

export type QueryGetLotAppointmentsForClientArgs = {
  lotId: Scalars['Int'];
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
};

export type QueryGetLotAppointmentByIdForClientArgs = {
  id: Scalars['Int'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginWithSsoInput = {
  code: Scalars['String'];
  code_verifier: Scalars['String'];
  redirect_uri: Scalars['String'];
};

/** Allowed sort orders */
export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

/** Event list sort by fields */
export enum EventListSortByField {
  Name = 'name',
  Description = 'description'
}

export type EventsListResponse = {
  __typename?: 'EventsListResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  events?: Maybe<Array<Maybe<Event>>>;
};

export type EventsCountResponse = {
  __typename?: 'EventsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  eventsCount: EventsCount;
};

export type EventsCount = {
  __typename?: 'EventsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

export type TeamMemberAssignedToLotForClientResponse = {
  __typename?: 'TeamMemberAssignedToLotForClientResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMembers?: Maybe<Array<TeamMember>>;
};

export type TeamMemberAssignedToLotForCmsResponse = {
  __typename?: 'TeamMemberAssignedToLotForCMSResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMembers?: Maybe<Array<TeamMember>>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  user?: Maybe<User>;
};

/** Allowed users list sort fields */
export enum AllowedUsersSortFields {
  Name = 'name',
  Email = 'email',
  Phone = 'phone',
  JobTitle = 'jobTitle',
  Division = 'division',
  Role = 'role'
}

export type UsersCommunityAssignemntsResponse = {
  __typename?: 'UsersCommunityAssignemntsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  hasAtLeastOneUserWithAllCommunityAssignments?: Maybe<Scalars['Boolean']>;
};

export type UsersCountResponse = {
  __typename?: 'UsersCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  usersCount: UsersCount;
};

export type UsersCount = {
  __typename?: 'UsersCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  users?: Maybe<Array<User>>;
};

/** Available actions for division. */
export enum DivisionAction {
  Create = 'CREATE',
  Update = 'UPDATE'
}

export type NotificationsSettingsResponse = {
  __typename?: 'NotificationsSettingsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  notificationsSettings?: Maybe<Array<NotificationSetting>>;
};

export type PagesResponse = {
  __typename?: 'PagesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  pages?: Maybe<Array<Scalars['String']>>;
};

/** Allowed lots sort fields */
export enum AllowedLotsSortFields {
  Division = 'division',
  Community = 'community',
  Address = 'address',
  City = 'city',
  State = 'state',
  Homesite = 'homesite',
  Plan = 'plan',
  ContractDate = 'contractDate',
  Phase = 'phase',
  LastLoginDate = 'lastLoginDate',
  ContractCancelledDate = 'contractCancelledDate'
}

export type LotsCountResponse = {
  __typename?: 'LotsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotsCount: LotsCount;
};

export type LotsCount = {
  __typename?: 'LotsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Conversations sort fields */
export enum ConversationsSortFields {
  DivisionName = 'divisionName',
  CommunityName = 'communityName',
  Address = 'address',
  ContactName = 'contactName',
  BuyerName = 'buyerName',
  UpdatedAt = 'updatedAt'
}

export type ConversationsCountResponse = {
  __typename?: 'ConversationsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  conversationsCount: ConversationsCount;
};

export type ConversationsCount = {
  __typename?: 'ConversationsCount';
  active: Scalars['Int'];
  resolved: Scalars['Int'];
};

/** Lot documents sortable fields */
export enum LotDocumentsSortTypes {
  Name = 'name',
  Description = 'description',
  FileSize = 'fileSize'
}

export type LotDocumentsCountResponse = {
  __typename?: 'LotDocumentsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotDocumentsCount: LotDocumentsCount;
};

export type LotDocumentsCount = {
  __typename?: 'LotDocumentsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

export type LotDocumentsUnionResponse = {
  __typename?: 'LotDocumentsUnionResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotDocuments?: Maybe<Array<Maybe<DocumentInterfaceObject>>>;
};

/** Allowed buyers sort fields */
export enum AllowedBuyersSortFields {
  Name = 'name',
  Type = 'type',
  Email = 'email',
  Phone = 'phone',
  Status = 'status',
  LastLoginDate = 'lastLoginDate'
}

/** Allowed team member sort fields */
export enum TeamMembersSortFields {
  Name = 'name',
  Email = 'email',
  MobilePhone = 'mobilePhone',
  JobTitle = 'jobTitle',
  ContactType = 'contactType',
  Company = 'company',
  CompanyType = 'companyType',
  Division = 'division',
  Community = 'community'
}

export type TeamMembersCountResponse = {
  __typename?: 'TeamMembersCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMembersCount: TeamMembersCount;
};

export type TeamMembersCount = {
  __typename?: 'TeamMembersCount';
  active?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Int']>;
};

/** Allowed team member types sort fields */
export enum TeamMemberTypesSortFields {
  Name = 'name',
  CompanyType = 'companyType',
  Description = 'description'
}

export type TeamMemberTypesCountResponse = {
  __typename?: 'TeamMemberTypesCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberTypesCount: TeamMemberTypesCount;
};

export type TeamMemberTypesCount = {
  __typename?: 'TeamMemberTypesCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

export type TeamMemberTypeResponse = {
  __typename?: 'TeamMemberTypeResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  teamMemberType?: Maybe<TeamMemberType>;
};

export type CompaniesCountResponse = {
  __typename?: 'CompaniesCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  companiesCount: CompaniesCount;
};

export type CompaniesCount = {
  __typename?: 'CompaniesCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Allowed company sort fields */
export enum CompanySortFields {
  Name = 'name',
  State = 'state'
}

export type CompanyResponse = {
  __typename?: 'CompanyResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  company?: Maybe<Company>;
};

export type PermissionsResponse = {
  __typename?: 'PermissionsResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  permissions?: Maybe<Array<Permission>>;
};

/** Allowed phases sort fields */
export enum AllowedPhasesSortFields {
  Name = 'name',
  Description = 'description',
  IsVideo = 'isVideo'
}

export type DefaultPhaseResponseObject = {
  __typename?: 'DefaultPhaseResponseObject';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  defaultPhase?: Maybe<DefaultPhase>;
};

export type DefaultPhasesCountResponse = {
  __typename?: 'DefaultPhasesCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  defaultPhasesCount: DefaultPhasesCount;
};

export type DefaultPhasesCount = {
  __typename?: 'DefaultPhasesCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

export type PhaseResponse = {
  __typename?: 'PhaseResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phase?: Maybe<Phase>;
};

export type PhasesCountResponse = {
  __typename?: 'PhasesCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phasesCount: PhasesCount;
};

export type PhasesCount = {
  __typename?: 'PhasesCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Default phase tips sort fields */
export enum DefaultPhaseTipsSortFields {
  Name = 'name',
  Description = 'description'
}

export type DefaultPhaseTipResponse = {
  __typename?: 'DefaultPhaseTipResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  defaultPhaseTip?: Maybe<DefaultPhaseTip>;
};

export type DefaultPhaseTipsCountResponse = {
  __typename?: 'DefaultPhaseTipsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  stats: PhaseTipsCount;
};

export type PhaseTipsCount = {
  __typename?: 'PhaseTipsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Allowed phase tips sort fields */
export enum AllowedPhaseTipsSortFields {
  Name = 'name',
  Description = 'description'
}

export type PhaseTipResponse = {
  __typename?: 'PhaseTipResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseTip?: Maybe<PhaseTip>;
};

export type PhaseTipsCountResponse = {
  __typename?: 'PhaseTipsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  phaseTipsCount: PhaseTipsCount;
};

export type RolesResponse = {
  __typename?: 'RolesResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  roles?: Maybe<Array<Role>>;
};

/** Allowed divisions sort fields */
export enum AllowedDivisionsSortFields {
  Name = 'name',
  City = 'city',
  State = 'state',
  Phone = 'phone'
}

export type DivisionsCountResponse = {
  __typename?: 'DivisionsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  divisionsCount: DivisionsCount;
};

export type DivisionsCount = {
  __typename?: 'DivisionsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Allowed communities sort fields */
export enum AllowedCommunitiesSortFields {
  Name = 'name',
  Division = 'division',
  City = 'city',
  State = 'state'
}

export type CommunitiesCountResponse = {
  __typename?: 'CommunitiesCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  communitiesCount: CommunitiesCount;
};

export type CommunitiesCount = {
  __typename?: 'CommunitiesCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Allowed plan sort fields */
export enum AllowedPlansSortFields {
  Name = 'name',
  ElevationsCount = 'elevationsCount'
}

export type PlansCountResponse = {
  __typename?: 'PlansCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  plansCount: PlansCount;
};

export type PlansCount = {
  __typename?: 'PlansCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

export type ElevationsCountResponse = {
  __typename?: 'ElevationsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  elevationsCount: ElevationsCount;
};

export type ElevationsCount = {
  __typename?: 'ElevationsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Allowed documents sorting fields */
export enum DocumentsSortingFields {
  Name = 'name',
  Description = 'description',
  FileSize = 'fileSize'
}

export type DocumentsCountResponse = {
  __typename?: 'DocumentsCountResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  documentsCount: DocumentsCount;
};

export type DocumentsCount = {
  __typename?: 'DocumentsCount';
  active: Scalars['Int'];
  archived: Scalars['Int'];
};

/** Allowed LotAppointments sorting fields */
export enum LotAppointmentsSortFields {
  Date = 'date',
  Time = 'time',
  Name = 'name',
  Description = 'description',
  Phase = 'phase',
  Status = 'status',
  Attendees = 'attendees'
}

export type LotAppointmentResponse = {
  __typename?: 'LotAppointmentResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotAppointment?: Maybe<LotAppointment>;
};

export type LotAppointmentsForClientResponse = {
  __typename?: 'LotAppointmentsForClientResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotAppointments?: Maybe<Array<LotAppointment>>;
};

export type LotAppointmentByIdForClientResponse = {
  __typename?: 'LotAppointmentByIdForClientResponse';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
  lotAppointment?: Maybe<LotAppointment>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createPasswordResetRequest: PasswordResetCreated;
  confirmPasswordResetRequest: PasswordResetConfirmed;
  createEvent: EventResponse;
  updateEvent: EventResponse;
  archiveEvent: EventResponse;
  deleteEvent: EventResponse;
  exportEvents: ExportResultResponse;
  updateProfile: UserResponse;
  changePassword: UserResponse;
  createUser: UserResponse;
  updateUser: UserResponse;
  archiveUser: UserResponse;
  deleteUser: UserResponse;
  sendWelcomeEmail: UserResponse;
  exportUsers: ExportResultResponse;
  createLot: LotResponse;
  updateLot: LotResponse;
  archiveLot: LotResponse;
  deleteLot: LotResponse;
  exportLots: ExportResultResponse;
  changeDocumentVisibility: ServerResponseObject;
  createLotGalleryImages: LotGalleryImageList;
  removeLotGalleryImages: LotGalleryImageList;
  updateLotGalleryOrder: LotGalleryImageList;
  createLotGalleryImageForClientApp: LotGalleryImageResponse;
  removeLotGalleryImagesForClientApp: LotGalleryImageList;
  removeConversation: ConversationResponse;
  exportConversations: ExportResultResponse;
  sendConversationMessageForCMSApp: ConversationMessageCreatedResponseObject;
  sendConversationMessageForClientApp: ConversationMessageCreatedResponseObject;
  createLotDocuments: LotDocumentsResponse;
  updateLotDocument: LotDocumentResponse;
  deleteLotDocument: LotDocumentResponse;
  archiveLotDocument: LotDocumentResponse;
  exportLotDocuments: ExportResultResponse;
  setUpdatesLastViewedDate: BuyerResponse;
  createBuyerForClientApp: BuyerResponse;
  deleteBuyerForClientApp: BuyerResponse;
  createBuyer: BuyerResponse;
  updateBuyer: BuyerResponse;
  deleteBuyer: BuyerResponse;
  sendActivationEmail: BuyerResponse;
  exportBuyers: ExportResultResponse;
  createTeamMember: TeamMemberResponse;
  updateTeamMember: TeamMemberResponse;
  deleteTeamMember: TeamMemberResponse;
  archiveTeamMember: TeamMemberResponse;
  exportTeamMembers: ExportResultResponse;
  createTeamMemberType: TeamMemberTypeResponse;
  updateTeamMemberType: TeamMemberTypeResponse;
  archiveTeamMemberType: TeamMemberTypeResponse;
  deleteTeamMemberType: TeamMemberTypeResponse;
  createCompany: CompanyResponse;
  updateCompany: CompanyResponse;
  deleteCompany: CompanyResponse;
  archiveCompany: CompanyResponse;
  updateLotTeamMembers: TeamMemberLotAssignmentsListResponse;
  exportLotTeamMembers: ExportResultResponse;
  createGroupContact: TeamMemberResponse;
  updateGroupContact: TeamMemberResponse;
  updateContactProfile: TeamMemberResponse;
  updateCommunityTeamMembers: TeamMemberCommunityAssignmentsListResponse;
  updateCommunityLotTeamMembers: TeamMemberLotAssignmentsListResponse;
  exportCommunityTeamMembers: ExportResultResponse;
  createDefaultPhase: DefaultPhaseResponseObject;
  updateDefaultPhase: DefaultPhaseResponseObject;
  updateDefaultPhasesOrder: DefaultPhasesListResponse;
  deleteDefaultPhase: DefaultPhaseResponseObject;
  archiveDefaultPhase: DefaultPhaseResponseObject;
  exportDefaultPhases: ExportResultResponse;
  createPhase: PhaseResponse;
  updatePhase: PhaseResponse;
  updatePhasesOrder: PhasesListResponse;
  deletePhase: PhaseResponse;
  archivePhase: PhaseResponse;
  exportPhases: ExportResultResponse;
  createDefaultPhaseTip: DefaultPhaseTipResponse;
  updateDefaultPhaseTip: DefaultPhaseTipResponse;
  deleteDefaultPhaseTip: DefaultPhaseTipResponse;
  archiveDefaultPhaseTip: DefaultPhaseTipResponse;
  updateDefaultPhaseTipsOrder: DefaultPhaseTipsListResponse;
  exportDefaultPhaseTips: ExportResultResponse;
  createPhaseTip: PhaseTipResponse;
  updatePhaseTip: PhaseTipResponse;
  updatePhaseTipsOrder: PhaseTipsListResponse;
  deletePhaseTip: PhaseTipResponse;
  archivePhaseTip: PhaseTipResponse;
  exportPhaseTips: ExportResultResponse;
  exportReports: ExportResultResponse;
  createDivision: DivisionResponse;
  updateDivision: DivisionResponse;
  deleteDivision: DivisionResponse;
  archiveDivision: DivisionResponse;
  exportDivisions: ExportResultResponse;
  sync149PhotosWithRemote: ServerResponseObject;
  createCommunity: CommunityResponse;
  updateCommunity: CommunityResponse;
  archiveCommunity: CommunityResponse;
  deleteCommunity: CommunityResponse;
  exportCommunities: ExportResultResponse;
  createPlan: PlanResponse;
  updatePlan: PlanResponse;
  deletePlan: PlanResponse;
  archivePlan: PlanResponse;
  exportPlans: ExportResultResponse;
  createElevations: ElevationsListResponse;
  updateElevation: ElevationResponse;
  updateElevationsOrder: ElevationsListResponse;
  removeElevations: ElevationsListResponse;
  archiveElevation: ElevationResponse;
  exportElevations: ExportResultResponse;
  createDocument: DocumentResponse;
  updateDocument: DocumentResponse;
  deleteDocument: DocumentResponse;
  archiveDocument: DocumentResponse;
  exportDocuments: ExportResultResponse;
  exportLotUpdates: ExportResultResponse;
  createLotAppointment: LotAppointmentResponse;
  updateLotAppointment: LotAppointmentResponse;
  rescheduleLotAppointmentFromCMS: LotAppointmentResponse;
  deleteLotAppointment: LotAppointmentResponse;
  exportLotAppointments: ExportResultResponse;
  rescheduleLotAppointment: ServerResponseObject;
  confirmBuyerRSVP: ServerResponseObject;
  exportLotAppointment: ExportResultResponse;
  exportCompanies: ExportResultResponse;
  exportTeamMemberTypes: ExportResultResponse;
};

export type MutationCreatePasswordResetRequestArgs = {
  client?: Maybe<Scalars['Boolean']>;
  createPasswordResetInput: CreatePasswordResetInput;
};

export type MutationConfirmPasswordResetRequestArgs = {
  confirmPasswordResetInput: ConfirmPasswordResetInput;
};

export type MutationCreateEventArgs = {
  createEventInput: CreateEventInput;
};

export type MutationUpdateEventArgs = {
  updateEventInput: UpdateEventInput;
  id: Scalars['Int'];
};

export type MutationArchiveEventArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationDeleteEventArgs = {
  id: Scalars['Int'];
};

export type MutationExportEventsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
  appId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: EventsExportTypes;
};

export type MutationUpdateProfileArgs = {
  setPasswordInput?: Maybe<SetPasswordInput>;
  updateProfileInput?: Maybe<UpdateProfileInput>;
};

export type MutationChangePasswordArgs = {
  setPasswordInput?: Maybe<SetPasswordInput>;
};

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type MutationUpdateUserArgs = {
  setPasswordInput?: Maybe<SetPasswordInput>;
  updateUserInput?: Maybe<UpdateUserInput>;
  id: Scalars['Int'];
};

export type MutationArchiveUserArgs = {
  reassignTeamMembers?: Maybe<Scalars['Boolean']>;
  targetUserId?: Maybe<Scalars['Int']>;
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationDeleteUserArgs = {
  reassignTeamMembers?: Maybe<Scalars['Boolean']>;
  targetUserId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};

export type MutationSendWelcomeEmailArgs = {
  id: Scalars['Int'];
};

export type MutationExportUsersArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedUsersSortFields>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  rolesIds?: Maybe<Array<Scalars['Int']>>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: UsersExportTypes;
};

export type MutationCreateLotArgs = {
  createLotInput: CreateLotInput;
};

export type MutationUpdateLotArgs = {
  updateLotInput: UpdateLotInput;
  id: Scalars['Int'];
};

export type MutationArchiveLotArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationDeleteLotArgs = {
  id: Scalars['Int'];
};

export type MutationExportLotsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedLotsSortFields>;
  appId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Float']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  planId?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  phasesNames?: Maybe<Array<Scalars['String']>>;
  contractDateFrom?: Maybe<Scalars['DateTime']>;
  contractDateTo?: Maybe<Scalars['DateTime']>;
  lastLoginDateFrom?: Maybe<Scalars['DateTime']>;
  lastLoginDateTo?: Maybe<Scalars['DateTime']>;
  contractCancelledDateFrom?: Maybe<Scalars['DateTime']>;
  contractCancelledDateTo?: Maybe<Scalars['DateTime']>;
  archived?: Maybe<Scalars['Boolean']>;
  requestUserTimezone: Scalars['String'];
  exportType: LotsExportTypes;
};

export type MutationChangeDocumentVisibilityArgs = {
  documentId: Scalars['Int'];
  lotId: Scalars['Int'];
};

export type MutationCreateLotGalleryImagesArgs = {
  createLotGalleryImagesInput: Array<CreateLotGalleryImageInput>;
  lotId: Scalars['Int'];
};

export type MutationRemoveLotGalleryImagesArgs = {
  lotPhotosIds: Array<Scalars['Int']>;
};

export type MutationUpdateLotGalleryOrderArgs = {
  lotGalleryIds: Array<Scalars['Int']>;
  lotId: Scalars['Int'];
};

export type MutationCreateLotGalleryImageForClientAppArgs = {
  createLotGalleryImageInput: CreateLotGalleryImageInput;
  lotId: Scalars['Int'];
};

export type MutationRemoveLotGalleryImagesForClientAppArgs = {
  lotPhotosIds: Array<Scalars['Int']>;
};

export type MutationRemoveConversationArgs = {
  conversationId?: Maybe<Scalars['Int']>;
};

export type MutationExportConversationsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<ConversationsSortFields>;
  buyerName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: ConversationExportType;
};

export type MutationSendConversationMessageForCmsAppArgs = {
  createConversationMessageInput: CreateConversationMessageInput;
  lotId: Scalars['Int'];
  buyerId: Scalars['Int'];
};

export type MutationSendConversationMessageForClientAppArgs = {
  createConversationMessageInput: CreateConversationMessageInput;
  lotId: Scalars['Int'];
  teamMemberId: Scalars['Int'];
};

export type MutationCreateLotDocumentsArgs = {
  createLotDocumentsInputs: Array<CreateLotDocumentInput>;
  lotId: Scalars['Int'];
};

export type MutationUpdateLotDocumentArgs = {
  updateLotDocumentInput: UpdateLotDocumentInput;
  lotDocumentId: Scalars['Int'];
};

export type MutationDeleteLotDocumentArgs = {
  lotDocumentId: Scalars['Int'];
};

export type MutationArchiveLotDocumentArgs = {
  archive: Scalars['Boolean'];
  lotDocumentId: Scalars['Int'];
};

export type MutationExportLotDocumentsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotDocumentsSortTypes>;
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: LotDocumentsExportTypes;
};

export type MutationSetUpdatesLastViewedDateArgs = {
  lotId: Scalars['Int'];
};

export type MutationCreateBuyerForClientAppArgs = {
  createBuyerForClientAppInput: CreateBuyerForClientAppInput;
  lotId: Scalars['Int'];
};

export type MutationDeleteBuyerForClientAppArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  buyerId: Scalars['Int'];
};

export type MutationCreateBuyerArgs = {
  updateBuyerInput: UpdateBuyerInput;
  lotId: Scalars['Int'];
};

export type MutationUpdateBuyerArgs = {
  updateBuyerInput: UpdateBuyerInput;
  buyerId: Scalars['Int'];
};

export type MutationDeleteBuyerArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type MutationSendActivationEmailArgs = {
  generateNewPassword?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type MutationExportBuyersArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedBuyersSortFields>;
  buyerId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  requestUserTimezone: Scalars['String'];
  exportType: BuyersExportTypes;
};

export type MutationCreateTeamMemberArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  createVendorTeamMemberInput?: Maybe<CreateVendorTeamMemberInput>;
  createStaffTeamMemberInput?: Maybe<CreateStaffTeamMemberInput>;
  affiliation: ContactAffiliation;
};

export type MutationUpdateTeamMemberArgs = {
  updateVendorTeamMemberInput?: Maybe<UpdateVendorTeamMemberInput>;
  updateStaffTeamMemberInput?: Maybe<UpdateStaffTeamMemberInput>;
  skipCheck?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type MutationDeleteTeamMemberArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type MutationArchiveTeamMemberArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationExportTeamMembersArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  appId?: Maybe<Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  contactTypesIds?: Maybe<Array<Scalars['Int']>>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  communityId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  teamMembersIds?: Maybe<Array<Scalars['Int']>>;
  exportType: TeamMembersExportTypes;
};

export type MutationCreateTeamMemberTypeArgs = {
  createTeamMemberTypeInput: CreateTeamMemberTypeInput;
};

export type MutationUpdateTeamMemberTypeArgs = {
  id: Scalars['Int'];
  updateTeamMemberTypeInput: UpdateTeamMemberTypeInput;
};

export type MutationArchiveTeamMemberTypeArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationDeleteTeamMemberTypeArgs = {
  id: Scalars['Int'];
};

export type MutationCreateCompanyArgs = {
  createCompanyInput: CreateCompanyInput;
};

export type MutationUpdateCompanyArgs = {
  id: Scalars['Int'];
  updateCompanyInput: UpdateCompanyInput;
};

export type MutationDeleteCompanyArgs = {
  id: Scalars['Int'];
};

export type MutationArchiveCompanyArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationUpdateLotTeamMembersArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  updateLotTeamMembersInput: UpdateLotTeamMembersInput;
  lotId: Scalars['Int'];
};

export type MutationExportLotTeamMembersArgs = {
  lotId: Scalars['Int'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  exportType: TeamMembersExportTypes;
};

export type MutationCreateGroupContactArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  createGroupContactInput: CreateGroupContactInput;
};

export type MutationUpdateGroupContactArgs = {
  updateGroupContactInput: UpdateGroupContactInput;
  skipCheck?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type MutationUpdateContactProfileArgs = {
  updateContactProfileInput: UpdateGroupContactProfileInput;
};

export type MutationUpdateCommunityTeamMembersArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  updateCommunityTeamMembersInput: UpdateCommunityTeamMembersInput;
  id: Scalars['Int'];
};

export type MutationUpdateCommunityLotTeamMembersArgs = {
  skipCheck?: Maybe<Scalars['Boolean']>;
  communityId: Scalars['Int'];
};

export type MutationExportCommunityTeamMembersArgs = {
  communityId: Scalars['Int'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  exportType: TeamMembersExportTypes;
};

export type MutationCreateDefaultPhaseArgs = {
  createDefaultPhaseInput: CreateDefaultPhaseInput;
};

export type MutationUpdateDefaultPhaseArgs = {
  updateDivisionPhases?: Maybe<Scalars['Boolean']>;
  updateDefaultPhaseInput: UpdateDefaultPhaseInput;
  defaultPhaseId: Scalars['Int'];
};

export type MutationUpdateDefaultPhasesOrderArgs = {
  defaultPhaseIds: Array<Scalars['Int']>;
};

export type MutationDeleteDefaultPhaseArgs = {
  deleteDivisionPhases?: Maybe<Scalars['Boolean']>;
  defaultPhaseId: Scalars['Int'];
};

export type MutationArchiveDefaultPhaseArgs = {
  archiveDivisionPhases?: Maybe<Scalars['Boolean']>;
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationExportDefaultPhasesArgs = {
  archived?: Maybe<Scalars['Boolean']>;
  exportType: PhasesExportTypes;
};

export type MutationCreatePhaseArgs = {
  createPhaseInput: CreatePhaseInput;
};

export type MutationUpdatePhaseArgs = {
  updatePhaseInput: UpdatePhaseInput;
  phaseId: Scalars['Int'];
};

export type MutationUpdatePhasesOrderArgs = {
  phaseIds: Array<Scalars['Int']>;
  divisionId: Scalars['Int'];
};

export type MutationDeletePhaseArgs = {
  phaseId: Scalars['Int'];
};

export type MutationArchivePhaseArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationExportPhasesArgs = {
  divisionId?: Maybe<Scalars['Int']>;
  lotId?: Maybe<Scalars['Int']>;
  withEventsAssigned?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: PhasesExportTypes;
};

export type MutationCreateDefaultPhaseTipArgs = {
  createDefaultPhaseTipInput: CreateDefaultPhaseTipInput;
};

export type MutationUpdateDefaultPhaseTipArgs = {
  updateDivisionPhasesTips?: Maybe<Scalars['Boolean']>;
  updateDefaultPhaseTipInput: UpdateDefaultPhaseTipInput;
  defaultPhaseTipId: Scalars['Int'];
};

export type MutationDeleteDefaultPhaseTipArgs = {
  deleteRelatedPhaseTips?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type MutationArchiveDefaultPhaseTipArgs = {
  archiveRelatedPhaseTips?: Maybe<Scalars['Boolean']>;
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationUpdateDefaultPhaseTipsOrderArgs = {
  defaultPhaseTipIds: Array<Scalars['Int']>;
  defaultPhaseId: Scalars['Int'];
};

export type MutationExportDefaultPhaseTipsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DefaultPhaseTipsSortFields>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  defaultPhaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  exportType: DefaultPhaseTipsExportTypes;
};

export type MutationCreatePhaseTipArgs = {
  createPhaseTipInput: CreatePhaseTipInput;
};

export type MutationUpdatePhaseTipArgs = {
  updatePhaseInput: UpdatePhaseInput;
  phaseTipId: Scalars['Int'];
};

export type MutationUpdatePhaseTipsOrderArgs = {
  phaseTipIds: Array<Scalars['Int']>;
  phaseId: Scalars['Int'];
};

export type MutationDeletePhaseTipArgs = {
  id: Scalars['Int'];
};

export type MutationArchivePhaseTipArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationExportPhaseTipsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhaseTipsSortFields>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  phaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  exportType: PhaseTipsExportTypes;
};

export type MutationExportReportsArgs = {
  charts?: Maybe<Array<ReportChartInput>>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  date?: Maybe<Scalars['String']>;
  exportType: ReportsExportTypes;
};

export type MutationCreateDivisionArgs = {
  createDivisionInput: CreateDivisionInput;
};

export type MutationUpdateDivisionArgs = {
  updateDivisionInput: UpdateDivisionInput;
  id: Scalars['Int'];
};

export type MutationDeleteDivisionArgs = {
  id: Scalars['Int'];
};

export type MutationArchiveDivisionArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationExportDivisionsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
  phone?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['Int']>;
  divisionId?: Maybe<Scalars['Int']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: DivisionsExportTypes;
};

export type MutationSync149PhotosWithRemoteArgs = {
  divisionId: Scalars['Int'];
};

export type MutationCreateCommunityArgs = {
  allowUpsertAssignment: Scalars['Boolean'];
  createCommunityInput: CreateCommunityInput;
};

export type MutationUpdateCommunityArgs = {
  updateCommunityInput: UpdateCommunityInput;
  id: Scalars['Int'];
};

export type MutationArchiveCommunityArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type MutationDeleteCommunityArgs = {
  id: Scalars['Int'];
};

export type MutationExportCommunitiesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
  divisionId?: Maybe<Scalars['Float']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: CommunitiesExportTypes;
};

export type MutationCreatePlanArgs = {
  createPlanInput: CreatePlanInput;
};

export type MutationUpdatePlanArgs = {
  updatePlanInput: UpdatePlanInput;
  planId: Scalars['Int'];
};

export type MutationDeletePlanArgs = {
  planId: Scalars['Int'];
};

export type MutationArchivePlanArgs = {
  archive: Scalars['Boolean'];
  planId: Scalars['Int'];
};

export type MutationExportPlansArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPlansSortFields>;
  name?: Maybe<Scalars['String']>;
  hasElevations?: Maybe<Scalars['Boolean']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityId?: Maybe<Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: PlansExportTypes;
};

export type MutationCreateElevationsArgs = {
  createElevationInput: Array<CreateElevationInput>;
  planId: Scalars['Int'];
};

export type MutationUpdateElevationArgs = {
  updateElevationInput: UpdateElevationInput;
  elevationId: Scalars['Int'];
};

export type MutationUpdateElevationsOrderArgs = {
  elevationsIds: Array<Scalars['Int']>;
  planId: Scalars['Int'];
};

export type MutationRemoveElevationsArgs = {
  elevationsIds: Array<Scalars['Int']>;
};

export type MutationArchiveElevationArgs = {
  archive: Scalars['Boolean'];
  elevationId: Scalars['Int'];
};

export type MutationExportElevationsArgs = {
  planId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  exportType: ElevationsExportTypes;
};

export type MutationCreateDocumentArgs = {
  createDocumentInput: CreateDocumentInput;
};

export type MutationUpdateDocumentArgs = {
  updateDocumentInput: UpdateDocumentInput;
  documentId: Scalars['Int'];
};

export type MutationDeleteDocumentArgs = {
  documentId: Scalars['Int'];
};

export type MutationArchiveDocumentArgs = {
  archive: Scalars['Boolean'];
  documentId: Scalars['Int'];
};

export type MutationExportDocumentsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DocumentsSortingFields>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']>>;
  communityIds?: Maybe<Array<Scalars['Int']>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: DocumentsExportTypes;
};

export type MutationExportLotUpdatesArgs = {
  exportType: LotUpdatesExportTypes;
  lotId: Scalars['Int'];
};

export type MutationCreateLotAppointmentArgs = {
  createLotAppointmentInput: CreateLotAppointmentInput;
};

export type MutationUpdateLotAppointmentArgs = {
  updateLotAppointmentInput: UpdateLotAppointmentInput;
  lotAppointmentId: Scalars['Int'];
};

export type MutationRescheduleLotAppointmentFromCmsArgs = {
  rescheduleLotAppointmentInput: RescheduleLotAppointmentInput;
  lotAppointmentId: Scalars['Int'];
};

export type MutationDeleteLotAppointmentArgs = {
  lotAppointmentId: Scalars['Int'];
};

export type MutationExportLotAppointmentsArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotAppointmentsSortFields>;
  lotId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  buyersIds?: Maybe<Array<Scalars['Int']>>;
  statuses?: Maybe<Array<LotAppointmentStatus>>;
  phaseNames?: Maybe<Array<Scalars['String']>>;
  attendees?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Scalars['Int']>;
  exportType: LotAppointmentsExportTypes;
};

export type MutationRescheduleLotAppointmentArgs = {
  id: Scalars['Int'];
};

export type MutationConfirmBuyerRsvpArgs = {
  lotAppointmentId: Scalars['Int'];
  attending: Scalars['Boolean'];
};

export type MutationExportLotAppointmentArgs = {
  lotAppointmentId: Scalars['Int'];
  exportType: LotAppointmentsExportTypes;
};

export type MutationExportCompaniesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<CompanySortFields>;
  stateIds?: Maybe<Array<Scalars['Int']>>;
  names?: Maybe<Array<Scalars['String']>>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: CompanyExportTypes;
};

export type MutationExportTeamMemberTypesArgs = {
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
  typesIds?: Maybe<Array<Scalars['Int']>>;
  typesNames?: Maybe<Array<Scalars['String']>>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: TeamMemberTypesExportTypes;
};

export type CreatePasswordResetInput = {
  email: Scalars['String'];
};

export type ConfirmPasswordResetInput = {
  resetCode: Scalars['String'];
  password: Scalars['String'];
};

export type CreateEventInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  rsvpRequired: Scalars['Boolean'];
  estimatedDuration?: Maybe<Scalars['Int']>;
  communityPhaseAssignments: Array<CommunityPhaseAssignmentInput>;
};

export type CommunityPhaseAssignmentInput = {
  communityId: Scalars['Int'];
  phaseId: Scalars['Int'];
};

export type UpdateEventInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  rsvpRequired?: Maybe<Scalars['Boolean']>;
  estimatedDuration?: Maybe<Scalars['Int']>;
  communityPhaseAssignments?: Maybe<Array<CommunityPhaseAssignmentInput>>;
};

/** Allowed events export types. */
export enum EventsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type SetPasswordInput = {
  currentPassword?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  passwordConfirmation?: Maybe<Scalars['String']>;
};

export type UpdateProfileInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
  homepageId?: Maybe<Scalars['Float']>;
  termsAccepted?: Maybe<Scalars['Boolean']>;
};

export type NotificationSettingInput = {
  name: Scalars['String'];
  email: Scalars['Boolean'];
  text: Scalars['Boolean'];
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roleId: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  permissionsIds?: Maybe<Array<Scalars['Int']>>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
};

export type UpdateUserInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  permissionsIds?: Maybe<Array<Scalars['Int']>>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
};

/** Allowed users export types. */
export enum UsersExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateLotInput = {
  homesite?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  city: Scalars['String'];
  zip: Scalars['String'];
  buyerFirstName: Scalars['String'];
  buyerLastName: Scalars['String'];
  buyerEmail: Scalars['String'];
  buyerHomePhone: Scalars['String'];
  coBuyerFirstName?: Maybe<Scalars['String']>;
  coBuyerLastName?: Maybe<Scalars['String']>;
  contractDate: Scalars['DateTime'];
  elevationRendering?: Maybe<Scalars['String']>;
  stateId: Scalars['Int'];
  communityId: Scalars['Int'];
  elevationId: Scalars['Int'];
  phaseId: Scalars['Int'];
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']>;
  closingDate?: Maybe<Scalars['DateTime']>;
};

export type UpdateLotInput = {
  homesite?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  buyerFirstName?: Maybe<Scalars['String']>;
  buyerLastName?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerHomePhone?: Maybe<Scalars['String']>;
  coBuyerFirstName?: Maybe<Scalars['String']>;
  coBuyerLastName?: Maybe<Scalars['String']>;
  contractDate?: Maybe<Scalars['DateTime']>;
  elevationRendering?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
  communityId?: Maybe<Scalars['Int']>;
  elevationId?: Maybe<Scalars['Int']>;
  phaseId?: Maybe<Scalars['Int']>;
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']>;
  closingDate?: Maybe<Scalars['DateTime']>;
};

/** Allowed lots export types. */
export enum LotsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type ServerResponseObject = {
  __typename?: 'ServerResponseObject';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  statusCode: Scalars['Int'];
};

export type CreateLotGalleryImageInput = {
  smallImgSrc: Scalars['String'];
  fullImgSrc: Scalars['String'];
  mediumImgSrc: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
};

/** Conversations export types */
export enum ConversationExportType {
  Pdf = 'pdf',
  Xls = 'xls'
}

export type CreateConversationMessageInput = {
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Scalars['String']>>;
};

export type CreateLotDocumentInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  fileUrl: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  phasesIds: Array<Scalars['Int']>;
  categoryId?: Maybe<Scalars['Int']>;
};

export type UpdateLotDocumentInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  phasesIds?: Maybe<Array<Scalars['Int']>>;
  categoryId?: Maybe<Scalars['Int']>;
};

/** Allowed lot documents export types. */
export enum LotDocumentsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateBuyerForClientAppInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  relationship: Scalars['String'];
};

export type UpdateBuyerInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  activated?: Maybe<Scalars['Boolean']>;
  activationDate?: Maybe<Scalars['DateTime']>;
  activationEmailSent?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
};

/** Allowed buyers export types. */
export enum BuyersExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateVendorTeamMemberInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  title: Scalars['String'];
  mobilePhone: Scalars['String'];
  workPhone: Scalars['String'];
  displayMobilePhone?: Maybe<Scalars['Boolean']>;
  typeId: Scalars['Int'];
  description: Scalars['String'];
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  avatar?: Maybe<Scalars['String']>;
  isGroupContact: Scalars['Boolean'];
  groupName?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  companyId?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  companyStateId?: Maybe<Scalars['Int']>;
};

export type CreateStaffTeamMemberInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  title: Scalars['String'];
  mobilePhone: Scalars['String'];
  workPhone: Scalars['String'];
  displayMobilePhone?: Maybe<Scalars['Boolean']>;
  typeId: Scalars['Int'];
  description: Scalars['String'];
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  avatar?: Maybe<Scalars['String']>;
  isGroupContact: Scalars['Boolean'];
  groupName?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Scalars['Int']>;
};

export type UpdateVendorTeamMemberInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  displayMobilePhone?: Maybe<Scalars['Boolean']>;
  typeId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  avatar?: Maybe<Scalars['String']>;
  isGroupContact?: Maybe<Scalars['Boolean']>;
  groupName?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  companyId?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  companyStateId?: Maybe<Scalars['Int']>;
};

export type UpdateStaffTeamMemberInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  displayMobilePhone?: Maybe<Scalars['Boolean']>;
  typeId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  avatar?: Maybe<Scalars['String']>;
  isGroupContact?: Maybe<Scalars['Boolean']>;
  groupName?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  userId?: Maybe<Scalars['Int']>;
};

/** Allowed team members export types. */
export enum TeamMembersExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateTeamMemberTypeInput = {
  label: Scalars['String'];
  affiliation: ContactAffiliation;
  description: Scalars['String'];
};

export type UpdateTeamMemberTypeInput = {
  label: Scalars['String'];
  affiliation: ContactAffiliation;
  description: Scalars['String'];
};

export type CreateCompanyInput = {
  name: Scalars['String'];
  stateId: Scalars['Int'];
};

export type UpdateCompanyInput = {
  name: Scalars['String'];
  stateId: Scalars['Int'];
};

export type UpdateLotTeamMembersInput = {
  teamMembersIds: Array<Scalars['Int']>;
};

export type CreateGroupContactInput = {
  email: Scalars['String'];
  groupName: Scalars['String'];
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
  typeId: Scalars['Int'];
  description: Scalars['String'];
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  avatar?: Maybe<Scalars['String']>;
};

export type UpdateGroupContactInput = {
  email?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  communitiesIds?: Maybe<Array<Scalars['Int']>>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
  typeId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  avatar?: Maybe<Scalars['String']>;
};

export type UpdateGroupContactProfileInput = {
  email?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  notificationsSettings?: Maybe<Array<NotificationSettingInput>>;
  description?: Maybe<Scalars['String']>;
  groupMembersNames?: Maybe<Array<Scalars['String']>>;
  avatar?: Maybe<Scalars['String']>;
  homepageId?: Maybe<Scalars['Float']>;
};

export type UpdateCommunityTeamMembersInput = {
  defaultTeamMembersIds: Array<Scalars['Int']>;
};

export type CreateDefaultPhaseInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  videoPreviewImage?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateDefaultPhaseInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  videoPreviewImage?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
};

/** Allowed phases export types. */
export enum PhasesExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreatePhaseInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  videoPreviewImage?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  divisionId: Scalars['Int'];
};

export type UpdatePhaseInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  videoPreviewImage?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['Int']>;
};

export type CreateDefaultPhaseTipInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  defaultPhaseId: Scalars['Int'];
  divisionsIds?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateDefaultPhaseTipInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** Default phase tips export types. */
export enum DefaultPhaseTipsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreatePhaseTipInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  phaseId: Scalars['Int'];
};

/** Allowed phase tips export types. */
export enum PhaseTipsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type ReportChartInput = {
  title?: Maybe<Scalars['String']>;
  img?: Maybe<Scalars['String']>;
  legends?: Maybe<Array<ReportChartLegendInput>>;
};

export type ReportChartLegendInput = {
  color?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

/** Allowed reports export types. */
export enum ReportsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateDivisionInput = {
  name: Scalars['String'];
  url: Scalars['String'];
  designStudioUrl: Scalars['String'];
  city: Scalars['String'];
  address: Scalars['String'];
  zip: Scalars['String'];
  phone: Scalars['String'];
  division149PhotosId?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactUserId?: Maybe<Scalars['Int']>;
  contactUser?: Maybe<CreateBaseUserInput>;
  stateId: Scalars['Int'];
  countryId: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  defaultPhaseIds?: Maybe<Array<Scalars['Int']>>;
  timeZone: TimeZone;
};

export type CreateBaseUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  workPhone?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
};

export type UpdateDivisionInput = {
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  designStudioUrl?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  division149PhotosId?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactUserId?: Maybe<Scalars['Int']>;
  contactUser?: Maybe<CreateBaseUserInput>;
  stateId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  defaultPhaseIds?: Maybe<Array<Scalars['Int']>>;
  timeZone: TimeZone;
};

/** Allowed divisions export types. */
export enum DivisionsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateCommunityInput = {
  name: Scalars['String'];
  city: Scalars['String'];
  address: Scalars['String'];
  zip: Scalars['String'];
  stateId: Scalars['Int'];
  divisionId: Scalars['Int'];
};

export type UpdateCommunityInput = {
  name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
  divisionId?: Maybe<Scalars['Int']>;
};

/** Allowed communities export types. */
export enum CommunitiesExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreatePlanInput = {
  name: Scalars['String'];
  communityIds?: Maybe<Array<Scalars['Int']>>;
};

export type UpdatePlanInput = {
  name: Scalars['String'];
  communityIds?: Maybe<Array<Scalars['Int']>>;
};

/** Allowed plans export types. */
export enum PlansExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateElevationInput = {
  /** Elevation name */
  name: Scalars['String'];
  /** Image URL */
  imageUrl: Scalars['String'];
  floorplanUrl?: Maybe<Scalars['String']>;
};

export type UpdateElevationInput = {
  /** Elevation name */
  name?: Maybe<Scalars['String']>;
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']>;
  floorplanUrl?: Maybe<Scalars['String']>;
};

/** Allowed elevations export types. */
export enum ElevationsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateDocumentInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  fileUrl: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  communityPhaseAssignments: Array<CommunityPhaseAssignmentInput>;
};

export type UpdateDocumentInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  communityPhaseAssignments?: Maybe<Array<CommunityPhaseAssignmentInput>>;
};

/** Allowed documents export types. */
export enum DocumentsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

/** Allowed lot updates export types. */
export enum LotUpdatesExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type CreateLotAppointmentInput = {
  lotId: Scalars['Int'];
  phaseId: Scalars['Int'];
  stateId: Scalars['Int'];
  eventId?: Maybe<Scalars['Int']>;
  buyersIds: Array<Scalars['Int']>;
  teamMembersIds: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  city: Scalars['String'];
  zip: Scalars['String'];
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  rsvpRequired: Scalars['Boolean'];
  requestedBy: Scalars['String'];
};

export type UpdateLotAppointmentInput = {
  phaseId?: Maybe<Scalars['Int']>;
  stateId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  buyersIds?: Maybe<Array<Scalars['Int']>>;
  teamMembersIds?: Maybe<Array<Scalars['Int']>>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  city?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  rsvpRequired?: Maybe<Scalars['Boolean']>;
  status?: Maybe<LotAppointmentStatus>;
};

export type RescheduleLotAppointmentInput = {
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};

/** Allowed lot appointments export types. */
export enum LotAppointmentsExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

/** Allowed company export types. */
export enum CompanyExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

/** Allowed team member types export types. */
export enum TeamMemberTypesExportTypes {
  Xls = 'xls',
  Pdf = 'pdf'
}

export type LoginQueryVariables = Exact<{
  loginInput: LoginInput;
}>;

export type LoginQuery = { __typename?: 'Query' } & {
  login: { __typename?: 'LoginSuccessResponse' } & Pick<
    LoginSuccessResponse,
    'error' | 'success' | 'statusCode'
  > & {
    user?: Maybe<
      { __typename?: 'User' } & {
        permissions?: Maybe<Array<{ __typename?: 'Permission' } & Pick<Permission, 'name'>>>;
        homepage?: Maybe<{ __typename?: 'Permission' } & Pick<Permission, 'name'>>;
      }
    >;
    tokens?: Maybe<{ __typename?: 'Jwt' } & Pick<Jwt, 'accessToken' | 'refreshToken'>>;
  };
};

export type LoginWithSsoQueryVariables = Exact<{
  loginWithSsoInput: LoginWithSsoInput;
}>;

export type LoginWithSsoQuery = { __typename?: 'Query' } & {
  loginWithSso: { __typename?: 'LoginSuccessResponse' } & Pick<
    LoginSuccessResponse,
    'error' | 'success' | 'statusCode'
  > & {
    user?: Maybe<
      { __typename?: 'User' } & {
        permissions?: Maybe<Array<{ __typename?: 'Permission' } & Pick<Permission, 'name'>>>;
        homepage?: Maybe<{ __typename?: 'Permission' } & Pick<Permission, 'name'>>;
      }
    >;
    tokens?: Maybe<{ __typename?: 'Jwt' } & Pick<Jwt, 'accessToken' | 'refreshToken'>>;
  };
};

export type RefreshTokensQueryVariables = Exact<{
  refreshToken: Scalars['String'];
}>;

export type RefreshTokensQuery = { __typename?: 'Query' } & {
  refreshTokens: { __typename?: 'JwtRefreshSuccessResponse' } & Pick<
    JwtRefreshSuccessResponse,
    'error' | 'success' | 'statusCode'
  > & { tokens?: Maybe<{ __typename?: 'Jwt' } & Pick<Jwt, 'accessToken' | 'refreshToken'>> };
};

export type ConfirmPasswordResetRequestMutationVariables = Exact<{
  confirmPasswordResetInput: ConfirmPasswordResetInput;
}>;

export type ConfirmPasswordResetRequestMutation = { __typename?: 'Mutation' } & {
  confirmPasswordResetRequest: { __typename?: 'PasswordResetConfirmed' } & Pick<
    PasswordResetConfirmed,
    'success' | 'error' | 'statusCode' | 'message'
  >;
};

export type CreatePasswordResetRequestMutationVariables = Exact<{
  createPasswordResetRequest: CreatePasswordResetInput;
}>;

export type CreatePasswordResetRequestMutation = { __typename?: 'Mutation' } & {
  createPasswordResetRequest: { __typename?: 'PasswordResetCreated' } & Pick<
    PasswordResetCreated,
    'success' | 'error' | 'statusCode' | 'message'
  >;
};

export type FindConversationsPaginatedQueryVariables = Exact<{
  order?: Maybe<SortOrder>;
  archived?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<ConversationsSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  buyerName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;

export type FindConversationsPaginatedQuery = { __typename?: 'Query' } & {
  findConversationsPaginated: { __typename?: 'PaginatedConversations' } & Pick<
    PaginatedConversations,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'Conversation' } & Pick<Conversation, 'id' | 'lastMessageCreatedAt'> & {
          buyerUser?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'fullName'>>;
          lot?: Maybe<
            { __typename?: 'Lot' } & Pick<Lot, 'address'> & {
              community: { __typename?: 'Community' } & Pick<Community, 'id' | 'name'> & {
                division?: Maybe<
                  { __typename?: 'Division' } & Pick<Division, 'id' | 'name'>
                >;
              };
            }
          >;
          teamMember?: Maybe<
            { __typename?: 'TeamMember' } & Pick<TeamMember, 'groupName'> & {
              user?: Maybe<
                { __typename?: 'User' } & Pick<User, 'id'> & {
                  role?: Maybe<{ __typename?: 'Role' } & Pick<Role, 'label'>>;
                }
              >;
            }
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetConversationsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetConversationsCountQuery = { __typename?: 'Query' } & {
  getConversationsCount: { __typename?: 'ConversationsCountResponse' } & Pick<
    ConversationsCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'ConversationsCount' } & Pick<ConversationsCount, 'active'> & {
      archived: ConversationsCount['resolved'];
    };
  };
};

export type FindConversationsQueryVariables = Exact<{
  buyerName?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<ConversationsSortFields>;
}>;

export type FindConversationsQuery = { __typename?: 'Query' } & {
  findConversations: { __typename?: 'ConversationsListResponse' } & Pick<
    ConversationsListResponse,
    'error'
  > & {
    conversations?: Maybe<
      Array<
        { __typename?: 'Conversation' } & {
          lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'address'>>;
          teamMember?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'groupName'>>;
          buyerUser?: Maybe<{ __typename?: 'User' } & Pick<User, 'fullName'>>;
        }
      >
    >;
  };
};

export type FindConversationByIdQueryVariables = Exact<{
  conversationId: Scalars['Int'];
}>;

export type FindConversationByIdQuery = { __typename?: 'Query' } & {
  findConversationById: { __typename?: 'ConversationResponse' } & Pick<
    ConversationResponse,
    'error'
  > & {
    conversation?: Maybe<
      { __typename?: 'Conversation' } & Pick<Conversation, 'id' | 'sid' | 'status'> & {
        teamMember?: Maybe<
          { __typename?: 'TeamMember' } & {
            user?: Maybe<
              { __typename?: 'User' } & Pick<User, 'id'> & {
                conversationUser?: Maybe<
                  { __typename?: 'ConversationUser' } & Pick<ConversationUser, 'identity'>
                >;
              }
            >;
          }
        >;
        buyerUser?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'fullName'>>;
      }
    >;
  };
};

export type RemoveConversationMutationVariables = Exact<{
  conversationId?: Maybe<Scalars['Int']>;
}>;

export type RemoveConversationMutation = { __typename?: 'Mutation' } & {
  removeConversation: { __typename?: 'ConversationResponse' } & Pick<
    ConversationResponse,
    'error'
  > & {
    conversation?: Maybe<
      { __typename?: 'Conversation' } & {
        buyerUser?: Maybe<{ __typename?: 'User' } & Pick<User, 'fullName'>>;
      }
    >;
  };
};

export type ExportConversationsMutationVariables = Exact<{
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  buyerName?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<ConversationsSortFields>;
  exportType: ConversationExportType;
}>;

export type ExportConversationsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type SendConversationMessageForCmsAppMutationVariables = Exact<{
  createConversationMessageInput: CreateConversationMessageInput;
  lotId: Scalars['Int'];
  buyerId: Scalars['Int'];
}>;

export type SendConversationMessageForCmsAppMutation = { __typename?: 'Mutation' } & {
  sendConversationMessageForCMSApp: {
    __typename?: 'ConversationMessageCreatedResponseObject';
  } & Pick<ConversationMessageCreatedResponseObject, 'error' | 'success' | 'statusCode'> & {
    conversation?: Maybe<{ __typename?: 'Conversation' } & Pick<Conversation, 'id' | 'sid'>>;
  };
};

export type GetChatTokenForConversationQueryVariables = Exact<{
  conversationId: Scalars['Int'];
}>;

export type GetChatTokenForConversationQuery = { __typename?: 'Query' } & {
  getChatTokenForConversation: { __typename?: 'TwilioTokensResponse' } & Pick<
    TwilioTokensResponse,
    'error' | 'accessToken'
  >;
};

export type FindCommunitiesQueryVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
}>;

export type FindCommunitiesQuery = { __typename?: 'Query' } & {
  findCommunities: { __typename?: 'CommunitiesList' } & Pick<CommunitiesList, 'error'> & {
    communities?: Maybe<
      Array<Maybe<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name'>>>
    >;
  };
};

export type GetCommunitiesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetCommunitiesQuery = { __typename?: 'Query' } & {
  getCommunities: { __typename?: 'PaginatedCommunities' } & Pick<PaginatedCommunities, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'Community' } & Pick<Community, 'id' | 'name' | 'city'> & {
          division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
          state: { __typename?: 'State' } & Pick<State, 'id' | 'label'>;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type SearchCommunitiesForAutoCompleteQueryVariables = Exact<{
  city?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
}>;

export type SearchCommunitiesForAutoCompleteQuery = { __typename?: 'Query' } & {
  getCommunities: { __typename?: 'PaginatedCommunities' } & Pick<PaginatedCommunities, 'error'> & {
    items?: Maybe<Array<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name' | 'city'>>>;
  };
};

export type GetCommunityDefaultTeamMembersIdsQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetCommunityDefaultTeamMembersIdsQuery = { __typename?: 'Query' } & {
  getCommunityDefaultTeamMembersIds: { __typename?: 'CommunityDefaultTeamMemberIds' } & Pick<
    CommunityDefaultTeamMemberIds,
    'error' | 'success' | 'teamMemberIds'
  >;
};

export type FindCommunityTeamMembersQueryVariables = Exact<{
  communityId: Scalars['Int'];
  contactTypesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  getAll?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type FindCommunityTeamMembersQuery = { __typename?: 'Query' } & {
  findCommunityTeamMembers: { __typename?: 'PaginatedTeamMembers' } & Pick<
    PaginatedTeamMembers,
    'error' | 'success'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMember' } & Pick<
          TeamMember,
          'id' | 'fullName' | 'title' | 'affiliation' | 'email' | 'mobilePhone'
        > & {
          type?: Maybe<{ __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'label'>>;
          company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>>;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FindCommunityByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type FindCommunityByIdQuery = { __typename?: 'Query' } & {
  findCommunityById: { __typename?: 'CommunityResponse' } & Pick<CommunityResponse, 'error'> & {
    community?: Maybe<
      { __typename?: 'Community' } & Pick<
        Community,
        'id' | 'name' | 'zip' | 'city' | 'address'
      > & {
        division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
        state: { __typename?: 'State' } & Pick<State, 'id' | 'name'>;
        teamMemberCommuniyAssignments?: Maybe<
          Array<
            { __typename?: 'TeamMemberCommunityAssignment' } & {
              teamMember: { __typename?: 'TeamMember' } & Pick<
                TeamMember,
                'groupName' | 'groupMembersNames' | 'status'
              >;
            }
          >
        >;
      }
    >;
  };
};

export type FetchCommunitiesCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchCommunitiesCountQuery = { __typename?: 'Query' } & {
  fetchCommunitiesCount: { __typename?: 'CommunitiesCountResponse' } & Pick<
    CommunitiesCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'CommunitiesCount' } & Pick<
      CommunitiesCount,
      'active' | 'archived'
    >;
  };
};

export type GetCommunityStatesQueryVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetCommunityStatesQuery = { __typename?: 'Query' } & {
  getCommunityStates: { __typename?: 'StatesList' } & Pick<StatesList, 'error'> & {
    states?: Maybe<Array<Maybe<{ __typename?: 'State' } & Pick<State, 'id' | 'label'>>>>;
  };
};

export type GetPageContextDataForCommunityQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetPageContextDataForCommunityQuery = { __typename?: 'Query' } & {
  getPageContextDataForCommunity: { __typename?: 'CommunityResponse' } & Pick<
    CommunityResponse,
    'error'
  > & { community?: Maybe<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name'>> };
};

export type ExportCommunitiesMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedCommunitiesSortFields>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: CommunitiesExportTypes;
}>;

export type ExportCommunitiesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type ExportCommunityTeamMembersMutationVariables = Exact<{
  communityId: Scalars['Int'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  exportType: TeamMembersExportTypes;
}>;

export type ExportCommunityTeamMembersMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type CreateCommunityMutationVariables = Exact<{
  createCommunityInput: CreateCommunityInput;
  allowUpsertAssignment: Scalars['Boolean'];
}>;

export type CreateCommunityMutation = { __typename?: 'Mutation' } & {
  createCommunity: { __typename?: 'CommunityResponse' } & Pick<
    CommunityResponse,
    'error' | 'success'
  > & { community?: Maybe<{ __typename?: 'Community' } & Pick<Community, 'name' | 'id'>> };
};

export type UpdateCommunityTeamMembersMutationVariables = Exact<{
  updateCommunityTeamMembersInput: UpdateCommunityTeamMembersInput;
  id: Scalars['Int'];
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateCommunityTeamMembersMutation = { __typename?: 'Mutation' } & {
  updateCommunityTeamMembers: { __typename?: 'TeamMemberCommunityAssignmentsListResponse' } & Pick<
    TeamMemberCommunityAssignmentsListResponse,
    'error' | 'success'
  >;
};

export type UpdateCommunityHomeTeamMembersMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type UpdateCommunityHomeTeamMembersMutation = { __typename?: 'Mutation' } & {
  updateCommunityHomeTeamMembers: { __typename?: 'TeamMemberLotAssignmentsListResponse' } & Pick<
    TeamMemberLotAssignmentsListResponse,
    'error' | 'success'
  >;
};

export type UpdateCommunityMutationVariables = Exact<{
  updateCommunityInput: UpdateCommunityInput;
  id: Scalars['Int'];
}>;

export type UpdateCommunityMutation = { __typename?: 'Mutation' } & {
  updateCommunity: { __typename?: 'CommunityResponse' } & Pick<CommunityResponse, 'error'> & {
    community?: Maybe<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name'>>;
  };
};

export type ArchiveCommunityMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveCommunityMutation = { __typename?: 'Mutation' } & {
  archiveCommunity: { __typename?: 'CommunityResponse' } & Pick<CommunityResponse, 'error'> & {
    community?: Maybe<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name'>>;
  };
};

export type DeleteCommunityMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteCommunityMutation = { __typename?: 'Mutation' } & {
  deleteCommunity: { __typename?: 'CommunityResponse' } & Pick<CommunityResponse, 'error'> & {
    community?: Maybe<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name'>>;
  };
};

export type FindCompaniesQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type FindCompaniesQuery = { __typename?: 'Query' } & {
  findCompanies: { __typename?: 'CompaniesListResponse' } & Pick<CompaniesListResponse, 'error'> & {
    companies?: Maybe<Array<{ __typename?: 'Company' } & Pick<Company, 'id' | 'name'>>>;
  };
};

export type FindCompaniesPaginatedQueryVariables = Exact<{
  stateIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  names?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<CompanySortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;

export type FindCompaniesPaginatedQuery = { __typename?: 'Query' } & {
  findCompaniesPaginated: { __typename?: 'PaginatedCompanies' } & Pick<
    PaginatedCompanies,
    'statusCode' | 'error' | 'success'
  > & {
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
    items?: Maybe<
      Array<
        { __typename?: 'Company' } & Pick<Company, 'id' | 'name' | 'stateId'> & {
          state?: Maybe<{ __typename?: 'State' } & Pick<State, 'label'>>;
        }
      >
    >;
  };
};

export type FetchCompaniesCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchCompaniesCountQuery = { __typename?: 'Query' } & {
  fetchCompaniesCount: { __typename?: 'CompaniesCountResponse' } & Pick<
    CompaniesCountResponse,
    'success' | 'error'
  > & {
    statsCount: { __typename?: 'CompaniesCount' } & Pick<CompaniesCount, 'active' | 'archived'>;
  };
};

export type GetCompanyByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCompanyByIdQuery = { __typename?: 'Query' } & {
  getCompanyById: { __typename?: 'CompanyResponse' } & Pick<
    CompanyResponse,
    'error' | 'success'
  > & { company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'id' | 'name' | 'stateId'>> };
};

export type ExportCompaniesMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<CompanySortFields>;
  names?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  stateIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: CompanyExportTypes;
}>;

export type ExportCompaniesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type CreateCompanyMutationVariables = Exact<{
  createCompanyInput: CreateCompanyInput;
}>;

export type CreateCompanyMutation = { __typename?: 'Mutation' } & {
  createCompany: { __typename?: 'CompanyResponse' } & Pick<CompanyResponse, 'error' | 'success'> & {
    company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>>;
  };
};

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
  updateCompanyInput: UpdateCompanyInput;
}>;

export type UpdateCompanyMutation = { __typename?: 'Mutation' } & {
  updateCompany: { __typename?: 'CompanyResponse' } & Pick<CompanyResponse, 'error' | 'success'> & {
    company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>>;
  };
};

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteCompanyMutation = { __typename?: 'Mutation' } & {
  deleteCompany: { __typename?: 'CompanyResponse' } & Pick<CompanyResponse, 'success' | 'error'> & {
    company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>>;
  };
};

export type ArchiveCompanyMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveCompanyMutation = { __typename?: 'Mutation' } & {
  archiveCompany: { __typename?: 'CompanyResponse' } & Pick<
    CompanyResponse,
    'success' | 'error'
  > & { company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>> };
};

export type GetContactsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  contactTypesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetContactsQuery = { __typename?: 'Query' } & {
  getContacts: { __typename?: 'PaginatedTeamMembers' } & Pick<PaginatedTeamMembers, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMember' } & Pick<
          TeamMember,
          'id' | 'fullName' | 'title' | 'affiliation' | 'email' | 'mobilePhone'
        > & {
          type?: Maybe<{ __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'label'>>;
          company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>>;
          communities?: Maybe<
            Array<
              { __typename?: 'Community' } & Pick<Community, 'name'> & {
                division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'name'>>;
              }
            >
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetContactTypesQueryVariables = Exact<{
  affiliation?: Maybe<ContactAffiliation>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
}>;

export type GetContactTypesQuery = { __typename?: 'Query' } & {
  getContactTypes: { __typename?: 'TeamMemberTypesListResponse' } & Pick<
    TeamMemberTypesListResponse,
    'error'
  > & {
    contactTypes?: Maybe<
      Array<
        Maybe<
          { __typename?: 'TeamMemberType' } & Pick<
            TeamMemberType,
            'id' | 'label' | 'description' | 'affiliation'
          >
        >
      >
    >;
  };
};

export type FindContactTypesQueryVariables = Exact<{
  typesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  typesNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
}>;

export type FindContactTypesQuery = { __typename?: 'Query' } & {
  findContactTypes: { __typename?: 'PaginatedTeamMemberTypes' } & Pick<
    PaginatedTeamMemberTypes,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMemberType' } & Pick<
          TeamMemberType,
          'id' | 'label' | 'description' | 'affiliation'
        >
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FindAllContactTypesQueryVariables = Exact<{
  typesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;

export type FindAllContactTypesQuery = { __typename?: 'Query' } & {
  findAllContactTypes: { __typename?: 'TeamMemberTypesResponse' } & Pick<
    TeamMemberTypesResponse,
    'error'
  > & {
    teamMemberTypes?: Maybe<
      Array<
        { __typename?: 'TeamMemberType' } & Pick<
          TeamMemberType,
          'id' | 'label' | 'description' | 'affiliation'
        >
      >
    >;
  };
};

export type FetchContactTypesCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchContactTypesCountQuery = { __typename?: 'Query' } & {
  fetchContactTypesCount: { __typename?: 'TeamMemberTypesCountResponse' } & Pick<
    TeamMemberTypesCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'TeamMemberTypesCount' } & Pick<
      TeamMemberTypesCount,
      'active' | 'archived'
    >;
  };
};

export type GetContactByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetContactByIdQuery = { __typename?: 'Query' } & {
  getContactById: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<
      { __typename?: 'TeamMember' } & Pick<
        TeamMember,
        | 'id'
        | 'firstName'
        | 'lastName'
        | 'fullName'
        | 'email'
        | 'title'
        | 'mobilePhone'
        | 'workPhone'
        | 'displayMobilePhone'
        | 'description'
        | 'avatar'
        | 'affiliation'
        | 'typeId'
        | 'isGroupContact'
        | 'groupName'
        | 'groupMembersNames'
      > & {
        communities?: Maybe<Array<{ __typename?: 'Community' } & Pick<Community, 'id'>>>;
        company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'id' | 'name'>>;
        user?: Maybe<
          { __typename?: 'User' } & Pick<User, 'id' | 'fullName'> & {
            notificationsSettings?: Maybe<
              Array<
                { __typename?: 'UserNotificationSetting' } & Pick<
                  UserNotificationSetting,
                  'email' | 'text' | 'id' | 'label' | 'name'
                >
              >
            >;
          }
        >;
      }
    >;
  };
};

export type GetTeamMemberAssignedToLotForCmsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetTeamMemberAssignedToLotForCmsQuery = { __typename?: 'Query' } & {
  getTeamMemberAssignedToLotForCMS: { __typename?: 'TeamMemberAssignedToLotForCMSResponse' } & Pick<
    TeamMemberAssignedToLotForCmsResponse,
    'error' | 'success'
  > & {
    teamMembers?: Maybe<
      Array<
        { __typename?: 'TeamMember' } & Pick<
          TeamMember,
          | 'id'
          | 'lastName'
          | 'firstName'
          | 'avatar'
          | 'workPhone'
          | 'mobilePhone'
          | 'title'
          | 'affiliation'
          | 'companyName'
          | 'companyUrl'
          | 'allowSMS'
          | 'isGroupContact'
          | 'groupName'
          | 'groupMembersNames'
        > & {
          user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id'>>;
          type?: Maybe<
            { __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'name' | 'label'>
          >;
        }
      >
    >;
  };
};

export type GetTeamMemberTypeByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetTeamMemberTypeByIdQuery = { __typename?: 'Query' } & {
  getTeamMemberTypeById: { __typename?: 'TeamMemberTypeResponse' } & Pick<
    TeamMemberTypeResponse,
    'error'
  > & {
    teamMemberType?: Maybe<
      { __typename?: 'TeamMemberType' } & Pick<
        TeamMemberType,
        'id' | 'label' | 'affiliation' | 'description'
      >
    >;
  };
};

export type SearchContactsForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  lotId?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  communityId?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
}>;

export type SearchContactsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getContacts: { __typename?: 'PaginatedTeamMembers' } & Pick<PaginatedTeamMembers, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName' | 'title' | 'email'>
      >
    >;
  };
};

export type SearchTeamMembersForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  lotId?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  communityId?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
}>;

export type SearchTeamMembersForAutoCompleteQuery = { __typename?: 'Query' } & {
  getContacts: { __typename?: 'PaginatedTeamMembers' } & Pick<PaginatedTeamMembers, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName' | 'title' | 'email'>
      >
    >;
  };
};

export type SearchContactTypesForAutoCompleteQueryVariables = Exact<{
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
}>;

export type SearchContactTypesForAutoCompleteQuery = { __typename?: 'Query' } & {
  getContactTypes: { __typename?: 'PaginatedTeamMemberTypes' } & Pick<
    PaginatedTeamMemberTypes,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'id' | 'label' | 'description'>
      >
    >;
  };
};

export type GetNamesFromContactTypesQueryVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetNamesFromContactTypesQuery = { __typename?: 'Query' } & {
  getNamesFromContactTypes: { __typename?: 'NamesFromTeamMemberTypesResponse' } & Pick<
    NamesFromTeamMemberTypesResponse,
    'error' | 'teamMemberTypeNames'
  >;
};

export type FetchContactsCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchContactsCountQuery = { __typename?: 'Query' } & {
  fetchContactsCount: { __typename?: 'TeamMembersCountResponse' } & Pick<
    TeamMembersCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'TeamMembersCount' } & Pick<
      TeamMembersCount,
      'active' | 'archived'
    >;
  };
};

export type ExportContactsMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  contactTypesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  affiliation?: Maybe<ContactAffiliation>;
  companiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: TeamMembersExportTypes;
}>;

export type ExportContactsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type CreateContactMutationVariables = Exact<{
  createVendorTeamMemberInput?: Maybe<CreateVendorTeamMemberInput>;
  createStaffTeamMemberInput?: Maybe<CreateStaffTeamMemberInput>;
  affiliation: ContactAffiliation;
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type CreateContactMutation = { __typename?: 'Mutation' } & {
  createContact: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>>;
  };
};

export type CreateGroupContactMutationVariables = Exact<{
  createGroupContactInput: CreateGroupContactInput;
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type CreateGroupContactMutation = { __typename?: 'Mutation' } & {
  createGroupContact: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>>;
  };
};

export type UpdateGroupContactMutationVariables = Exact<{
  id: Scalars['Int'];
  updateGroupContactInput: UpdateGroupContactInput;
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateGroupContactMutation = { __typename?: 'Mutation' } & {
  updateGroupContact: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>>;
  };
};

export type CreateContactTypeMutationVariables = Exact<{
  createTeamMemberTypeInput: CreateTeamMemberTypeInput;
}>;

export type CreateContactTypeMutation = { __typename?: 'Mutation' } & {
  createContactType: { __typename?: 'TeamMemberTypeResponse' } & Pick<
    TeamMemberTypeResponse,
    'error'
  > & {
    contactType?: Maybe<{ __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'id' | 'label'>>;
  };
};

export type UpdateTeamMemberTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  updateTeamMemberTypeInput: UpdateTeamMemberTypeInput;
}>;

export type UpdateTeamMemberTypeMutation = { __typename?: 'Mutation' } & {
  updateTeamMemberType: { __typename?: 'TeamMemberTypeResponse' } & Pick<
    TeamMemberTypeResponse,
    'error'
  > & { teamMemberType?: Maybe<{ __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'label'>> };
};

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['Int'];
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type DeleteContactMutation = { __typename?: 'Mutation' } & {
  deleteContact: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>>;
  };
};

export type UpdateContactMutationVariables = Exact<{
  updateVendorTeamMemberInput?: Maybe<UpdateVendorTeamMemberInput>;
  updateStaffTeamMemberInput?: Maybe<UpdateStaffTeamMemberInput>;
  id: Scalars['Int'];
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateContactMutation = { __typename?: 'Mutation' } & {
  updateContact: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>>;
  };
};

export type ArchiveContactTypeMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveContactTypeMutation = { __typename?: 'Mutation' } & {
  archiveContactType: { __typename?: 'TeamMemberTypeResponse' } & Pick<
    TeamMemberTypeResponse,
    'statusCode' | 'error'
  > & {
    contactType?: Maybe<
      { __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'id'> & {
        name: TeamMemberType['label'];
      }
    >;
  };
};

export type DeleteTeamMemberTypeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteTeamMemberTypeMutation = { __typename?: 'Mutation' } & {
  deleteTeamMemberType: { __typename?: 'TeamMemberTypeResponse' } & Pick<
    TeamMemberTypeResponse,
    'error'
  > & { teamMemberType?: Maybe<{ __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'label'>> };
};

export type ArchiveContactMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type ArchiveContactMutation = { __typename?: 'Mutation' } & {
  archiveContact: { __typename?: 'TeamMemberResponse' } & Pick<TeamMemberResponse, 'error'> & {
    contact?: Maybe<{ __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>>;
  };
};

export type ExportContactTypesMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMemberTypesSortFields>;
  typesNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  affiliation?: Maybe<ContactAffiliation>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: TeamMemberTypesExportTypes;
}>;

export type ExportContactTypesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetStatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetStatesQuery = { __typename?: 'Query' } & {
  getStates: { __typename?: 'StatesList' } & Pick<StatesList, 'error'> & {
    states?: Maybe<
      Array<
        Maybe<
          { __typename?: 'State' } & Pick<State, 'id' | 'label'> & {
            country?: Maybe<{ __typename?: 'Country' } & Pick<Country, 'id'>>;
          }
        >
      >
    >;
  };
};

export type GetCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountriesQuery = { __typename?: 'Query' } & {
  getCountries: { __typename?: 'CountriesList' } & Pick<CountriesList, 'error'> & {
    countries?: Maybe<Array<{ __typename?: 'Country' } & Pick<Country, 'id' | 'label'>>>;
  };
};

export type GetDefaultPhaseTipByIdQueryVariables = Exact<{
  defaultPhaseTipId: Scalars['Int'];
}>;

export type GetDefaultPhaseTipByIdQuery = { __typename?: 'Query' } & {
  getDefaultPhaseTipById: { __typename?: 'DefaultPhaseTipResponse' } & Pick<
    DefaultPhaseTipResponse,
    'error'
  > & {
    defaultPhaseTip?: Maybe<
      { __typename?: 'DefaultPhaseTip' } & Pick<DefaultPhaseTip, 'id' | 'name' | 'description'>
    >;
  };
};

export type GetDefaultPhaseTipsPaginatedQueryVariables = Exact<{
  defaultPhaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sortBy?: Maybe<DefaultPhaseTipsSortFields>;
  order?: Maybe<SortOrder>;
}>;

export type GetDefaultPhaseTipsPaginatedQuery = { __typename?: 'Query' } & {
  getDefaultPhaseTipsPaginated: { __typename?: 'PaginatedDefaultPhaseTips' } & Pick<
    PaginatedDefaultPhaseTips,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'DefaultPhaseTip' } & Pick<
          DefaultPhaseTip,
          'id' | 'name' | 'description' | 'sequence'
        >
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FetchDefaultPhaseTipsCountQueryVariables = Exact<{
  defaultPhaseId: Scalars['Int'];
}>;

export type FetchDefaultPhaseTipsCountQuery = { __typename?: 'Query' } & {
  fetchDefaultPhaseTipsCount: { __typename?: 'DefaultPhaseTipsCountResponse' } & Pick<
    DefaultPhaseTipsCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'PhaseTipsCount' } & Pick<PhaseTipsCount, 'active' | 'archived'>;
  };
};

export type FindDivisionsWithPhasesQueryVariables = Exact<{
  defaultPhaseId: Scalars['Int'];
}>;

export type FindDivisionsWithPhasesQuery = { __typename?: 'Query' } & {
  findDivisionsWithPhases: { __typename?: 'DivisionsList' } & Pick<DivisionsList, 'error'> & {
    divisions?: Maybe<Array<Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>>>;
  };
};

export type SearchDefaultPhaseTipsForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  defaultPhaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<DefaultPhaseTipsSortFields>;
  order?: Maybe<SortOrder>;
}>;

export type SearchDefaultPhaseTipsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getDefaultPhaseTipsPaginated: { __typename?: 'PaginatedDefaultPhaseTips' } & Pick<
    PaginatedDefaultPhaseTips,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'DefaultPhaseTip' } & Pick<DefaultPhaseTip, 'id' | 'name' | 'description'>
      >
    >;
  };
};

export type UpdateDefaultPhaseTipsOrderMutationVariables = Exact<{
  defaultPhaseTipIds: Array<Scalars['Int']> | Scalars['Int'];
  defaultPhaseId: Scalars['Int'];
}>;

export type UpdateDefaultPhaseTipsOrderMutation = { __typename?: 'Mutation' } & {
  updateDefaultPhaseTipsOrder: { __typename?: 'DefaultPhaseTipsListResponse' } & Pick<
    DefaultPhaseTipsListResponse,
    'error'
  >;
};

export type UpdateDefaultPhaseTipMutationVariables = Exact<{
  updateDefaultPhaseTipInput: UpdateDefaultPhaseTipInput;
  defaultPhaseTipId: Scalars['Int'];
  updateDivisionPhasesTips?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateDefaultPhaseTipMutation = { __typename?: 'Mutation' } & {
  updateDefaultPhaseTip: { __typename?: 'DefaultPhaseTipResponse' } & Pick<
    DefaultPhaseTipResponse,
    'error' | 'success'
  > & {
    defaultPhaseTip?: Maybe<
      { __typename?: 'DefaultPhaseTip' } & Pick<DefaultPhaseTip, 'id' | 'name'>
    >;
  };
};

export type CreateDefaultPhaseTipMutationVariables = Exact<{
  createDefaultPhaseTipInput: CreateDefaultPhaseTipInput;
}>;

export type CreateDefaultPhaseTipMutation = { __typename?: 'Mutation' } & {
  createDefaultPhaseTip: { __typename?: 'DefaultPhaseTipResponse' } & Pick<
    DefaultPhaseTipResponse,
    'error' | 'success'
  > & {
    defaultPhaseTip?: Maybe<
      { __typename?: 'DefaultPhaseTip' } & Pick<DefaultPhaseTip, 'id' | 'name'>
    >;
  };
};

export type ArchiveDefaultPhaseTipMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveDefaultPhaseTipMutation = { __typename?: 'Mutation' } & {
  archiveDefaultPhaseTip: { __typename?: 'DefaultPhaseTipResponse' } & Pick<
    DefaultPhaseTipResponse,
    'statusCode' | 'error'
  > & {
    defaultPhaseTip?: Maybe<
      { __typename?: 'DefaultPhaseTip' } & Pick<DefaultPhaseTip, 'id' | 'name'>
    >;
  };
};

export type DeleteDefaultPhaseTipMutationVariables = Exact<{
  id: Scalars['Int'];
  deleteRelatedPhaseTips?: Maybe<Scalars['Boolean']>;
}>;

export type DeleteDefaultPhaseTipMutation = { __typename?: 'Mutation' } & {
  deleteDefaultPhaseTip: { __typename?: 'DefaultPhaseTipResponse' } & Pick<
    DefaultPhaseTipResponse,
    'error' | 'statusCode'
  > & {
    defaultPhaseTip?: Maybe<
      { __typename?: 'DefaultPhaseTip' } & Pick<DefaultPhaseTip, 'id' | 'name'>
    >;
  };
};

export type ExportDefaultPhaseTipsMutationVariables = Exact<{
  defaultPhaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sortBy?: Maybe<DefaultPhaseTipsSortFields>;
  order?: Maybe<SortOrder>;
  exportType: DefaultPhaseTipsExportTypes;
}>;

export type ExportDefaultPhaseTipsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type FindDivisionsQueryVariables = Exact<{
  withCommunities?: Maybe<Scalars['Boolean']>;
  withPhases?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
}>;

export type FindDivisionsQuery = { __typename?: 'Query' } & {
  findDivisions: { __typename?: 'DivisionsList' } & Pick<DivisionsList, 'error'> & {
    divisions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Division' } & Pick<Division, 'id' | 'name'> & {
            country?: Maybe<{ __typename?: 'Country' } & Pick<Country, 'id' | 'label'>>;
            communities?: Maybe<
              { __typename?: 'Community' } & Pick<
                Community,
                'id' | 'name' | 'city' | 'zip' | 'stateId'
              >
            >;
            phases?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
          }
        >
      >
    >;
  };
};

export type FindDivisionsWithHomesQueryVariables = Exact<{ [key: string]: never }>;

export type FindDivisionsWithHomesQuery = { __typename?: 'Query' } & {
  findDivisionsWithHomes: { __typename?: 'DivisionsList' } & Pick<DivisionsList, 'error'> & {
    divisions?: Maybe<Array<Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>>>;
  };
};

export type GetDivisionsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  statesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetDivisionsQuery = { __typename?: 'Query' } & {
  getDivisions: { __typename?: 'PaginatedDivisions' } & Pick<PaginatedDivisions, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'Division' } & Pick<
          Division,
          'id' | 'name' | 'city' | 'phone' | 'division149PhotosId'
        > & {
          state: { __typename?: 'State' } & Pick<State, 'id' | 'label'>;
          division149photosSync?: Maybe<
            Array<
              { __typename?: 'Division149photosSync' } & Pick<
                Division149photosSync,
                'syncInProgress'
              >
            >
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FindDivisionByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  withPhases?: Maybe<Scalars['Boolean']>;
}>;

export type FindDivisionByIdQuery = { __typename?: 'Query' } & {
  findDivisionById: { __typename?: 'DivisionResponse' } & Pick<DivisionResponse, 'error'> & {
    division?: Maybe<
      { __typename?: 'Division' } & Pick<
        Division,
        | 'id'
        | 'name'
        | 'url'
        | 'designStudioUrl'
        | 'phone'
        | 'zip'
        | 'address'
        | 'city'
        | 'contactPhone'
        | 'contactEmail'
        | 'logo'
        | 'division149PhotosId'
        | 'timeZone'
      > & {
        country?: Maybe<{ __typename?: 'Country' } & Pick<Country, 'id'>>;
        state: { __typename?: 'State' } & Pick<State, 'id'>;
        contactUser?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'fullName'>>;
        phases?: Maybe<
          { __typename?: 'Phase' } & Pick<Phase, 'id' | 'name' | 'defaultPhaseId'>
        >;
      }
    >;
  };
};

export type SearchDivisionsForAutoCompleteQueryVariables = Exact<{
  city?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
}>;

export type SearchDivisionsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getDivisions: { __typename?: 'PaginatedDivisions' } & Pick<PaginatedDivisions, 'error'> & {
    items?: Maybe<
      Array<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name' | 'city' | 'phone'>>
    >;
  };
};

export type FetchDivisionsCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchDivisionsCountQuery = { __typename?: 'Query' } & {
  fetchDivisionsCount: { __typename?: 'DivisionsCountResponse' } & Pick<
    DivisionsCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'DivisionsCount' } & Pick<DivisionsCount, 'active' | 'archived'>;
  };
};

export type GetDivisionStatesQueryVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetDivisionStatesQuery = { __typename?: 'Query' } & {
  getDivisionStates: { __typename?: 'StatesList' } & Pick<StatesList, 'error'> & {
    states?: Maybe<Array<Maybe<{ __typename?: 'State' } & Pick<State, 'id' | 'label'>>>>;
  };
};

export type ExportDivisionsMutationVariables = Exact<{
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  statesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedDivisionsSortFields>;
  exportType: DivisionsExportTypes;
}>;

export type ExportDivisionsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type ArchiveDivisionMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveDivisionMutation = { __typename?: 'Mutation' } & {
  archiveDivision: { __typename?: 'DivisionResponse' } & Pick<DivisionResponse, 'error'> & {
    division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
  };
};

export type DeleteDivisionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteDivisionMutation = { __typename?: 'Mutation' } & {
  deleteDivision: { __typename?: 'DivisionResponse' } & Pick<DivisionResponse, 'error'> & {
    division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
  };
};

export type CreateDivisionMutationVariables = Exact<{
  createDivisionInput: CreateDivisionInput;
}>;

export type CreateDivisionMutation = { __typename?: 'Mutation' } & {
  createDivision: { __typename?: 'DivisionResponse' } & Pick<DivisionResponse, 'error'> & {
    division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
  };
};

export type UpdateDivisionMutationVariables = Exact<{
  updateDivisionInput: UpdateDivisionInput;
  id: Scalars['Int'];
}>;

export type UpdateDivisionMutation = { __typename?: 'Mutation' } & {
  updateDivision: { __typename?: 'DivisionResponse' } & Pick<DivisionResponse, 'error'> & {
    division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
  };
};

export type Sync149PhotosWithRemoteMutationVariables = Exact<{
  divisionId: Scalars['Int'];
}>;

export type Sync149PhotosWithRemoteMutation = { __typename?: 'Mutation' } & {
  sync149PhotosWithRemote: { __typename?: 'ServerResponseObject' } & Pick<
    ServerResponseObject,
    'success'
  >;
};

export type GetDocumentsWithPaginationQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DocumentsSortingFields>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetDocumentsWithPaginationQuery = { __typename?: 'Query' } & {
  getDocumentsWithPagination: { __typename?: 'PaginatedDocument' } & {
    items?: Maybe<
      Array<
        { __typename?: 'Document' } & Pick<
          Document,
          'id' | 'name' | 'description' | 'fileSize' | 'fileName' | 'fileUrl' | 'editable'
        > & {
          communities?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Community' } & Pick<Community, 'id' | 'name'> & {
                  division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
                }
              >
            >
          >;
          phases?: Maybe<Array<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>>;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetDocumentsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetDocumentsCountQuery = { __typename?: 'Query' } & {
  getDocumentsCount: { __typename?: 'DocumentsCountResponse' } & Pick<
    DocumentsCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'DocumentsCount' } & Pick<DocumentsCount, 'active' | 'archived'>;
  };
};

export type SearchDocumentsForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DocumentsSortingFields>;
}>;

export type SearchDocumentsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getDocumentsWithPagination: { __typename?: 'PaginatedDocument' } & Pick<
    PaginatedDocument,
    'error'
  > & {
    items?: Maybe<
      Array<{ __typename?: 'Document' } & Pick<Document, 'id' | 'name' | 'description'>>
    >;
  };
};

export type GetPhaseNamesFromDocumentsQueryVariables = Exact<{
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhaseNamesFromDocumentsQuery = { __typename?: 'Query' } & {
  getPhaseNamesFromDocuments: { __typename?: 'DocumentPhaseNamesResponse' } & Pick<
    DocumentPhaseNamesResponse,
    'error' | 'phaseNames'
  >;
};

export type GetDocumentByIdQueryVariables = Exact<{
  documentId: Scalars['Int'];
}>;

export type GetDocumentByIdQuery = { __typename?: 'Query' } & {
  getDocument: { __typename?: 'DocumentResponse' } & Pick<DocumentResponse, 'error'> & {
    document?: Maybe<
      { __typename?: 'Document' } & Pick<
        Document,
        'id' | 'name' | 'description' | 'fileName' | 'fileUrl' | 'fileSize'
      > & {
        communityPhaseAssignments?: Maybe<
          Array<
            Maybe<
              { __typename?: 'DocumentCommunityPhaseAssignment' } & {
                phase: { __typename?: 'Phase' } & Pick<Phase, 'id'>;
                community: { __typename?: 'Community' } & Pick<Community, 'id'>;
              }
            >
          >
        >;
      }
    >;
  };
};

export type ArchiveDocumentMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  documentId: Scalars['Int'];
}>;

export type ArchiveDocumentMutation = { __typename?: 'Mutation' } & {
  archiveDocument: { __typename?: 'DocumentResponse' } & Pick<DocumentResponse, 'error'> & {
    document?: Maybe<{ __typename?: 'Document' } & Pick<Document, 'id' | 'name'>>;
  };
};

export type CreateDocumentMutationVariables = Exact<{
  createDocumentInput: CreateDocumentInput;
}>;

export type CreateDocumentMutation = { __typename?: 'Mutation' } & {
  createDocument: { __typename?: 'DocumentResponse' } & Pick<DocumentResponse, 'error'> & {
    document?: Maybe<{ __typename?: 'Document' } & Pick<Document, 'id' | 'name'>>;
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['Int'];
}>;

export type DeleteDocumentMutation = { __typename?: 'Mutation' } & {
  deleteDocument: { __typename?: 'DocumentResponse' } & Pick<DocumentResponse, 'error'> & {
    document?: Maybe<{ __typename?: 'Document' } & Pick<Document, 'id' | 'name'>>;
  };
};

export type UpdateDocumentMutationVariables = Exact<{
  updateDocumentInput: UpdateDocumentInput;
  documentId: Scalars['Int'];
}>;

export type UpdateDocumentMutation = { __typename?: 'Mutation' } & {
  updateDocument: { __typename?: 'DocumentResponse' } & Pick<DocumentResponse, 'error'> & {
    document?: Maybe<{ __typename?: 'Document' } & Pick<Document, 'id' | 'name'>>;
  };
};

export type ExportDocumentsMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<DocumentsSortingFields>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: DocumentsExportTypes;
}>;

export type ExportDocumentsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetEventsWithPaginationQueryVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
  name?: Maybe<Scalars['String']>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetEventsWithPaginationQuery = { __typename?: 'Query' } & {
  getEventsWithPagination: { __typename?: 'PaginatedEvents' } & Pick<PaginatedEvents, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'Event' } & Pick<
          Event,
          'id' | 'name' | 'description' | 'rsvpRequired' | 'estimatedDuration' | 'editable'
        > & {
          communityPhaseAssignments?: Maybe<
            Array<
              { __typename?: 'EventCommunityPhaseAssignment' } & Pick<
                EventCommunityPhaseAssignment,
                'id'
              > & {
                community?: Maybe<
                  { __typename?: 'Community' } & Pick<Community, 'id' | 'name'> & {
                    division?: Maybe<
                      { __typename?: 'Division' } & Pick<Division, 'id' | 'name'>
                    >;
                  }
                >;
                phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
              }
            >
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetEventsQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<EventListSortByField>;
  order?: Maybe<SortOrder>;
}>;

export type GetEventsQuery = { __typename?: 'Query' } & {
  getEvents: { __typename?: 'EventsListResponse' } & Pick<EventsListResponse, 'error'> & {
    events?: Maybe<Array<Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'name'>>>>;
  };
};

export type ExportEventsMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: EventsExportTypes;
}>;

export type ExportEventsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetCommunitiesByDivisionIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCommunitiesByDivisionIdQuery = { __typename?: 'Query' } & {
  getCommunitiesByDivisionId: { __typename?: 'CommunitiesList' } & Pick<
    CommunitiesList,
    'success' | 'error' | 'statusCode'
  > & {
    communities?: Maybe<
      Array<Maybe<{ __typename?: 'Community' } & Pick<Community, 'id' | 'name'>>>
    >;
  };
};

export type FindEventByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type FindEventByIdQuery = { __typename?: 'Query' } & {
  findEventById: { __typename?: 'EventResponse' } & Pick<EventResponse, 'error'> & {
    event?: Maybe<
      { __typename?: 'Event' } & Pick<
        Event,
        'id' | 'name' | 'description' | 'rsvpRequired' | 'estimatedDuration'
      > & {
        communityPhaseAssignments?: Maybe<
          Array<
            { __typename?: 'EventCommunityPhaseAssignment' } & Pick<
              EventCommunityPhaseAssignment,
              'id'
            > & {
              community?: Maybe<
                { __typename?: 'Community' } & Pick<Community, 'id' | 'name'>
              >;
              phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
            }
          >
        >;
      }
    >;
  };
};

export type GetHomesByCommunityIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetHomesByCommunityIdQuery = { __typename?: 'Query' } & {
  getHomesByCommunityId: { __typename?: 'LotsList' } & Pick<
    LotsList,
    'success' | 'error' | 'statusCode'
  > & { lots?: Maybe<Array<Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'id' | 'address'>>>> };
};

export type FetchEventsCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchEventsCountQuery = { __typename?: 'Query' } & {
  fetchEventsCount: { __typename?: 'EventsCountResponse' } & Pick<EventsCountResponse, 'error'> & {
    statsCount: { __typename?: 'EventsCount' } & Pick<EventsCount, 'active' | 'archived'>;
  };
};

export type CreateEventMutationVariables = Exact<{
  createEventInput: CreateEventInput;
}>;

export type CreateEventMutation = { __typename?: 'Mutation' } & {
  createEvent: { __typename?: 'EventResponse' } & Pick<EventResponse, 'error'> & {
    event?: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'name'>>;
  };
};

export type UpdateEventMutationVariables = Exact<{
  updateEventInput: UpdateEventInput;
  id: Scalars['Int'];
}>;

export type UpdateEventMutation = { __typename?: 'Mutation' } & {
  updateEvent: { __typename?: 'EventResponse' } & Pick<EventResponse, 'error'> & {
    event?: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'name'>>;
  };
};

export type ArchiveEventMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveEventMutation = { __typename?: 'Mutation' } & {
  archiveEvent: { __typename?: 'EventResponse' } & Pick<EventResponse, 'statusCode' | 'error'> & {
    event?: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'name'>>;
  };
};

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteEventMutation = { __typename?: 'Mutation' } & {
  deleteEvent: { __typename?: 'EventResponse' } & Pick<EventResponse, 'error' | 'statusCode'> & {
    event?: Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'name'>>;
  };
};

export type SearchEventsForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
}>;

export type SearchEventsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getEvents: { __typename?: 'EventsListResponse' } & Pick<EventsListResponse, 'error'> & {
    events?: Maybe<Array<Maybe<{ __typename?: 'Event' } & Pick<Event, 'id' | 'name'>>>>;
  };
};

export type GetPhaseNamesFromEventsQueryVariables = Exact<{
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhaseNamesFromEventsQuery = { __typename?: 'Query' } & {
  getPhaseNamesFromEvents: { __typename?: 'PhaseNamesFromEventsResponse' } & Pick<
    PhaseNamesFromEventsResponse,
    'error' | 'phaseNames'
  >;
};

export type BuyerCoreFragment = { __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'fullName'> & {
  role?: Maybe<{ __typename?: 'Role' } & Pick<Role, 'name' | 'label'>>;
};

export type TeamMemberCoreFragment = { __typename?: 'TeamMember' } & Pick<
  TeamMember,
  'id' | 'fullName'
>;

export type PaginationCoreInfoFragment = { __typename?: 'PaginationMeta' } & Pick<
  PaginationMeta,
  'totalItems'
>;

export type PhaseCoreFragment = { __typename?: 'Phase' } & Pick<
  Phase,
  'id' | 'sequence' | 'name' | 'description' | 'videoUrl'
>;

export type DefaultPhaseCoreFragment = { __typename?: 'DefaultPhase' } & Pick<
  DefaultPhase,
  'id' | 'sequence' | 'name' | 'description' | 'videoUrl'
> & {
  divisionPhases?: Maybe<
    Array<
      { __typename?: 'Phase' } & {
        division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'name'>>;
      }
    >
  >;
};

export type GetHomeDocumentsWithPaginationQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotDocumentsSortTypes>;
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetHomeDocumentsWithPaginationQuery = { __typename?: 'Query' } & {
  getHomeDocumentsWithPagination: { __typename?: 'PaginatedLotDocuments' } & {
    items?: Maybe<
      Array<
        | ({ __typename?: 'LotDocument' } & Pick<
          LotDocument,
          'id' | 'name' | 'description' | 'fileSize' | 'fileName' | 'fileUrl'
        > & { phases?: Maybe<Array<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>> })
        | ({ __typename?: 'Document' } & Pick<
          Document,
          'id' | 'name' | 'description' | 'fileSize' | 'fileName' | 'fileUrl'
        > & {
          phases?: Maybe<Array<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>>;
          lotDocumentAssignments?: Maybe<
            Array<
              Maybe<
                { __typename?: 'LotDocumentAssignment' } & Pick<
                  LotDocumentAssignment,
                  'visible' | 'lotId'
                >
              >
            >
          >;
        })
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type ChangeDocumentVisibilityMutationVariables = Exact<{
  documentId: Scalars['Int'];
  lotId: Scalars['Int'];
}>;

export type ChangeDocumentVisibilityMutation = { __typename?: 'Mutation' } & {
  changeDocumentVisibility: { __typename?: 'ServerResponseObject' } & Pick<
    ServerResponseObject,
    'success' | 'error'
  >;
};

export type GetHomeDocumentsCountQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type GetHomeDocumentsCountQuery = { __typename?: 'Query' } & {
  getHomeDocumentsCount: { __typename?: 'LotDocumentsCountResponse' } & Pick<
    LotDocumentsCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'LotDocumentsCount' } & Pick<
      LotDocumentsCount,
      'active' | 'archived'
    >;
  };
};

export type SearchHomeDocumentsForAutoCompleteQueryVariables = Exact<{
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotDocumentsSortTypes>;
}>;

export type SearchHomeDocumentsForAutoCompleteQuery = { __typename?: 'Query' } & {
  searchHomeDocumentsForAutoComplete: { __typename?: 'LotDocumentsUnionResponse' } & Pick<
    LotDocumentsUnionResponse,
    'error'
  > & {
    lotDocuments?: Maybe<
      Array<
        Maybe<
          | ({ __typename?: 'LotDocument' } & Pick<LotDocument, 'id' | 'name' | 'description'>)
          | ({ __typename?: 'Document' } & Pick<Document, 'id' | 'name' | 'description'>)
        >
      >
    >;
  };
};

export type GetPhaseNamesFromHomeDocumentsQueryVariables = Exact<{
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhaseNamesFromHomeDocumentsQuery = { __typename?: 'Query' } & {
  getPhaseNamesFromHomeDocuments: { __typename?: 'LotDocumentPhaseNamesResponse' } & Pick<
    LotDocumentPhaseNamesResponse,
    'error' | 'phaseNames'
  >;
};

export type GetHomeDocumentByIdQueryVariables = Exact<{
  documentId: Scalars['Int'];
}>;

export type GetHomeDocumentByIdQuery = { __typename?: 'Query' } & {
  getHomeDocument: { __typename?: 'LotDocumentResponse' } & Pick<LotDocumentResponse, 'error'> & {
    lotDocument?: Maybe<
      { __typename?: 'LotDocument' } & Pick<
        LotDocument,
        'id' | 'name' | 'description' | 'fileName' | 'fileUrl' | 'fileSize'
      > & {
        phaseAssignments: Array<
          { __typename?: 'LotDocumentPhaseAssignment' } & {
            phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id'>>;
          }
        >;
      }
    >;
  };
};

export type ArchiveHomeDocumentMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  documentId: Scalars['Int'];
}>;

export type ArchiveHomeDocumentMutation = { __typename?: 'Mutation' } & {
  archiveHomeDocument: { __typename?: 'LotDocumentResponse' } & Pick<
    LotDocumentResponse,
    'error'
  > & { lotDocument?: Maybe<{ __typename?: 'LotDocument' } & Pick<LotDocument, 'id' | 'name'>> };
};

export type CreateHomeDocumentMutationVariables = Exact<{
  lotId: Scalars['Int'];
  createHomeDocumentInput: Array<CreateLotDocumentInput> | CreateLotDocumentInput;
}>;

export type CreateHomeDocumentMutation = { __typename?: 'Mutation' } & {
  createHomeDocument: { __typename?: 'LotDocumentsResponse' } & Pick<
    LotDocumentsResponse,
    'error'
  > & {
    lotDocuments?: Maybe<
      Array<{ __typename?: 'LotDocument' } & Pick<LotDocument, 'id' | 'name'>>
    >;
  };
};

export type DeleteHomeDocumentMutationVariables = Exact<{
  documentId: Scalars['Int'];
}>;

export type DeleteHomeDocumentMutation = { __typename?: 'Mutation' } & {
  deleteHomeDocument: { __typename?: 'LotDocumentResponse' } & Pick<
    LotDocumentResponse,
    'error'
  > & { lotDocument?: Maybe<{ __typename?: 'LotDocument' } & Pick<LotDocument, 'id' | 'name'>> };
};

export type UpdateHomeDocumentMutationVariables = Exact<{
  updateHomeDocumentInput: UpdateLotDocumentInput;
  documentId: Scalars['Int'];
}>;

export type UpdateHomeDocumentMutation = { __typename?: 'Mutation' } & {
  updateHomeDocument: { __typename?: 'LotDocumentResponse' } & Pick<
    LotDocumentResponse,
    'error'
  > & { lotDocument?: Maybe<{ __typename?: 'LotDocument' } & Pick<LotDocument, 'id' | 'name'>> };
};

export type ExportHomeDocumentsMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotDocumentsSortTypes>;
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: LotDocumentsExportTypes;
}>;

export type ExportHomeDocumentsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetLotGalleryImagesQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type GetLotGalleryImagesQuery = { __typename?: 'Query' } & {
  getLotGalleryImages: { __typename?: 'LotGalleryImageList' } & Pick<
    LotGalleryImageList,
    'error' | 'success'
  > & {
    items?: Maybe<
      Array<
        Maybe<
          { __typename?: 'LotGalleryImage' } & Pick<
            LotGalleryImage,
            'id' | 'order' | 'fullImgSrc' | 'smallImgSrc'
          >
        >
      >
    >;
  };
};

export type UpdateLotGalleryOrderMutationVariables = Exact<{
  lotGalleryIds: Array<Scalars['Int']> | Scalars['Int'];
  lotId: Scalars['Int'];
}>;

export type UpdateLotGalleryOrderMutation = { __typename?: 'Mutation' } & {
  updateLotGalleryOrder: { __typename?: 'LotGalleryImageList' } & Pick<
    LotGalleryImageList,
    'success' | 'error'
  >;
};

export type RemoveLotGalleryImagesMutationVariables = Exact<{
  lotPhotosIds: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type RemoveLotGalleryImagesMutation = { __typename?: 'Mutation' } & {
  removeLotGalleryImages: { __typename?: 'LotGalleryImageList' } & Pick<
    LotGalleryImageList,
    'success' | 'error'
  >;
};

export type CreateLotGalleryImagesMutationVariables = Exact<{
  createLotGalleryImagesInput: Array<CreateLotGalleryImageInput> | CreateLotGalleryImageInput;
  lotId: Scalars['Int'];
}>;

export type CreateLotGalleryImagesMutation = { __typename?: 'Mutation' } & {
  createLotGalleryImages: { __typename?: 'LotGalleryImageList' } & Pick<
    LotGalleryImageList,
    'success' | 'error'
  >;
};

export type GetLotPhotos149ListQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type GetLotPhotos149ListQuery = { __typename?: 'Query' } & {
  getLotPhotos149List: { __typename?: 'LotPhotos149List' } & Pick<
    LotPhotos149List,
    'error' | 'success'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'Lot149PhotosGallery' } & Pick<
          Lot149PhotosGallery,
          'url' | 'stage' | 'updatedAt' | 'type'
        >
      >
    >;
  };
};

export type FindLotAppointmentsWithPaginationQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotAppointmentsSortFields>;
  lotId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  statuses?: Maybe<Array<LotAppointmentStatus> | LotAppointmentStatus>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  attendees?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type FindLotAppointmentsWithPaginationQuery = { __typename?: 'Query' } & {
  findLotAppointmentsWithPagination: { __typename?: 'PaginatedLotAppointments' } & Pick<
    PaginatedLotAppointments,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'LotAppointment' } & Pick<
          LotAppointment,
          'id' | 'name' | 'description' | 'status' | 'startDate' | 'startTime' | 'start' | 'end'
        > & {
          phase: { __typename?: 'Phase' } & Pick<Phase, 'name'>;
          attendees?: Maybe<
            Array<
              | ({ __typename?: 'Buyer' } & Pick<Buyer, 'fullName'>)
              | ({ __typename?: 'TeamMember' } & Pick<TeamMember, 'fullName'>)
            >
          >;
          lot: { __typename?: 'Lot' } & Pick<Lot, 'id'>;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FindLotAppointmentByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type FindLotAppointmentByIdQuery = { __typename?: 'Query' } & {
  findLotAppointmentById: { __typename?: 'LotAppointmentResponse' } & Pick<
    LotAppointmentResponse,
    'error'
  > & {
    lotAppointment?: Maybe<
      { __typename?: 'LotAppointment' } & Pick<
        LotAppointment,
        | 'name'
        | 'eventId'
        | 'phaseId'
        | 'description'
        | 'startDate'
        | 'startTime'
        | 'start'
        | 'end'
        | 'rsvpRequired'
        | 'address'
        | 'address2'
        | 'city'
        | 'stateId'
        | 'zip'
        | 'requestedBy'
        | 'status'
      > & {
        phase: { __typename?: 'Phase' } & Pick<Phase, 'name'>;
        event?: Maybe<
          { __typename?: 'Event' } & {
            communityPhaseAssignments?: Maybe<
              Array<
                { __typename?: 'EventCommunityPhaseAssignment' } & {
                  phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id'>>;
                }
              >
            >;
          }
        >;
        lotAppointmentBuyers: Array<
          Maybe<
            { __typename?: 'LotAppointmentBuyer' } & {
              buyer?: Maybe<{ __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'fullName'>>;
            }
          >
        >;
        lotAppointmentTeamMembers: Array<
          Maybe<
            { __typename?: 'LotAppointmentTeamMember' } & {
              teamMember?: Maybe<
                { __typename?: 'TeamMember' } & Pick<TeamMember, 'id' | 'fullName'>
              >;
            }
          >
        >;
        state: { __typename?: 'State' } & Pick<State, 'label'>;
        lot: { __typename?: 'Lot' } & Pick<Lot, 'id'> & {
          community: { __typename?: 'Community' } & {
            division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'timeZone'>>;
          };
        };
        newEvent?: Maybe<
          { __typename?: 'LotAppointment' } & Pick<LotAppointment, 'startDate' | 'startTime' | 'start' | 'end'>
        >;
      }
    >;
  };
};

export type GetEventsForAutocompleteQueryVariables = Exact<{
  name: Scalars['String'];
  lotId: Scalars['Int'];
  phaseId?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<EventListSortByField>;
}>;

export type GetEventsForAutocompleteQuery = { __typename?: 'Query' } & {
  getEventsForLotAppointmentAutocomplete: { __typename?: 'EventsListResponse' } & {
    events?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Event' } & Pick<
            Event,
            'id' | 'name' | 'description' | 'rsvpRequired' | 'estimatedDuration'
          > & {
            communityPhaseAssignments?: Maybe<
              Array<
                { __typename?: 'EventCommunityPhaseAssignment' } & {
                  phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
                }
              >
            >;
          }
        >
      >
    >;
  };
};

export type GetCommunityTeamMembersNamesForLotQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCommunityTeamMembersNamesForLotQuery = { __typename?: 'Query' } & {
  getCommunityTeamMembersNamesForLot: { __typename?: 'TeamMembersNamesResponse' } & Pick<
    TeamMembersNamesResponse,
    'teamMembersNames'
  >;
};

export type GetPhaseNamesFromLotAppointmentsQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type GetPhaseNamesFromLotAppointmentsQuery = { __typename?: 'Query' } & {
  getPhaseNamesFromLotAppointments: { __typename?: 'PhaseNamesFromLotAppointmentsResponse' } & Pick<
    PhaseNamesFromLotAppointmentsResponse,
    'error' | 'phaseNames'
  >;
};

export type GetAttendeesFromLotAppointmentsQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type GetAttendeesFromLotAppointmentsQuery = { __typename?: 'Query' } & {
  findLotAppointmentsAttendees: { __typename?: 'LotAppointmentAttendeesResponse' } & Pick<
    LotAppointmentAttendeesResponse,
    'error'
  > & {
    attendees?: Maybe<
      Array<
        | ({ __typename?: 'Buyer' } & Pick<Buyer, 'fullName'>)
        | ({ __typename?: 'TeamMember' } & Pick<TeamMember, 'fullName'>)
      >
    >;
  };
};

export type SearchLotAppointmentsForAutoCompleteQueryVariables = Exact<{
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotAppointmentsSortFields>;
}>;

export type SearchLotAppointmentsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getLotAppointmentNamesForAutocomplete: { __typename?: 'LotAppointmentNamesResponse' } & Pick<
    LotAppointmentNamesResponse,
    'error' | 'names'
  >;
};

export type ExportLotAppointmentsMutationVariables = Exact<{
  lotId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  statuses?: Maybe<Array<LotAppointmentStatus> | LotAppointmentStatus>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  attendees?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  exportType: LotAppointmentsExportTypes;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<LotAppointmentsSortFields>;
}>;

export type ExportLotAppointmentsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type ExportLotAppointmentMutationVariables = Exact<{
  id: Scalars['Int'];
  exportType: LotAppointmentsExportTypes;
}>;

export type ExportLotAppointmentMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type DeleteLotAppointmentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteLotAppointmentMutation = { __typename?: 'Mutation' } & {
  deleteLotAppointment: { __typename?: 'LotAppointmentResponse' } & Pick<
    LotAppointmentResponse,
    'error' | 'success'
  > & { lotAppointment?: Maybe<{ __typename?: 'LotAppointment' } & Pick<LotAppointment, 'name'>> };
};

export type CreateHomeAppointmentMutationVariables = Exact<{
  createHomeAppointmentInput: CreateLotAppointmentInput;
}>;

export type CreateHomeAppointmentMutation = { __typename?: 'Mutation' } & {
  createHomeAppointment: { __typename?: 'LotAppointmentResponse' } & Pick<
    LotAppointmentResponse,
    'error' | 'success'
  > & {
    lotAppointment?: Maybe<
      { __typename?: 'LotAppointment' } & Pick<LotAppointment, 'id' | 'name'>
    >;
  };
};

export type UpdateLotAppointmentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: UpdateLotAppointmentInput;
}>;

export type UpdateLotAppointmentMutation = { __typename?: 'Mutation' } & {
  updateLotAppointment: { __typename?: 'LotAppointmentResponse' } & Pick<
    LotAppointmentResponse,
    'error' | 'success'
  > & {
    lotAppointment?: Maybe<
      { __typename?: 'LotAppointment' } & Pick<LotAppointment, 'id' | 'name'>
    >;
  };
};

export type RescheduleLotAppointmentMutationVariables = Exact<{
  id: Scalars['Int'];
  input: RescheduleLotAppointmentInput;
}>;

export type RescheduleLotAppointmentMutation = { __typename?: 'Mutation' } & {
  rescheduleLotAppointmentFromCMS: { __typename?: 'LotAppointmentResponse' } & Pick<
    LotAppointmentResponse,
    'error' | 'success'
  > & {
    lotAppointment?: Maybe<
      { __typename?: 'LotAppointment' } & Pick<LotAppointment, 'id' | 'name'>
    >;
  };
};

export type GetHomesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedLotsSortFields>;
  contractDateFrom?: Maybe<Scalars['DateTime']>;
  contractDateTo?: Maybe<Scalars['DateTime']>;
  lastLoginDateFrom?: Maybe<Scalars['DateTime']>;
  lastLoginDateTo?: Maybe<Scalars['DateTime']>;
  contractCancelledDateFrom?: Maybe<Scalars['DateTime']>;
  contractCancelledDateTo?: Maybe<Scalars['DateTime']>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  planId?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  phasesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  phasesNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetHomesQuery = { __typename?: 'Query' } & {
  getHomes: { __typename?: 'PaginatedLots' } & Pick<PaginatedLots, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'Lot' } & Pick<
          Lot,
          | 'id'
          | 'address'
          | 'homesite'
          | 'contractDate'
          | 'estimatedDeliveryDate'
          | 'closingDate'
          | 'buyerFirstName'
          | 'buyerLastName'
          | 'lastLoginDate'
          | 'contractCancelledDate'
        > & {
          elevation?: Maybe<
            { __typename?: 'Elevation' } & Pick<Elevation, 'id'> & {
              plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'>>;
            }
          >;
          buyers?: Maybe<
            Array<
              { __typename?: 'Buyer' } & Pick<Buyer, 'id'> & {
                user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'fullName'>>;
              }
            >
          >;
          phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
          community: { __typename?: 'Community' } & Pick<Community, 'id' | 'name'> & {
            division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
          };
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FindHomeByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type FindHomeByIdQuery = { __typename?: 'Query' } & {
  findHomeById: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error'> & {
    lot?: Maybe<
      { __typename?: 'Lot' } & Pick<
        Lot,
        | 'id'
        | 'address'
        | 'homesite'
        | 'city'
        | 'stateId'
        | 'zip'
        | 'elevationRendering'
        | 'contractDate'
        | 'estimatedDeliveryDate'
        | 'closingDate'
        | 'buyerFirstName'
        | 'buyerLastName'
        | 'buyerEmail'
        | 'buyerHomePhone'
        | 'lot149PhotosLotNum'
      > & {
        elevation?: Maybe<
          { __typename?: 'Elevation' } & Pick<Elevation, 'id' | 'name' | 'imageUrl'> & {
            plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'>>;
          }
        >;
        teamMembersAssignments?: Maybe<
          Array<
            { __typename?: 'TeamMemberLotAssignment' } & {
              teamMember: { __typename?: 'TeamMember' } & Pick<
                TeamMember,
                'groupName' | 'groupMembersNames' | 'status'
              >;
            }
          >
        >;
        buyers?: Maybe<
          Array<
            { __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'activated'> & {
              user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'fullName'>>;
            }
          >
        >;
        phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
        community: { __typename?: 'Community' } & Pick<Community, 'id' | 'name'> & {
          division?: Maybe<
            { __typename?: 'Division' } & Pick<
              Division,
              'id' | 'name' | 'timeZone' | 'division149PhotosId'
            > & {
              country?: Maybe<{ __typename?: 'Country' } & Pick<Country, 'id' | 'label'>>;
            }
          >;
        };
      }
    >;
  };
};

export type GetLotCommunityDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetLotCommunityDataQuery = { __typename?: 'Query' } & {
  getLotCommunityData: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error'> & {
    lot?: Maybe<
      { __typename?: 'Lot' } & Pick<Lot, 'id'> & {
        community: { __typename?: 'Community' } & Pick<
          Community,
          'id' | 'stateId' | 'address' | 'address2' | 'zip' | 'city'
        >;
      }
    >;
  };
};

export type GetPageContextDataForHomeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetPageContextDataForHomeQuery = { __typename?: 'Query' } & {
  getPageContextDataForHome: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error'> & {
    lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'id' | 'address'>>;
  };
};

export type SearchHomesForAutoCompleteQueryVariables = Exact<{
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedLotsSortFields>;
}>;

export type SearchHomesForAutoCompleteQuery = { __typename?: 'Query' } & {
  getHomes: { __typename?: 'LotsList' } & Pick<LotsList, 'error'> & {
    items?: Maybe<
      Array<
        Maybe<
          { __typename?: 'Lot' } & Pick<
            Lot,
            'id' | 'address' | 'homesite' | 'planName' | 'buyerFirstName' | 'buyerLastName'
          > & {
            buyers?: Maybe<
              Array<
                { __typename?: 'Buyer' } & {
                  user?: Maybe<{ __typename?: 'User' } & Pick<User, 'firstName' | 'lastName'>>;
                }
              >
            >;
          }
        >
      >
    >;
  };
};

export type GetHomeTeamMembersIdsQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type GetHomeTeamMembersIdsQuery = { __typename?: 'Query' } & {
  getHomeTeamMembersIds: { __typename?: 'LotTeamMemberIds' } & Pick<
    LotTeamMemberIds,
    'error' | 'success' | 'teamMemberIds'
  >;
};

export type FindCommunityTeamMembersForLotQueryVariables = Exact<{
  communityId: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  getAll?: Maybe<Scalars['Boolean']>;
}>;

export type FindCommunityTeamMembersForLotQuery = { __typename?: 'Query' } & {
  findCommunityTeamMembersForLot: { __typename?: 'PaginatedTeamMembers' } & Pick<
    PaginatedTeamMembers,
    'error' | 'success'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'TeamMember' } & Pick<
          TeamMember,
          'id' | 'fullName' | 'title' | 'affiliation' | 'email' | 'mobilePhone'
        > & {
          type?: Maybe<{ __typename?: 'TeamMemberType' } & Pick<TeamMemberType, 'label'>>;
          company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'name'>>;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FindLotAttendeesQueryVariables = Exact<{
  lotId: Scalars['Int'];
}>;

export type FindLotAttendeesQuery = { __typename?: 'Query' } & {
  findLotAttendees: { __typename?: 'LotAppointmentAttendeesResponse' } & Pick<
    LotAppointmentAttendeesResponse,
    'error'
  > & {
    attendees?: Maybe<
      Array<
        | ({ __typename: 'Buyer' } & BuyerCoreFragment)
        | ({ __typename: 'TeamMember' } & TeamMemberCoreFragment)
      >
    >;
  };
};

export type FetchHomesCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchHomesCountQuery = { __typename?: 'Query' } & {
  fetchHomesCount: { __typename?: 'LotsCountResponse' } & Pick<LotsCountResponse, 'error'> & {
    statsCount: { __typename?: 'LotsCount' } & Pick<LotsCount, 'active' | 'archived'>;
  };
};

export type GetLotUpdatesQueryVariables = Exact<{
  lotId: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;

export type GetLotUpdatesQuery = { __typename?: 'Query' } & {
  getLotUpdates: { __typename?: 'LotUpdatesListResponseObject' } & Pick<
    LotUpdatesListResponseObject,
    'success' | 'error' | 'statusCode'
  > & {
    items?: Maybe<Array<{ __typename?: 'LotUpdate' } & Pick<LotUpdate, 'id' | 'title'>>>;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type ExportLotUpdatesMutationVariables = Exact<{
  lotId: Scalars['Int'];
  exportType: LotUpdatesExportTypes;
}>;

export type ExportLotUpdatesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetPhaseNamesFromLotsQueryVariables = Exact<{
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  planId?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhaseNamesFromLotsQuery = { __typename?: 'Query' } & {
  getPhaseNamesFromLots: { __typename?: 'PhaseNamesFromLotsResponse' } & Pick<
    PhaseNamesFromLotsResponse,
    'error' | 'phaseNames'
  >;
};

export type ExportHomesMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedLotsSortFields>;
  contractDateFrom?: Maybe<Scalars['DateTime']>;
  contractDateTo?: Maybe<Scalars['DateTime']>;
  lastLoginDateFrom?: Maybe<Scalars['DateTime']>;
  lastLoginDateTo?: Maybe<Scalars['DateTime']>;
  contractCancelledDateFrom?: Maybe<Scalars['DateTime']>;
  contractCancelledDateTo?: Maybe<Scalars['DateTime']>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  planId?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  homesite?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  phasesNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: LotsExportTypes;
  requestUserTimezone: Scalars['String'];
}>;

export type ExportHomesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type ExportHomeTeamMembersMutationVariables = Exact<{
  lotId: Scalars['Int'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<TeamMembersSortFields>;
  exportType: TeamMembersExportTypes;
}>;

export type ExportHomeTeamMembersMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type CreateHomeMutationVariables = Exact<{
  createHomeInput: CreateLotInput;
}>;

export type CreateHomeMutation = { __typename?: 'Mutation' } & {
  createHome: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error' | 'success'> & {
    lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'address' | 'id'>>;
  };
};

export type UpdateHomeMutationVariables = Exact<{
  updateHomeInput: UpdateLotInput;
  id: Scalars['Int'];
}>;

export type UpdateHomeMutation = { __typename?: 'Mutation' } & {
  updateHome: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error'> & {
    lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'id' | 'address'>>;
  };
};

export type ArchiveHomeMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveHomeMutation = { __typename?: 'Mutation' } & {
  archiveHome: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error'> & {
    lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'id' | 'address'>>;
  };
};

export type DeleteHomeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteHomeMutation = { __typename?: 'Mutation' } & {
  deleteHome: { __typename?: 'LotResponse' } & Pick<LotResponse, 'error'> & {
    lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'id' | 'address'>>;
  };
};

export type UpdateHomeTeamMembersMutationVariables = Exact<{
  updateHomeTeamMembersInput: UpdateLotTeamMembersInput;
  lotId: Scalars['Int'];
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateHomeTeamMembersMutation = { __typename?: 'Mutation' } & {
  updateHomeTeamMembers: { __typename?: 'TeamMemberLotAssignmentsListResponse' } & Pick<
    TeamMemberLotAssignmentsListResponse,
    'error' | 'success'
  >;
};

export type GetBuyersWithPaginationQueryVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedBuyersSortFields>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  lotId: Scalars['Int'];
}>;

export type GetBuyersWithPaginationQuery = { __typename?: 'Query' } & {
  getBuyersWithPagination: { __typename?: 'PaginatedBuyers' } & Pick<PaginatedBuyers, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'Buyer' } & Pick<
          Buyer,
          | 'id'
          | 'activated'
          | 'lotId'
          | 'fullName'
          | 'email'
          | 'phone'
          | 'status'
          | 'type'
          | 'lastLoginDate'
        > & {
          user?: Maybe<
            { __typename?: 'User' } & Pick<User, 'id'> & {
              conversations?: Maybe<
                Array<
                  { __typename?: 'Conversation' } & Pick<Conversation, 'id' | 'status'> & {
                    lot?: Maybe<{ __typename?: 'Lot' } & Pick<Lot, 'id'>>;
                  }
                >
              >;
            }
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetBuyerByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetBuyerByIdQuery = { __typename?: 'Query' } & {
  getBuyerById: { __typename?: 'BuyerResponse' } & Pick<BuyerResponse, 'error'> & {
    buyer?: Maybe<
      { __typename?: 'Buyer' } & Pick<
        Buyer,
        | 'id'
        | 'activated'
        | 'lotId'
        | 'fullName'
        | 'firstName'
        | 'lastName'
        | 'email'
        | 'phone'
        | 'type'
        | 'relationship'
        | 'avatar'
      > & {
        user?: Maybe<
          { __typename?: 'User' } & {
            notificationsSettings?: Maybe<
              Array<
                { __typename?: 'UserNotificationSetting' } & Pick<
                  UserNotificationSetting,
                  'email' | 'text' | 'id' | 'label' | 'name'
                >
              >
            >;
          }
        >;
      }
    >;
  };
};

export type GetPageContextDataForLoginQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetPageContextDataForLoginQuery = { __typename?: 'Query' } & {
  getPageContextDataForLogin: { __typename?: 'BuyerResponse' } & Pick<BuyerResponse, 'error'> & {
    buyer?: Maybe<
      { __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'fullName' | 'firstName' | 'lastName'>
    >;
  };
};

export type ExportBuyersMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedBuyersSortFields>;
  lotId?: Maybe<Scalars['Int']>;
  exportType: BuyersExportTypes;
  requestUserTimezone: Scalars['String'];
}>;

export type ExportBuyersMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type DeleteBuyerMutationVariables = Exact<{
  id: Scalars['Int'];
  skipCheck?: Maybe<Scalars['Boolean']>;
}>;

export type DeleteBuyerMutation = { __typename?: 'Mutation' } & {
  deleteBuyer: { __typename?: 'BuyerResponse' } & Pick<BuyerResponse, 'error'> & {
    buyer?: Maybe<{ __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'fullName'>>;
  };
};

export type CreateBuyerMutationVariables = Exact<{
  lotId: Scalars['Int'];
  updateBuyerInput: UpdateBuyerInput;
}>;

export type CreateBuyerMutation = { __typename?: 'Mutation' } & {
  createBuyer: { __typename?: 'BuyerResponse' } & Pick<BuyerResponse, 'error'> & {
    buyer?: Maybe<{ __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'fullName' | 'activated'>>;
  };
};

export type UpdateBuyerMutationVariables = Exact<{
  updateBuyerInput: UpdateBuyerInput;
  buyerId: Scalars['Int'];
}>;

export type UpdateBuyerMutation = { __typename?: 'Mutation' } & {
  updateBuyer: { __typename?: 'BuyerResponse' } & Pick<BuyerResponse, 'error'> & {
    buyer?: Maybe<{ __typename?: 'Buyer' } & Pick<Buyer, 'id' | 'fullName' | 'activated'>>;
  };
};

export type SendActivationEmailMutationVariables = Exact<{
  id: Scalars['Int'];
  generateNewPassword?: Maybe<Scalars['Boolean']>;
}>;

export type SendActivationEmailMutation = { __typename?: 'Mutation' } & {
  sendActivationEmail: { __typename?: 'BuyerResponse' } & Pick<BuyerResponse, 'error'> & {
    buyer?: Maybe<{ __typename?: 'Buyer' } & Pick<Buyer, 'fullName'>>;
  };
};

export type FindNotificationsQueryVariables = Exact<{
  type?: Maybe<NotificationSettingType>;
}>;

export type FindNotificationsQuery = { __typename?: 'Query' } & {
  findNotificationsSettings: { __typename?: 'NotificationsSettingsResponse' } & Pick<
    NotificationsSettingsResponse,
    'error'
  > & {
    notificationsSettings?: Maybe<
      Array<
        { __typename?: 'NotificationSetting' } & Pick<
          NotificationSetting,
          'id' | 'name' | 'label'
        >
      >
    >;
  };
};

export type FindPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type FindPermissionsQuery = { __typename?: 'Query' } & {
  findPermissions: { __typename?: 'PermissionsResponse' } & Pick<PermissionsResponse, 'error'> & {
    permissions?: Maybe<
      Array<{ __typename?: 'Permission' } & Pick<Permission, 'id' | 'name' | 'label'>>
    >;
  };
};

export type GetPhaseTipsQueryVariables = Exact<{
  phaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhaseTipsQuery = { __typename?: 'Query' } & {
  getPhaseTips: { __typename?: 'PhaseTipsListResponse' } & Pick<PhaseTipsListResponse, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name' | 'description' | 'sequence'>
      >
    >;
  };
};

export type GetPhaseTipByIdQueryVariables = Exact<{
  phaseTipId: Scalars['Int'];
}>;

export type GetPhaseTipByIdQuery = { __typename?: 'Query' } & {
  getPhaseTipById: { __typename?: 'PhaseTipResponse' } & Pick<PhaseTipResponse, 'error'> & {
    phaseTip?: Maybe<{ __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name' | 'description'>>;
  };
};

export type GetPhaseTipsWithPaginationQueryVariables = Exact<{
  phaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AllowedPhaseTipsSortFields>;
  order?: Maybe<SortOrder>;
}>;

export type GetPhaseTipsWithPaginationQuery = { __typename?: 'Query' } & {
  getPhaseTipsWithPagination: { __typename?: 'PaginatedPhaseTips' } & Pick<
    PaginatedPhaseTips,
    'error'
  > & {
    items?: Maybe<
      Array<
        { __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name' | 'description' | 'sequence'>
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type FetchPhaseTipsCountQueryVariables = Exact<{
  phaseId: Scalars['Int'];
}>;

export type FetchPhaseTipsCountQuery = { __typename?: 'Query' } & {
  fetchPhaseTipsCount: { __typename?: 'PhaseTipsCountResponse' } & Pick<
    PhaseTipsCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'PhaseTipsCount' } & Pick<PhaseTipsCount, 'active' | 'archived'>;
  };
};

export type SearchPhaseTipsForAutoCompleteQueryVariables = Exact<{
  phaseId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<AllowedPhaseTipsSortFields>;
  order?: Maybe<SortOrder>;
}>;

export type SearchPhaseTipsForAutoCompleteQuery = { __typename?: 'Query' } & {
  getPhaseTipsWithPagination: { __typename?: 'PaginatedPhaseTips' } & Pick<
    PaginatedPhaseTips,
    'error'
  > & {
    items?: Maybe<
      Array<{ __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name' | 'description'>>
    >;
  };
};

export type UpdatePhaseTipsOrderMutationVariables = Exact<{
  phaseTipIds: Array<Scalars['Int']> | Scalars['Int'];
  phaseId: Scalars['Int'];
}>;

export type UpdatePhaseTipsOrderMutation = { __typename?: 'Mutation' } & {
  updatePhaseTipsOrder: { __typename?: 'PhaseTipsListResponse' } & Pick<
    PhaseTipsListResponse,
    'error'
  >;
};

export type UpdatePhaseTipMutationVariables = Exact<{
  updatePhaseInput: UpdatePhaseInput;
  phaseTipId: Scalars['Int'];
}>;

export type UpdatePhaseTipMutation = { __typename?: 'Mutation' } & {
  updatePhaseTip: { __typename?: 'PhaseTipResponse' } & Pick<
    PhaseTipResponse,
    'error' | 'success'
  > & { phaseTip?: Maybe<{ __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name'>> };
};

export type CreatePhaseTipMutationVariables = Exact<{
  createPhaseTipInput: CreatePhaseTipInput;
}>;

export type CreatePhaseTipMutation = { __typename?: 'Mutation' } & {
  createPhaseTip: { __typename?: 'PhaseTipResponse' } & Pick<
    PhaseTipResponse,
    'error' | 'success'
  > & { phaseTip?: Maybe<{ __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name'>> };
};

export type ArchivePhaseTipMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchivePhaseTipMutation = { __typename?: 'Mutation' } & {
  archivePhaseTip: { __typename?: 'PhaseTipResponse' } & Pick<
    PhaseTipResponse,
    'statusCode' | 'error'
  > & { phaseTip?: Maybe<{ __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name'>> };
};

export type DeletePhaseTipMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeletePhaseTipMutation = { __typename?: 'Mutation' } & {
  deletePhaseTip: { __typename?: 'PhaseTipResponse' } & Pick<
    PhaseTipResponse,
    'error' | 'statusCode'
  > & { phaseTip?: Maybe<{ __typename?: 'PhaseTip' } & Pick<PhaseTip, 'id' | 'name'>> };
};

export type ExportPhaseTipsMutationVariables = Exact<{
  phaseId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  sortBy?: Maybe<AllowedPhaseTipsSortFields>;
  order?: Maybe<SortOrder>;
  exportType: PhaseTipsExportTypes;
}>;

export type ExportPhaseTipsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetPhasesQueryVariables = Exact<{
  divisionId?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<AllowedPhasesSortFields>;
  order?: Maybe<SortOrder>;
}>;

export type GetPhasesQuery = { __typename?: 'Query' } & {
  getPhases: { __typename?: 'PhasesListResponse' } & Pick<
    PhasesListResponse,
    'error' | 'success'
  > & { items?: Maybe<Array<{ __typename?: 'Phase' } & PhaseCoreFragment>> };
};

export type GetPhaseNamesQueryVariables = Exact<{
  divisionId?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhaseNamesQuery = { __typename?: 'Query' } & {
  getPhases: { __typename?: 'PhasesListResponse' } & Pick<
    PhasesListResponse,
    'error' | 'success'
  > & { items?: Maybe<Array<{ __typename?: 'Phase' } & Pick<Phase, 'name'>>> };
};

export type GetPhasesByLotIdQueryVariables = Exact<{
  lotId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhasesByLotIdQuery = { __typename?: 'Query' } & {
  getPhases: { __typename?: 'PhasesListResponse' } & Pick<
    PhasesListResponse,
    'error' | 'success'
  > & { items?: Maybe<Array<{ __typename?: 'Phase' } & PhaseCoreFragment>> };
};

export type GetPhasesWithPaginationQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  divisionId: Scalars['Int'];
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhasesSortFields>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPhasesWithPaginationQuery = { __typename?: 'Query' } & {
  getPhasesWithPagination: { __typename?: 'PaginatedPhases' } & Pick<
    PaginatedPhases,
    'error' | 'success'
  > & {
    items?: Maybe<Array<{ __typename?: 'Phase' } & PhaseCoreFragment>>;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetPhaseByIdQueryVariables = Exact<{
  phaseId: Scalars['Int'];
}>;

export type GetPhaseByIdQuery = { __typename?: 'Query' } & {
  getPhaseById: { __typename?: 'PhaseResponse' } & Pick<PhaseResponse, 'error' | 'success'> & {
    phase?: Maybe<
      { __typename?: 'Phase' } & Pick<Phase, 'videoPreviewImage'> & PhaseCoreFragment
    >;
  };
};

export type FetchPhasesCountQueryVariables = Exact<{
  divisionId: Scalars['Int'];
}>;

export type FetchPhasesCountQuery = { __typename?: 'Query' } & {
  fetchPhasesCount: { __typename?: 'PhasesCountResponse' } & Pick<PhasesCountResponse, 'error'> & {
    statsCount: { __typename?: 'PhasesCount' } & Pick<PhasesCount, 'active' | 'archived'>;
  };
};

export type GetDefaultPhasesQueryVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetDefaultPhasesQuery = { __typename?: 'Query' } & {
  getDefaultPhases: { __typename?: 'DefaultPhasesListResponse' } & Pick<
    DefaultPhasesListResponse,
    'error' | 'success'
  > & { items?: Maybe<Array<{ __typename?: 'DefaultPhase' } & DefaultPhaseCoreFragment>> };
};

export type GetDefaultPhasesWithPaginationQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPhasesSortFields>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetDefaultPhasesWithPaginationQuery = { __typename?: 'Query' } & {
  getDefaultPhasesWithPagination: { __typename?: 'PaginatedDefaultPhases' } & Pick<
    PaginatedDefaultPhases,
    'error' | 'success'
  > & {
    items?: Maybe<Array<{ __typename?: 'DefaultPhase' } & DefaultPhaseCoreFragment>>;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type GetDefaultPhaseByIdQueryVariables = Exact<{
  defaultPhaseId: Scalars['Int'];
}>;

export type GetDefaultPhaseByIdQuery = { __typename?: 'Query' } & {
  getDefaultPhaseById: { __typename?: 'DefaultPhaseResponseObject' } & Pick<
    DefaultPhaseResponseObject,
    'error' | 'success'
  > & {
    defaultPhase?: Maybe<
      { __typename?: 'DefaultPhase' } & Pick<DefaultPhase, 'videoPreviewImage'> &
      DefaultPhaseCoreFragment
    >;
  };
};

export type FetchDefaultPhasesCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchDefaultPhasesCountQuery = { __typename?: 'Query' } & {
  fetchDefaultPhasesCount: { __typename?: 'DefaultPhasesCountResponse' } & Pick<
    DefaultPhasesCountResponse,
    'error'
  > & {
    statsCount: { __typename?: 'DefaultPhasesCount' } & Pick<
      DefaultPhasesCount,
      'active' | 'archived'
    >;
  };
};

export type CreatePhaseMutationVariables = Exact<{
  createPhaseInput: CreatePhaseInput;
}>;

export type CreatePhaseMutation = { __typename?: 'Mutation' } & {
  createPhase: { __typename?: 'PhaseResponse' } & Pick<PhaseResponse, 'error' | 'success'>;
};

export type UpdatePhaseMutationVariables = Exact<{
  updatePhaseInput: UpdatePhaseInput;
  phaseId: Scalars['Int'];
}>;

export type UpdatePhaseMutation = { __typename?: 'Mutation' } & {
  updatePhase: { __typename?: 'PhaseResponse' } & Pick<PhaseResponse, 'error' | 'success'> & {
    phase?: Maybe<
      { __typename?: 'Phase' } & Pick<Phase, 'videoPreviewImage'> & PhaseCoreFragment
    >;
  };
};

export type UpdatePhasesOrderMutationVariables = Exact<{
  phaseIds: Array<Scalars['Int']> | Scalars['Int'];
  divisionId: Scalars['Int'];
}>;

export type UpdatePhasesOrderMutation = { __typename?: 'Mutation' } & {
  updatePhasesOrder: { __typename?: 'PhasesListResponse' } & Pick<
    PhasesListResponse,
    'error' | 'success'
  > & { items?: Maybe<Array<{ __typename?: 'Phase' } & PhaseCoreFragment>> };
};

export type DeletePhaseMutationVariables = Exact<{
  phaseId: Scalars['Int'];
}>;

export type DeletePhaseMutation = { __typename?: 'Mutation' } & {
  deletePhase: { __typename?: 'PhaseResponse' } & Pick<PhaseResponse, 'error' | 'success'>;
};

export type ArchivePhaseMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchivePhaseMutation = { __typename?: 'Mutation' } & {
  archivePhase: { __typename?: 'PhaseResponse' } & Pick<PhaseResponse, 'error'> & {
    phase?: Maybe<{ __typename?: 'Phase' } & Pick<Phase, 'id' | 'name'>>;
  };
};

export type ExportPhasesMutationVariables = Exact<{
  divisionId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  exportType: PhasesExportTypes;
}>;

export type ExportPhasesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type CreateDefaultPhaseMutationVariables = Exact<{
  createDefaultPhaseInput: CreateDefaultPhaseInput;
}>;

export type CreateDefaultPhaseMutation = { __typename?: 'Mutation' } & {
  createDefaultPhase: { __typename?: 'DefaultPhaseResponseObject' } & Pick<
    DefaultPhaseResponseObject,
    'error' | 'success'
  >;
};

export type UpdateDefaultPhaseMutationVariables = Exact<{
  updateDivisionPhases?: Maybe<Scalars['Boolean']>;
  updateDefaultPhaseInput: UpdateDefaultPhaseInput;
  defaultPhaseId: Scalars['Int'];
}>;

export type UpdateDefaultPhaseMutation = { __typename?: 'Mutation' } & {
  updateDefaultPhase: { __typename?: 'DefaultPhaseResponseObject' } & Pick<
    DefaultPhaseResponseObject,
    'error' | 'success'
  > & {
    defaultPhase?: Maybe<
      { __typename?: 'DefaultPhase' } & Pick<DefaultPhase, 'videoPreviewImage'> &
      DefaultPhaseCoreFragment
    >;
  };
};

export type UpdateDefaultPhasesOrderMutationVariables = Exact<{
  defaultPhaseIds: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type UpdateDefaultPhasesOrderMutation = { __typename?: 'Mutation' } & {
  updateDefaultPhasesOrder: { __typename?: 'DefaultPhasesListResponse' } & Pick<
    DefaultPhasesListResponse,
    'error' | 'success'
  > & { items?: Maybe<Array<{ __typename?: 'DefaultPhase' } & DefaultPhaseCoreFragment>> };
};

export type DeleteDefaultPhaseMutationVariables = Exact<{
  deleteDivisionPhases?: Maybe<Scalars['Boolean']>;
  defaultPhaseId: Scalars['Int'];
}>;

export type DeleteDefaultPhaseMutation = { __typename?: 'Mutation' } & {
  deleteDefaultPhase: { __typename?: 'DefaultPhaseResponseObject' } & Pick<
    DefaultPhaseResponseObject,
    'error' | 'success'
  >;
};

export type ArchiveDefaultPhaseMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveDefaultPhaseMutation = { __typename?: 'Mutation' } & {
  archiveDefaultPhase: { __typename?: 'DefaultPhaseResponseObject' } & Pick<
    DefaultPhaseResponseObject,
    'error'
  > & { defaultPhase?: Maybe<{ __typename?: 'DefaultPhase' } & Pick<DefaultPhase, 'id' | 'name'>> };
};

export type ExportDefaultPhasesMutationVariables = Exact<{
  archived?: Maybe<Scalars['Boolean']>;
  exportType: PhasesExportTypes;
}>;

export type ExportDefaultPhasesMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type GetPlansWithPaginationQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPlansSortFields>;
  archived?: Maybe<Scalars['Boolean']>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  hasElevations?: Maybe<Scalars['Boolean']>;
}>;

export type GetPlansWithPaginationQuery = { __typename?: 'Query' } & {
  getPlansWithPagination: { __typename?: 'PaginatedPlan' } & Pick<PaginatedPlan, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'Plan' } & Pick<Plan, 'name' | 'id' | 'elevationsCount' | 'editable'> & {
          communities?: Maybe<
            Array<
              Maybe<
                { __typename?: 'Community' } & Pick<Community, 'name'> & {
                  division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'name'>>;
                }
              >
            >
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type SearchPlansForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPlansSortFields>;
}>;

export type SearchPlansForAutoCompleteQuery = { __typename?: 'Query' } & {
  getPlansWithPagination: { __typename?: 'PaginatedPlan' } & Pick<PaginatedPlan, 'error'> & {
    items?: Maybe<Array<{ __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'>>>;
  };
};

export type GetPlansQueryVariables = Exact<{
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  withElevations?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type GetPlansQuery = { __typename?: 'Query' } & {
  getPlans: { __typename?: 'PlanListResponse' } & Pick<PlanListResponse, 'error'> & {
    plans?: Maybe<
      Array<
        { __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'> & {
          communities?: Maybe<
            Array<Maybe<{ __typename?: 'Community' } & Pick<Community, 'id'>>>
          >;
          elevations?: Maybe<
            { __typename?: 'Elevation' } & Pick<
              Elevation,
              'id' | 'name' | 'imageUrl' | 'status'
            >
          >;
        }
      >
    >;
  };
};

export type FindPlanByIdQueryVariables = Exact<{
  planId: Scalars['Int'];
}>;

export type FindPlanByIdQuery = { __typename?: 'Query' } & {
  findPlanById: { __typename?: 'PlanResponse' } & Pick<PlanResponse, 'error' | 'success'> & {
    plan?: Maybe<
      { __typename?: 'Plan' } & Pick<Plan, 'name' | 'id'> & {
        communities?: Maybe<Array<Maybe<{ __typename?: 'Community' } & Pick<Community, 'id'>>>>;
      }
    >;
  };
};

export type GetPageContextDataForPlanQueryVariables = Exact<{
  planId: Scalars['Int'];
}>;

export type GetPageContextDataForPlanQuery = { __typename?: 'Query' } & {
  getPageContextDataForPlan: { __typename?: 'PlanResponse' } & Pick<PlanResponse, 'error'> & {
    plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'>>;
  };
};

export type GetPlansCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlansCountQuery = { __typename?: 'Query' } & {
  getPlansCount: { __typename?: 'PlansCountResponse' } & Pick<PlansCountResponse, 'error'> & {
    statsCount: { __typename?: 'PlansCount' } & Pick<PlansCount, 'active' | 'archived'>;
  };
};

export type DeletePlanMutationVariables = Exact<{
  planId: Scalars['Int'];
}>;

export type DeletePlanMutation = { __typename?: 'Mutation' } & {
  deletePlan: { __typename?: 'PlanResponse' } & Pick<PlanResponse, 'success' | 'error'> & {
    plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'name' | 'status'>>;
  };
};

export type ArchivePlanMutationVariables = Exact<{
  planId: Scalars['Int'];
  archive: Scalars['Boolean'];
}>;

export type ArchivePlanMutation = { __typename?: 'Mutation' } & {
  archivePlan: { __typename?: 'PlanResponse' } & Pick<PlanResponse, 'success' | 'error'> & {
    plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'name' | 'status'>>;
  };
};

export type CreatePlanMutationVariables = Exact<{
  createPlanInput: CreatePlanInput;
}>;

export type CreatePlanMutation = { __typename?: 'Mutation' } & {
  createPlan: { __typename?: 'PlanResponse' } & Pick<PlanResponse, 'error' | 'success'> & {
    plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'>>;
  };
};

export type UpdatePlanMutationVariables = Exact<{
  planId: Scalars['Int'];
  updatePlanInput: UpdatePlanInput;
}>;

export type UpdatePlanMutation = { __typename?: 'Mutation' } & {
  updatePlan: { __typename?: 'PlanResponse' } & Pick<PlanResponse, 'error' | 'success'> & {
    plan?: Maybe<{ __typename?: 'Plan' } & Pick<Plan, 'id' | 'name'>>;
  };
};

export type FindElevationsPaginatedQueryVariables = Exact<{
  planId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;

export type FindElevationsPaginatedQuery = { __typename?: 'Query' } & {
  findElevationsPaginated: { __typename?: 'PaginatedElevations' } & Pick<
    PaginatedElevations,
    'error' | 'success'
  > & {
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
    items?: Maybe<
      Array<
        { __typename?: 'Elevation' } & Pick<Elevation, 'id' | 'name' | 'sequence' | 'imageUrl'>
      >
    >;
  };
};

export type FetchElevationsCountQueryVariables = Exact<{
  planId: Scalars['Int'];
}>;

export type FetchElevationsCountQuery = { __typename?: 'Query' } & {
  fetchElevationsCount: { __typename?: 'ElevationsCountResponse' } & Pick<
    ElevationsCountResponse,
    'error' | 'success'
  > & {
    statsCount: { __typename?: 'ElevationsCount' } & Pick<ElevationsCount, 'active' | 'archived'>;
  };
};

export type FindElevationQueryVariables = Exact<{
  elevationId: Scalars['Int'];
}>;

export type FindElevationQuery = { __typename?: 'Query' } & {
  findElevation: { __typename?: 'ElevationResponse' } & Pick<
    ElevationResponse,
    'success' | 'error'
  > & { elevation?: Maybe<{ __typename?: 'Elevation' } & Pick<Elevation, 'name' | 'imageUrl'>> };
};

export type ExportPlansMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedPlansSortFields>;
  archived?: Maybe<Scalars['Boolean']>;
  divisionIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communityIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  hasElevations?: Maybe<Scalars['Boolean']>;
  exportType: PlansExportTypes;
}>;

export type ExportPlansMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type RemoveElevationsMutationVariables = Exact<{
  elevationsIds: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type RemoveElevationsMutation = { __typename?: 'Mutation' } & {
  removeElevations: { __typename?: 'ElevationsListResponse' } & Pick<
    ElevationsListResponse,
    'error' | 'success'
  > & { elevations?: Maybe<Array<{ __typename?: 'Elevation' } & Pick<Elevation, 'name'>>> };
};

export type ArchiveElevationMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  elevationId: Scalars['Int'];
}>;

export type ArchiveElevationMutation = { __typename?: 'Mutation' } & {
  archiveElevation: { __typename?: 'ElevationResponse' } & Pick<
    ElevationResponse,
    'success' | 'error'
  > & { elevation?: Maybe<{ __typename?: 'Elevation' } & Pick<Elevation, 'name' | 'status'>> };
};

export type UpdateElevationMutationVariables = Exact<{
  updateElevationInput: UpdateElevationInput;
  elevationId: Scalars['Int'];
}>;

export type UpdateElevationMutation = { __typename?: 'Mutation' } & {
  updateElevation: { __typename?: 'ElevationResponse' } & Pick<
    ElevationResponse,
    'error' | 'success'
  >;
};

export type UpdateElevationsOrderMutationVariables = Exact<{
  elevationsIds: Array<Scalars['Int']> | Scalars['Int'];
  planId: Scalars['Int'];
}>;

export type UpdateElevationsOrderMutation = { __typename?: 'Mutation' } & {
  updateElevationsOrder: { __typename?: 'ElevationsListResponse' } & Pick<
    ElevationsListResponse,
    'error' | 'success'
  >;
};

export type CreateElevationsMutationVariables = Exact<{
  createElevationInput: Array<CreateElevationInput> | CreateElevationInput;
  planId: Scalars['Int'];
}>;

export type CreateElevationsMutation = { __typename?: 'Mutation' } & {
  createElevations: { __typename?: 'ElevationsListResponse' } & Pick<
    ElevationsListResponse,
    'success' | 'error'
  > & { elevations?: Maybe<Array<{ __typename?: 'Elevation' } & Pick<Elevation, 'name'>>> };
};

export type ExportElevationsMutationVariables = Exact<{
  planId: Scalars['Int'];
  archived?: Maybe<Scalars['Boolean']>;
  exportType: ElevationsExportTypes;
}>;

export type ExportElevationsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type FetchProfileQueryVariables = Exact<{ [key: string]: never }>;

export type FetchProfileQuery = { __typename?: 'Query' } & {
  fetchProfile: { __typename?: 'UserResponse' } & Pick<UserResponse, 'success' | 'error'> & {
    user?: Maybe<
      { __typename?: 'User' } & Pick<
        User,
        'id' | 'firstName' | 'lastName' | 'email' | 'jobTitle' | 'phone' | 'avatar' | 'workPhone'
      > & {
        teamMember?: Maybe<
          { __typename?: 'TeamMember' } & Pick<
            TeamMember,
            'id' | 'groupName' | 'groupMembersNames'
          >
        >;
        permissions?: Maybe<
          Array<{ __typename?: 'Permission' } & Pick<Permission, 'id' | 'name' | 'label'>>
        >;
        role?: Maybe<{ __typename?: 'Role' } & Pick<Role, 'name' | 'label'>>;
        homepage?: Maybe<
          { __typename?: 'Permission' } & Pick<Permission, 'label' | 'name' | 'id'>
        >;
        notificationsSettings?: Maybe<
          Array<
            { __typename?: 'UserNotificationSetting' } & Pick<
              UserNotificationSetting,
              'email' | 'text' | 'name' | 'label'
            >
          >
        >;
        app?: Maybe<{ __typename?: 'App' } & Pick<App, 'name'>>;
      }
    >;
  };
};

export type UpdateProfileMutationVariables = Exact<{
  updateProfileInput: UpdateProfileInput;
}>;

export type UpdateProfileMutation = { __typename?: 'Mutation' } & {
  updateProfile: { __typename?: 'UserResponse' } & Pick<UserResponse, 'success' | 'error'> & {
    user?: Maybe<
      { __typename?: 'User' } & Pick<
        User,
        'firstName' | 'lastName' | 'email' | 'jobTitle' | 'phone' | 'avatar' | 'workPhone'
      > & {
        teamMember?: Maybe<
          { __typename?: 'TeamMember' } & Pick<
            TeamMember,
            'id' | 'groupName' | 'groupMembersNames'
          >
        >;
        role?: Maybe<{ __typename?: 'Role' } & Pick<Role, 'name' | 'label'>>;
        homepage?: Maybe<
          { __typename?: 'Permission' } & Pick<Permission, 'label' | 'name' | 'id'>
        >;
        notificationsSettings?: Maybe<
          Array<
            { __typename?: 'UserNotificationSetting' } & Pick<
              UserNotificationSetting,
              'email' | 'text' | 'name' | 'label'
            >
          >
        >;
      }
    >;
  };
};

export type UpdateContactProfileMutationVariables = Exact<{
  updateContactProfileInput: UpdateGroupContactProfileInput;
}>;

export type UpdateContactProfileMutation = { __typename?: 'Mutation' } & {
  updateContactProfile: { __typename?: 'TeamMemberResponse' } & Pick<
    TeamMemberResponse,
    'success' | 'error'
  >;
};

export type ChangePasswordMutationVariables = Exact<{
  setPasswordInput?: Maybe<SetPasswordInput>;
}>;

export type ChangePasswordMutation = { __typename?: 'Mutation' } & {
  changePassword: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error' | 'success'>;
};

export type GetReportsQueryVariables = Exact<{
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  date?: Maybe<Scalars['String']>;
}>;

export type GetReportsQuery = { __typename?: 'Query' } & {
  getReports: { __typename?: 'ReportsResponse' } & {
    totalHomeownerAccounts?: Maybe<
      Array<
        { __typename?: 'TotalHomeownerAccounts' } & Pick<
          TotalHomeownerAccounts,
          'name' | 'id' | 'activeLogins' | 'totalHomes'
        >
      >
    >;
    totalHomesByConstructionPhase?: Maybe<
      Array<
        { __typename?: 'TotalHomesByConstructionPhase' } & Pick<
          TotalHomesByConstructionPhase,
          'name' | 'id'
        > & {
          items: Array<
            { __typename?: 'TotalHomesByConstructionPhaseItem' } & Pick<
              TotalHomesByConstructionPhaseItem,
              'name' | 'id' | 'count'
            >
          >;
        }
      >
    >;
  };
};

export type ExportReportsMutationVariables = Exact<{
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  phaseNames?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  charts?: Maybe<Array<ReportChartInput> | ReportChartInput>;
  exportType: ReportsExportTypes;
}>;

export type ExportReportsMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type FindUsersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedUsersSortFields>;
  rolesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
}>;

export type FindUsersQuery = { __typename?: 'Query' } & {
  findUsers: { __typename?: 'PaginatedUser' } & Pick<PaginatedUser, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'User' } & Pick<
          User,
          'id' | 'firstName' | 'lastName' | 'email' | 'phone' | 'jobTitle' | 'initialPasswordSet'
        > & {
          role?: Maybe<{ __typename?: 'Role' } & Pick<Role, 'label'>>;
          divisions?: Maybe<Array<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>>;
          communities?: Maybe<
            Array<
              { __typename?: 'Community' } & Pick<Community, 'id'> & {
                division?: Maybe<{ __typename?: 'Division' } & Pick<Division, 'id' | 'name'>>;
              }
            >
          >;
        }
      >
    >;
    meta?: Maybe<{ __typename?: 'PaginationMeta' } & PaginationCoreInfoFragment>;
  };
};

export type SearchUsersForAutoCompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  includeSelf?: Maybe<Scalars['Boolean']>;
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedUsersSortFields>;
}>;

export type SearchUsersForAutoCompleteQuery = { __typename?: 'Query' } & {
  findUsers: { __typename?: 'PaginatedUser' } & Pick<PaginatedUser, 'error'> & {
    items?: Maybe<
      Array<
        { __typename?: 'User' } & Pick<
          User,
          | 'id'
          | 'fullName'
          | 'firstName'
          | 'lastName'
          | 'email'
          | 'jobTitle'
          | 'phone'
          | 'workPhone'
        >
      >
    >;
  };
};

export type FindUserByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type FindUserByIdQuery = { __typename?: 'Query' } & {
  findUserById: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error'> & {
    user?: Maybe<
      { __typename?: 'User' } & Pick<
        User,
        | 'id'
        | 'firstName'
        | 'lastName'
        | 'fullName'
        | 'email'
        | 'jobTitle'
        | 'phone'
        | 'workPhone'
        | 'avatar'
      > & {
        role?: Maybe<{ __typename?: 'Role' } & Pick<Role, 'id' | 'label'>>;
        divisions?: Maybe<Array<{ __typename?: 'Division' } & Pick<Division, 'id'>>>;
        communities?: Maybe<Array<{ __typename?: 'Community' } & Pick<Community, 'id'>>>;
        permissions?: Maybe<Array<{ __typename?: 'Permission' } & Pick<Permission, 'id'>>>;
        notificationsSettings?: Maybe<
          Array<
            { __typename?: 'UserNotificationSetting' } & Pick<
              UserNotificationSetting,
              'email' | 'text' | 'id' | 'label' | 'name'
            >
          >
        >;
      }
    >;
  };
};

export type FindRolesQueryVariables = Exact<{ [key: string]: never }>;

export type FindRolesQuery = { __typename?: 'Query' } & {
  findRoles: { __typename?: 'RolesResponse' } & Pick<RolesResponse, 'error'> & {
    roles?: Maybe<Array<{ __typename?: 'Role' } & Pick<Role, 'id' | 'label'>>>;
  };
};

export type FetchUsersCountQueryVariables = Exact<{ [key: string]: never }>;

export type FetchUsersCountQuery = { __typename?: 'Query' } & {
  fetchUsersCount: { __typename?: 'UsersCountResponse' } & Pick<UsersCountResponse, 'error'> & {
    statsCount: { __typename?: 'UsersCount' } & Pick<UsersCount, 'active' | 'archived'>;
  };
};

export type ValidateUserCommunityAssignmentsQueryVariables = Exact<{
  divisionId: Scalars['Int'];
}>;

export type ValidateUserCommunityAssignmentsQuery = { __typename?: 'Query' } & {
  validateUserCommunityAssignments: { __typename?: 'UsersCommunityAssignemntsResponse' } & Pick<
    UsersCommunityAssignemntsResponse,
    'hasAtLeastOneUserWithAllCommunityAssignments'
  >;
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteUserMutation = { __typename?: 'Mutation' } & {
  deleteUser: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error'> & {
    user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>>;
  };
};

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;

export type CreateUserMutation = { __typename?: 'Mutation' } & {
  createUser: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error'> & {
    user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>>;
  };
};

export type ArchiveUserMutationVariables = Exact<{
  archive: Scalars['Boolean'];
  id: Scalars['Int'];
}>;

export type ArchiveUserMutation = { __typename?: 'Mutation' } & {
  archiveUser: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error'> & {
    user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>>;
  };
};

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
  id: Scalars['Int'];
}>;

export type UpdateUserMutation = { __typename?: 'Mutation' } & {
  updateUser: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error'> & {
    user?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'firstName' | 'lastName'>>;
  };
};

export type SendWelcomeEmailMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type SendWelcomeEmailMutation = { __typename?: 'Mutation' } & {
  sendWelcomeEmail: { __typename?: 'UserResponse' } & Pick<UserResponse, 'error'> & {
    user?: Maybe<{ __typename?: 'User' } & Pick<User, 'fullName'>>;
  };
};

export type ExportUsersMutationVariables = Exact<{
  order?: Maybe<SortOrder>;
  sortBy?: Maybe<AllowedUsersSortFields>;
  rolesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  divisionsIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  communitiesIds?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  exportType: UsersExportTypes;
}>;

export type ExportUsersMutation = { __typename?: 'Mutation' } & {
  exportResponse: { __typename?: 'ExportResultResponse' } & Pick<
    ExportResultResponse,
    'error' | 'content'
  >;
};

export type FindUsersForContactAutocompleteQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['Int']>;
  action?: Maybe<DivisionAction>;
  withoutContacts?: Maybe<Scalars['Boolean']>;
}>;

export type FindUsersForContactAutocompleteQuery = { __typename?: 'Query' } & {
  findUsersForContactAutocomplete: { __typename?: 'UsersResponse' } & Pick<
    UsersResponse,
    'error'
  > & {
    users?: Maybe<
      Array<
        { __typename?: 'User' } & Pick<
          User,
          | 'id'
          | 'firstName'
          | 'lastName'
          | 'jobTitle'
          | 'fullName'
          | 'email'
          | 'phone'
          | 'workPhone'
        >
      >
    >;
  };
};

export const BuyerCoreFragmentDoc = gql`
  fragment BuyerCore on Buyer {
    id
    fullName
    role {
      name
      label
    }
  }
`;
export const TeamMemberCoreFragmentDoc = gql`
  fragment TeamMemberCore on TeamMember {
    id
    fullName
  }
`;
export const PaginationCoreInfoFragmentDoc = gql`
  fragment PaginationCoreInfo on PaginationMeta {
    totalItems
  }
`;
export const PhaseCoreFragmentDoc = gql`
  fragment PhaseCore on Phase {
    id
    sequence
    name
    description
    videoUrl
  }
`;
export const DefaultPhaseCoreFragmentDoc = gql`
  fragment DefaultPhaseCore on DefaultPhase {
    id
    sequence
    name
    description
    videoUrl
    divisionPhases {
      division {
        name
      }
    }
  }
`;
export const LoginDocument = gql`
  query login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      error
      success
      statusCode
      user {
        permissions {
          name
        }
        homepage {
          name
        }
      }
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
  document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginWithSsoDocument = gql`
  query loginWithSso($loginWithSsoInput: LoginWithSsoInput!) {
    loginWithSso(loginWithSsoInput: $loginWithSsoInput) {
      error
      success
      statusCode
      user {
        permissions {
          name
        }
        homepage {
          name
        }
      }
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class LoginWithSsoGQL extends Apollo.Query<LoginWithSsoQuery, LoginWithSsoQueryVariables> {
  document = LoginWithSsoDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RefreshTokensDocument = gql`
  query refreshTokens($refreshToken: String!) {
    refreshTokens(refreshToken: $refreshToken) {
      error
      success
      statusCode
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RefreshTokensGQL extends Apollo.Query<
  RefreshTokensQuery,
  RefreshTokensQueryVariables
> {
  document = RefreshTokensDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ConfirmPasswordResetRequestDocument = gql`
  mutation confirmPasswordResetRequest($confirmPasswordResetInput: ConfirmPasswordResetInput!) {
    confirmPasswordResetRequest(confirmPasswordResetInput: $confirmPasswordResetInput) {
      success
      error
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ConfirmPasswordResetRequestGQL extends Apollo.Mutation<
  ConfirmPasswordResetRequestMutation,
  ConfirmPasswordResetRequestMutationVariables
> {
  document = ConfirmPasswordResetRequestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePasswordResetRequestDocument = gql`
  mutation createPasswordResetRequest($createPasswordResetRequest: CreatePasswordResetInput!) {
    createPasswordResetRequest(createPasswordResetInput: $createPasswordResetRequest) {
      success
      error
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreatePasswordResetRequestGQL extends Apollo.Mutation<
  CreatePasswordResetRequestMutation,
  CreatePasswordResetRequestMutationVariables
> {
  document = CreatePasswordResetRequestDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindConversationsPaginatedDocument = gql`
  query findConversationsPaginated(
    $order: SortOrder
    $archived: Boolean
    $sortBy: ConversationsSortFields
    $page: Int
    $limit: Int
    $buyerName: String
    $address: String
    $contactName: String
    $start: DateTime
    $end: DateTime
    $divisionIds: [Int!]
    $communityIds: [Int!]
  ) {
    findConversationsPaginated(
      order: $order
      sortBy: $sortBy
      archived: $archived
      page: $page
      limit: $limit
      buyerName: $buyerName
      address: $address
      contactName: $contactName
      start: $start
      end: $end
      divisionIds: $divisionIds
      communityIds: $communityIds
    ) {
      error
      items {
        id
        lastMessageCreatedAt
        buyerUser {
          id
          fullName
        }
        lot {
          address
          community {
            id
            name
            division {
              id
              name
            }
          }
        }
        teamMember {
          groupName
          user {
            id
            role {
              label
            }
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindConversationsPaginatedGQL extends Apollo.Query<
  FindConversationsPaginatedQuery,
  FindConversationsPaginatedQueryVariables
> {
  document = FindConversationsPaginatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetConversationsCountDocument = gql`
  query getConversationsCount {
    getConversationsCount {
      error
      statsCount: conversationsCount {
        active
        archived: resolved
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetConversationsCountGQL extends Apollo.Query<
  GetConversationsCountQuery,
  GetConversationsCountQueryVariables
> {
  document = GetConversationsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindConversationsDocument = gql`
  query findConversations(
    $buyerName: String
    $archived: Boolean
    $address: String
    $contactName: String
    $order: SortOrder = asc
    $sortBy: ConversationsSortFields = buyerName
  ) {
    findConversations(
      buyerName: $buyerName
      address: $address
      archived: $archived
      contactName: $contactName
      order: $order
      sortBy: $sortBy
    ) {
      error
      conversations {
        lot {
          address
        }
        teamMember {
          groupName
        }
        buyerUser {
          fullName
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindConversationsGQL extends Apollo.Query<
  FindConversationsQuery,
  FindConversationsQueryVariables
> {
  document = FindConversationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindConversationByIdDocument = gql`
  query findConversationById($conversationId: Int!) {
    findConversationById(conversationId: $conversationId) {
      error
      conversation {
        id
        sid
        status
        teamMember {
          user {
            id
            conversationUser {
              identity
            }
          }
        }
        buyerUser {
          id
          fullName
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindConversationByIdGQL extends Apollo.Query<
  FindConversationByIdQuery,
  FindConversationByIdQueryVariables
> {
  document = FindConversationByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveConversationDocument = gql`
  mutation removeConversation($conversationId: Int) {
    removeConversation(conversationId: $conversationId) {
      error
      conversation {
        buyerUser {
          fullName
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RemoveConversationGQL extends Apollo.Mutation<
  RemoveConversationMutation,
  RemoveConversationMutationVariables
> {
  document = RemoveConversationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportConversationsDocument = gql`
  mutation exportConversations(
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $archived: Boolean
    $buyerName: String
    $start: DateTime
    $end: DateTime
    $order: SortOrder
    $sortBy: ConversationsSortFields
    $exportType: ConversationExportType!
  ) {
    exportResponse: exportConversations(
      divisionIds: $divisionIds
      communityIds: $communityIds
      archived: $archived
      buyerName: $buyerName
      start: $start
      end: $end
      order: $order
      sortBy: $sortBy
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportConversationsGQL extends Apollo.Mutation<
  ExportConversationsMutation,
  ExportConversationsMutationVariables
> {
  document = ExportConversationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendConversationMessageForCmsAppDocument = gql`
  mutation sendConversationMessageForCMSApp(
    $createConversationMessageInput: CreateConversationMessageInput!
    $lotId: Int!
    $buyerId: Int!
  ) {
    sendConversationMessageForCMSApp(
      createConversationMessageInput: $createConversationMessageInput
      lotId: $lotId
      buyerId: $buyerId
    ) {
      error
      success
      statusCode
      conversation {
        id
        sid
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SendConversationMessageForCmsAppGQL extends Apollo.Mutation<
  SendConversationMessageForCmsAppMutation,
  SendConversationMessageForCmsAppMutationVariables
> {
  document = SendConversationMessageForCmsAppDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetChatTokenForConversationDocument = gql`
  query getChatTokenForConversation($conversationId: Int!) {
    getChatTokenForConversation: getTwilioTokenForConversation(conversationId: $conversationId) {
      error
      accessToken
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetChatTokenForConversationGQL extends Apollo.Query<
  GetChatTokenForConversationQuery,
  GetChatTokenForConversationQueryVariables
> {
  document = GetChatTokenForConversationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindCommunitiesDocument = gql`
  query findCommunities(
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedCommunitiesSortFields = name
  ) {
    findCommunities(archived: $archived, order: $order, sortBy: $sortBy) {
      error
      communities {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindCommunitiesGQL extends Apollo.Query<
  FindCommunitiesQuery,
  FindCommunitiesQueryVariables
> {
  document = FindCommunitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunitiesDocument = gql`
  query getCommunities(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: AllowedCommunitiesSortFields
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $city: String
    $statesIds: [Int!]
    $archived: Boolean
  ) {
    getCommunities(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      city: $city
      statesIds: $statesIds
      archived: $archived
    ) {
      error
      items {
        id
        name
        city
        division {
          id
          name
        }
        state {
          id
          label
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetCommunitiesGQL extends Apollo.Query<
  GetCommunitiesQuery,
  GetCommunitiesQueryVariables
> {
  document = GetCommunitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchCommunitiesForAutoCompleteDocument = gql`
  query searchCommunitiesForAutoComplete(
    $city: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedCommunitiesSortFields = name
  ) {
    getCommunities(city: $city, archived: $archived, order: $order, sortBy: $sortBy) {
      error
      items {
        id
        name
        city
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchCommunitiesForAutoCompleteGQL extends Apollo.Query<
  SearchCommunitiesForAutoCompleteQuery,
  SearchCommunitiesForAutoCompleteQueryVariables
> {
  document = SearchCommunitiesForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunityDefaultTeamMembersIdsDocument = gql`
  query getCommunityDefaultTeamMembersIds($communityId: Int!) {
    getCommunityDefaultTeamMembersIds(communityId: $communityId) {
      error
      success
      teamMemberIds
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetCommunityDefaultTeamMembersIdsGQL extends Apollo.Query<
  GetCommunityDefaultTeamMembersIdsQuery,
  GetCommunityDefaultTeamMembersIdsQueryVariables
> {
  document = GetCommunityDefaultTeamMembersIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindCommunityTeamMembersDocument = gql`
  query findCommunityTeamMembers(
    $communityId: Int!
    $contactTypesIds: [Int!]
    $affiliation: ContactAffiliation
    $companiesIds: [Int!]
    $name: String
    $jobTitle: String
    $email: String
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: TeamMembersSortFields
    $getAll: Boolean
    $archived: Boolean
  ) {
    findCommunityTeamMembers(
      communityId: $communityId
      contactTypesIds: $contactTypesIds
      affiliation: $affiliation
      companiesIds: $companiesIds
      name: $name
      jobTitle: $jobTitle
      email: $email
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      getAll: $getAll
      archived: $archived
    ) {
      error
      success
      items {
        id
        fullName
        title
        type {
          label
        }
        affiliation
        company {
          name
        }
        email
        mobilePhone
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindCommunityTeamMembersGQL extends Apollo.Query<
  FindCommunityTeamMembersQuery,
  FindCommunityTeamMembersQueryVariables
> {
  document = FindCommunityTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindCommunityByIdDocument = gql`
  query findCommunityById($id: Int!) {
    findCommunityById(id: $id) {
      error
      community {
        id
        name
        division {
          id
          name
        }
        state {
          id
          name
        }
        zip
        city
        address
        teamMemberCommuniyAssignments {
          teamMember {
            groupName
            groupMembersNames
            status
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindCommunityByIdGQL extends Apollo.Query<
  FindCommunityByIdQuery,
  FindCommunityByIdQueryVariables
> {
  document = FindCommunityByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCommunitiesCountDocument = gql`
  query fetchCommunitiesCount {
    fetchCommunitiesCount {
      error
      statsCount: communitiesCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchCommunitiesCountGQL extends Apollo.Query<
  FetchCommunitiesCountQuery,
  FetchCommunitiesCountQueryVariables
> {
  document = FetchCommunitiesCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunityStatesDocument = gql`
  query getCommunityStates($archived: Boolean) {
    getCommunityStates(archived: $archived) {
      error
      states {
        id
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetCommunityStatesGQL extends Apollo.Query<
  GetCommunityStatesQuery,
  GetCommunityStatesQueryVariables
> {
  document = GetCommunityStatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPageContextDataForCommunityDocument = gql`
  query getPageContextDataForCommunity($id: Int!) {
    getPageContextDataForCommunity: findCommunityById(id: $id) {
      error
      community {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPageContextDataForCommunityGQL extends Apollo.Query<
  GetPageContextDataForCommunityQuery,
  GetPageContextDataForCommunityQueryVariables
> {
  document = GetPageContextDataForCommunityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportCommunitiesDocument = gql`
  mutation exportCommunities(
    $order: SortOrder
    $sortBy: AllowedCommunitiesSortFields
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $city: String
    $statesIds: [Int!]
    $archived: Boolean
    $exportType: CommunitiesExportTypes!
  ) {
    exportResponse: exportCommunities(
      order: $order
      sortBy: $sortBy
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      city: $city
      statesIds: $statesIds
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportCommunitiesGQL extends Apollo.Mutation<
  ExportCommunitiesMutation,
  ExportCommunitiesMutationVariables
> {
  document = ExportCommunitiesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportCommunityTeamMembersDocument = gql`
  mutation exportCommunityTeamMembers(
    $communityId: Int!
    $order: SortOrder
    $sortBy: TeamMembersSortFields
    $exportType: TeamMembersExportTypes!
  ) {
    exportResponse: exportCommunityTeamMembers(
      communityId: $communityId
      order: $order
      sortBy: $sortBy
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportCommunityTeamMembersGQL extends Apollo.Mutation<
  ExportCommunityTeamMembersMutation,
  ExportCommunityTeamMembersMutationVariables
> {
  document = ExportCommunityTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCommunityDocument = gql`
  mutation createCommunity(
    $createCommunityInput: CreateCommunityInput!
    $allowUpsertAssignment: Boolean!
  ) {
    createCommunity(
      createCommunityInput: $createCommunityInput
      allowUpsertAssignment: $allowUpsertAssignment
    ) {
      error
      success
      community {
        name
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateCommunityGQL extends Apollo.Mutation<
  CreateCommunityMutation,
  CreateCommunityMutationVariables
> {
  document = CreateCommunityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCommunityTeamMembersDocument = gql`
  mutation updateCommunityTeamMembers(
    $updateCommunityTeamMembersInput: UpdateCommunityTeamMembersInput!
    $id: Int!
    $skipCheck: Boolean
  ) {
    updateCommunityTeamMembers(
      updateCommunityTeamMembersInput: $updateCommunityTeamMembersInput
      id: $id
      skipCheck: $skipCheck
    ) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateCommunityTeamMembersGQL extends Apollo.Mutation<
  UpdateCommunityTeamMembersMutation,
  UpdateCommunityTeamMembersMutationVariables
> {
  document = UpdateCommunityTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCommunityHomeTeamMembersDocument = gql`
  mutation updateCommunityHomeTeamMembers($id: Int!) {
    updateCommunityHomeTeamMembers: updateCommunityLotTeamMembers(communityId: $id) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateCommunityHomeTeamMembersGQL extends Apollo.Mutation<
  UpdateCommunityHomeTeamMembersMutation,
  UpdateCommunityHomeTeamMembersMutationVariables
> {
  document = UpdateCommunityHomeTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCommunityDocument = gql`
  mutation updateCommunity($updateCommunityInput: UpdateCommunityInput!, $id: Int!) {
    updateCommunity(updateCommunityInput: $updateCommunityInput, id: $id) {
      error
      community {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateCommunityGQL extends Apollo.Mutation<
  UpdateCommunityMutation,
  UpdateCommunityMutationVariables
> {
  document = UpdateCommunityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveCommunityDocument = gql`
  mutation archiveCommunity($archive: Boolean!, $id: Int!) {
    archiveCommunity(archive: $archive, id: $id) {
      error
      community {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveCommunityGQL extends Apollo.Mutation<
  ArchiveCommunityMutation,
  ArchiveCommunityMutationVariables
> {
  document = ArchiveCommunityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCommunityDocument = gql`
  mutation deleteCommunity($id: Int!) {
    deleteCommunity(id: $id) {
      error
      community {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteCommunityGQL extends Apollo.Mutation<
  DeleteCommunityMutation,
  DeleteCommunityMutationVariables
> {
  document = DeleteCommunityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindCompaniesDocument = gql`
  query findCompanies($name: String, $archived: Boolean) {
    findCompanies(name: $name, archived: $archived) {
      error
      companies {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindCompaniesGQL extends Apollo.Query<
  FindCompaniesQuery,
  FindCompaniesQueryVariables
> {
  document = FindCompaniesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindCompaniesPaginatedDocument = gql`
  query findCompaniesPaginated(
    $stateIds: [Int!]
    $names: [String!]
    $archived: Boolean
    $order: SortOrder
    $sortBy: CompanySortFields
    $page: Int
    $limit: Int
  ) {
    findCompaniesPaginated(
      stateIds: $stateIds
      names: $names
      archived: $archived
      order: $order
      sortBy: $sortBy
      page: $page
      limit: $limit
    ) {
      statusCode
      error
      success
      meta {
        ...PaginationCoreInfo
      }
      items {
        id
        name
        stateId
        state {
          label
        }
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindCompaniesPaginatedGQL extends Apollo.Query<
  FindCompaniesPaginatedQuery,
  FindCompaniesPaginatedQueryVariables
> {
  document = FindCompaniesPaginatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchCompaniesCountDocument = gql`
  query fetchCompaniesCount {
    fetchCompaniesCount {
      success
      error
      statsCount: companiesCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchCompaniesCountGQL extends Apollo.Query<
  FetchCompaniesCountQuery,
  FetchCompaniesCountQueryVariables
> {
  document = FetchCompaniesCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCompanyByIdDocument = gql`
  query getCompanyById($id: Int!) {
    getCompanyById(id: $id) {
      error
      success
      company {
        id
        name
        stateId
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetCompanyByIdGQL extends Apollo.Query<
  GetCompanyByIdQuery,
  GetCompanyByIdQueryVariables
> {
  document = GetCompanyByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportCompaniesDocument = gql`
  mutation exportCompanies(
    $order: SortOrder
    $sortBy: CompanySortFields
    $names: [String!]
    $stateIds: [Int!]
    $archived: Boolean
    $exportType: CompanyExportTypes!
  ) {
    exportResponse: exportCompanies(
      order: $order
      sortBy: $sortBy
      names: $names
      stateIds: $stateIds
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportCompaniesGQL extends Apollo.Mutation<
  ExportCompaniesMutation,
  ExportCompaniesMutationVariables
> {
  document = ExportCompaniesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCompanyDocument = gql`
  mutation createCompany($createCompanyInput: CreateCompanyInput!) {
    createCompany(createCompanyInput: $createCompanyInput) {
      error
      success
      company {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateCompanyGQL extends Apollo.Mutation<
  CreateCompanyMutation,
  CreateCompanyMutationVariables
> {
  document = CreateCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCompanyDocument = gql`
  mutation updateCompany($id: Int!, $updateCompanyInput: UpdateCompanyInput!) {
    updateCompany(id: $id, updateCompanyInput: $updateCompanyInput) {
      error
      success
      company {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateCompanyGQL extends Apollo.Mutation<
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables
> {
  document = UpdateCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCompanyDocument = gql`
  mutation deleteCompany($id: Int!) {
    deleteCompany(id: $id) {
      success
      error
      company {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteCompanyGQL extends Apollo.Mutation<
  DeleteCompanyMutation,
  DeleteCompanyMutationVariables
> {
  document = DeleteCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveCompanyDocument = gql`
  mutation archiveCompany($archive: Boolean!, $id: Int!) {
    archiveCompany(archive: $archive, id: $id) {
      success
      error
      company {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveCompanyGQL extends Apollo.Mutation<
  ArchiveCompanyMutation,
  ArchiveCompanyMutationVariables
> {
  document = ArchiveCompanyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetContactsDocument = gql`
  query getContacts(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: TeamMembersSortFields
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $contactTypesIds: [Int!]
    $affiliation: ContactAffiliation
    $companiesIds: [Int!]
    $name: String
    $jobTitle: String
    $email: String
    $archived: Boolean
  ) {
    getContacts: findTeamMembers(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      contactTypesIds: $contactTypesIds
      affiliation: $affiliation
      companiesIds: $companiesIds
      name: $name
      jobTitle: $jobTitle
      email: $email
      archived: $archived
    ) {
      error
      items {
        id
        fullName
        title
        type {
          label
        }
        affiliation
        company {
          name
        }
        email
        mobilePhone
        communities {
          name
          division {
            name
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetContactsGQL extends Apollo.Query<GetContactsQuery, GetContactsQueryVariables> {
  document = GetContactsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetContactTypesDocument = gql`
  query getContactTypes(
    $affiliation: ContactAffiliation
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: TeamMemberTypesSortFields = name
  ) {
    getContactTypes: getTeamMemberTypes(
      affiliation: $affiliation
      archived: $archived
      order: $order
      sortBy: $sortBy
    ) {
      error
      contactTypes: teamMemberTypes {
        id
        label
        description
        affiliation
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetContactTypesGQL extends Apollo.Query<
  GetContactTypesQuery,
  GetContactTypesQueryVariables
> {
  document = GetContactTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindContactTypesDocument = gql`
  query findContactTypes(
    $typesIds: [Int!]
    $typesNames: [String!]
    $affiliation: ContactAffiliation
    $description: String
    $archived: Boolean
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: TeamMemberTypesSortFields
  ) {
    findContactTypes: findTeamMemberTypes(
      typesIds: $typesIds
      typesNames: $typesNames
      affiliation: $affiliation
      description: $description
      archived: $archived
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        label
        description
        affiliation
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindContactTypesGQL extends Apollo.Query<
  FindContactTypesQuery,
  FindContactTypesQueryVariables
> {
  document = FindContactTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindAllContactTypesDocument = gql`
  query findAllContactTypes($typesIds: [Int!]) {
    findAllContactTypes: findAllTeamMemberTypes(typesIds: $typesIds) {
      error
      teamMemberTypes {
        id
        label
        description
        affiliation
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindAllContactTypesGQL extends Apollo.Query<
  FindAllContactTypesQuery,
  FindAllContactTypesQueryVariables
> {
  document = FindAllContactTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchContactTypesCountDocument = gql`
  query fetchContactTypesCount {
    fetchContactTypesCount: fetchTeamMemberTypesCount {
      error
      statsCount: teamMemberTypesCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchContactTypesCountGQL extends Apollo.Query<
  FetchContactTypesCountQuery,
  FetchContactTypesCountQueryVariables
> {
  document = FetchContactTypesCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetContactByIdDocument = gql`
  query getContactById($id: Int!) {
    getContactById: getTeamMemberById(id: $id) {
      error
      contact: teamMember {
        id
        firstName
        lastName
        fullName
        email
        title
        mobilePhone
        workPhone
        displayMobilePhone
        description
        avatar
        affiliation
        typeId
        isGroupContact
        groupName
        groupMembersNames
        communities {
          id
        }
        company {
          id
          name
        }
        user {
          id
          fullName
          notificationsSettings {
            email
            text
            id
            label
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetContactByIdGQL extends Apollo.Query<
  GetContactByIdQuery,
  GetContactByIdQueryVariables
> {
  document = GetContactByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTeamMemberAssignedToLotForCmsDocument = gql`
  query GetTeamMemberAssignedToLotForCMS($id: Int!) {
    getTeamMemberAssignedToLotForCMS(id: $id) {
      error
      success
      teamMembers {
        id
        lastName
        firstName
        avatar
        workPhone
        mobilePhone
        title
        affiliation
        companyName
        companyUrl
        allowSMS
        isGroupContact
        groupName
        groupMembersNames
        user {
          id
        }
        type {
          name
          label
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetTeamMemberAssignedToLotForCmsGQL extends Apollo.Query<
  GetTeamMemberAssignedToLotForCmsQuery,
  GetTeamMemberAssignedToLotForCmsQueryVariables
> {
  document = GetTeamMemberAssignedToLotForCmsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTeamMemberTypeByIdDocument = gql`
  query getTeamMemberTypeById($id: Int!) {
    getTeamMemberTypeById(id: $id) {
      error
      teamMemberType {
        id
        label
        affiliation
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetTeamMemberTypeByIdGQL extends Apollo.Query<
  GetTeamMemberTypeByIdQuery,
  GetTeamMemberTypeByIdQueryVariables
> {
  document = GetTeamMemberTypeByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchContactsForAutoCompleteDocument = gql`
  query searchContactsForAutoComplete(
    $name: String
    $jobTitle: String
    $email: String
    $lotId: Int
    $archived: Boolean
    $communityId: Int
    $order: SortOrder = asc
    $sortBy: TeamMembersSortFields = name
  ) {
    getContacts: findTeamMembers(
      name: $name
      jobTitle: $jobTitle
      email: $email
      lotId: $lotId
      archived: $archived
      communityId: $communityId
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        fullName
        title
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchContactsForAutoCompleteGQL extends Apollo.Query<
  SearchContactsForAutoCompleteQuery,
  SearchContactsForAutoCompleteQueryVariables
> {
  document = SearchContactsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchTeamMembersForAutoCompleteDocument = gql`
  query searchTeamMembersForAutoComplete(
    $name: String
    $jobTitle: String
    $email: String
    $lotId: Int
    $archived: Boolean
    $communityId: Int
    $order: SortOrder = asc
    $sortBy: TeamMembersSortFields = name
  ) {
    getContacts: findTeamMembersForAutocomplete(
      name: $name
      jobTitle: $jobTitle
      email: $email
      lotId: $lotId
      archived: $archived
      communityId: $communityId
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        fullName
        title
        email
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchTeamMembersForAutoCompleteGQL extends Apollo.Query<
  SearchTeamMembersForAutoCompleteQuery,
  SearchTeamMembersForAutoCompleteQueryVariables
> {
  document = SearchTeamMembersForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchContactTypesForAutoCompleteDocument = gql`
  query searchContactTypesForAutoComplete(
    $description: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: TeamMemberTypesSortFields = name
  ) {
    getContactTypes: findTeamMemberTypes(
      description: $description
      archived: $archived
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        label
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchContactTypesForAutoCompleteGQL extends Apollo.Query<
  SearchContactTypesForAutoCompleteQuery,
  SearchContactTypesForAutoCompleteQueryVariables
> {
  document = SearchContactTypesForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetNamesFromContactTypesDocument = gql`
  query getNamesFromContactTypes($archived: Boolean) {
    getNamesFromContactTypes: getNamesFromTeamMemberTypes(archived: $archived) {
      error
      teamMemberTypeNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetNamesFromContactTypesGQL extends Apollo.Query<
  GetNamesFromContactTypesQuery,
  GetNamesFromContactTypesQueryVariables
> {
  document = GetNamesFromContactTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchContactsCountDocument = gql`
  query fetchContactsCount {
    fetchContactsCount: fetchTeamMembersCount {
      error
      statsCount: teamMembersCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchContactsCountGQL extends Apollo.Query<
  FetchContactsCountQuery,
  FetchContactsCountQueryVariables
> {
  document = FetchContactsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportContactsDocument = gql`
  mutation exportContacts(
    $order: SortOrder
    $sortBy: TeamMembersSortFields
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $contactTypesIds: [Int!]
    $affiliation: ContactAffiliation
    $companiesIds: [Int!]
    $name: String
    $jobTitle: String
    $email: String
    $archived: Boolean
    $exportType: TeamMembersExportTypes!
  ) {
    exportResponse: exportTeamMembers(
      order: $order
      sortBy: $sortBy
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      contactTypesIds: $contactTypesIds
      affiliation: $affiliation
      companiesIds: $companiesIds
      name: $name
      jobTitle: $jobTitle
      email: $email
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportContactsGQL extends Apollo.Mutation<
  ExportContactsMutation,
  ExportContactsMutationVariables
> {
  document = ExportContactsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateContactDocument = gql`
  mutation createContact(
    $createVendorTeamMemberInput: CreateVendorTeamMemberInput
    $createStaffTeamMemberInput: CreateStaffTeamMemberInput
    $affiliation: ContactAffiliation!
    $skipCheck: Boolean
  ) {
    createContact: createTeamMember(
      createVendorTeamMemberInput: $createVendorTeamMemberInput
      createStaffTeamMemberInput: $createStaffTeamMemberInput
      affiliation: $affiliation
      skipCheck: $skipCheck
    ) {
      error
      contact: teamMember {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateContactGQL extends Apollo.Mutation<
  CreateContactMutation,
  CreateContactMutationVariables
> {
  document = CreateContactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateGroupContactDocument = gql`
  mutation createGroupContact(
    $createGroupContactInput: CreateGroupContactInput!
    $skipCheck: Boolean
  ) {
    createGroupContact(createGroupContactInput: $createGroupContactInput, skipCheck: $skipCheck) {
      error
      contact: teamMember {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateGroupContactGQL extends Apollo.Mutation<
  CreateGroupContactMutation,
  CreateGroupContactMutationVariables
> {
  document = CreateGroupContactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateGroupContactDocument = gql`
  mutation updateGroupContact(
    $id: Int!
    $updateGroupContactInput: UpdateGroupContactInput!
    $skipCheck: Boolean
  ) {
    updateGroupContact(
      id: $id
      updateGroupContactInput: $updateGroupContactInput
      skipCheck: $skipCheck
    ) {
      error
      contact: teamMember {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateGroupContactGQL extends Apollo.Mutation<
  UpdateGroupContactMutation,
  UpdateGroupContactMutationVariables
> {
  document = UpdateGroupContactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateContactTypeDocument = gql`
  mutation createContactType($createTeamMemberTypeInput: CreateTeamMemberTypeInput!) {
    createContactType: createTeamMemberType(createTeamMemberTypeInput: $createTeamMemberTypeInput) {
      error
      contactType: teamMemberType {
        id
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateContactTypeGQL extends Apollo.Mutation<
  CreateContactTypeMutation,
  CreateContactTypeMutationVariables
> {
  document = CreateContactTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTeamMemberTypeDocument = gql`
  mutation updateTeamMemberType($id: Int!, $updateTeamMemberTypeInput: UpdateTeamMemberTypeInput!) {
    updateTeamMemberType(id: $id, updateTeamMemberTypeInput: $updateTeamMemberTypeInput) {
      error
      teamMemberType {
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateTeamMemberTypeGQL extends Apollo.Mutation<
  UpdateTeamMemberTypeMutation,
  UpdateTeamMemberTypeMutationVariables
> {
  document = UpdateTeamMemberTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteContactDocument = gql`
  mutation deleteContact($id: Int!, $skipCheck: Boolean) {
    deleteContact: deleteTeamMember(id: $id, skipCheck: $skipCheck) {
      error
      contact: teamMember {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteContactGQL extends Apollo.Mutation<
  DeleteContactMutation,
  DeleteContactMutationVariables
> {
  document = DeleteContactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateContactDocument = gql`
  mutation updateContact(
    $updateVendorTeamMemberInput: UpdateVendorTeamMemberInput
    $updateStaffTeamMemberInput: UpdateStaffTeamMemberInput
    $id: Int!
    $skipCheck: Boolean
  ) {
    updateContact: updateTeamMember(
      updateVendorTeamMemberInput: $updateVendorTeamMemberInput
      updateStaffTeamMemberInput: $updateStaffTeamMemberInput
      id: $id
      skipCheck: $skipCheck
    ) {
      error
      contact: teamMember {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateContactGQL extends Apollo.Mutation<
  UpdateContactMutation,
  UpdateContactMutationVariables
> {
  document = UpdateContactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveContactTypeDocument = gql`
  mutation archiveContactType($archive: Boolean!, $id: Int!) {
    archiveContactType: archiveTeamMemberType(archive: $archive, id: $id) {
      statusCode
      error
      contactType: teamMemberType {
        id
        name: label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveContactTypeGQL extends Apollo.Mutation<
  ArchiveContactTypeMutation,
  ArchiveContactTypeMutationVariables
> {
  document = ArchiveContactTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTeamMemberTypeDocument = gql`
  mutation deleteTeamMemberType($id: Int!) {
    deleteTeamMemberType(id: $id) {
      error
      teamMemberType {
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteTeamMemberTypeGQL extends Apollo.Mutation<
  DeleteTeamMemberTypeMutation,
  DeleteTeamMemberTypeMutationVariables
> {
  document = DeleteTeamMemberTypeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveContactDocument = gql`
  mutation archiveContact($archive: Boolean!, $id: Int!, $skipCheck: Boolean) {
    archiveContact: archiveTeamMember(archive: $archive, id: $id, skipCheck: $skipCheck) {
      error
      contact: teamMember {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveContactGQL extends Apollo.Mutation<
  ArchiveContactMutation,
  ArchiveContactMutationVariables
> {
  document = ArchiveContactDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportContactTypesDocument = gql`
  mutation exportContactTypes(
    $order: SortOrder
    $sortBy: TeamMemberTypesSortFields
    $typesNames: [String!]
    $affiliation: ContactAffiliation
    $description: String
    $archived: Boolean
    $exportType: TeamMemberTypesExportTypes!
  ) {
    exportResponse: exportTeamMemberTypes(
      order: $order
      sortBy: $sortBy
      typesNames: $typesNames
      affiliation: $affiliation
      description: $description
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportContactTypesGQL extends Apollo.Mutation<
  ExportContactTypesMutation,
  ExportContactTypesMutationVariables
> {
  document = ExportContactTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetStatesDocument = gql`
  query getStates {
    getStates {
      error
      states {
        id
        label
        country {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetStatesGQL extends Apollo.Query<GetStatesQuery, GetStatesQueryVariables> {
  document = GetStatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCountriesDocument = gql`
  query getCountries {
    getCountries {
      error
      countries {
        id
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
  document = GetCountriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDefaultPhaseTipByIdDocument = gql`
  query getDefaultPhaseTipById($defaultPhaseTipId: Int!) {
    getDefaultPhaseTipById(defaultPhaseTipId: $defaultPhaseTipId) {
      error
      defaultPhaseTip {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetDefaultPhaseTipByIdGQL extends Apollo.Query<
  GetDefaultPhaseTipByIdQuery,
  GetDefaultPhaseTipByIdQueryVariables
> {
  document = GetDefaultPhaseTipByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDefaultPhaseTipsPaginatedDocument = gql`
  query getDefaultPhaseTipsPaginated(
    $defaultPhaseId: Int!
    $archived: Boolean
    $page: Int
    $limit: Int
    $name: String
    $description: String
    $sortBy: DefaultPhaseTipsSortFields
    $order: SortOrder
  ) {
    getDefaultPhaseTipsPaginated(
      defaultPhaseId: $defaultPhaseId
      archived: $archived
      page: $page
      limit: $limit
      name: $name
      description: $description
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        name
        description
        sequence
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetDefaultPhaseTipsPaginatedGQL extends Apollo.Query<
  GetDefaultPhaseTipsPaginatedQuery,
  GetDefaultPhaseTipsPaginatedQueryVariables
> {
  document = GetDefaultPhaseTipsPaginatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDefaultPhaseTipsCountDocument = gql`
  query fetchDefaultPhaseTipsCount($defaultPhaseId: Int!) {
    fetchDefaultPhaseTipsCount(defaultPhaseId: $defaultPhaseId) {
      error
      statsCount: stats {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchDefaultPhaseTipsCountGQL extends Apollo.Query<
  FetchDefaultPhaseTipsCountQuery,
  FetchDefaultPhaseTipsCountQueryVariables
> {
  document = FetchDefaultPhaseTipsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindDivisionsWithPhasesDocument = gql`
  query findDivisionsWithPhases($defaultPhaseId: Int!) {
    findDivisionsWithPhases(defaultPhaseId: $defaultPhaseId) {
      error
      divisions {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindDivisionsWithPhasesGQL extends Apollo.Query<
  FindDivisionsWithPhasesQuery,
  FindDivisionsWithPhasesQueryVariables
> {
  document = FindDivisionsWithPhasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDefaultPhaseTipsForAutoCompleteDocument = gql`
  query searchDefaultPhaseTipsForAutoComplete(
    $name: String
    $description: String
    $defaultPhaseId: Int!
    $archived: Boolean
    $sortBy: DefaultPhaseTipsSortFields = name
    $order: SortOrder = asc
  ) {
    getDefaultPhaseTipsPaginated(
      defaultPhaseId: $defaultPhaseId
      name: $name
      description: $description
      archived: $archived
      sortBy: $sortBy
      order: $order
    ) {
      error
      items {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchDefaultPhaseTipsForAutoCompleteGQL extends Apollo.Query<
  SearchDefaultPhaseTipsForAutoCompleteQuery,
  SearchDefaultPhaseTipsForAutoCompleteQueryVariables
> {
  document = SearchDefaultPhaseTipsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDefaultPhaseTipsOrderDocument = gql`
  mutation updateDefaultPhaseTipsOrder($defaultPhaseTipIds: [Int!]!, $defaultPhaseId: Int!) {
    updateDefaultPhaseTipsOrder(
      defaultPhaseTipIds: $defaultPhaseTipIds
      defaultPhaseId: $defaultPhaseId
    ) {
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateDefaultPhaseTipsOrderGQL extends Apollo.Mutation<
  UpdateDefaultPhaseTipsOrderMutation,
  UpdateDefaultPhaseTipsOrderMutationVariables
> {
  document = UpdateDefaultPhaseTipsOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDefaultPhaseTipDocument = gql`
  mutation updateDefaultPhaseTip(
    $updateDefaultPhaseTipInput: UpdateDefaultPhaseTipInput!
    $defaultPhaseTipId: Int!
    $updateDivisionPhasesTips: Boolean
  ) {
    updateDefaultPhaseTip(
      updateDefaultPhaseTipInput: $updateDefaultPhaseTipInput
      defaultPhaseTipId: $defaultPhaseTipId
      updateDivisionPhasesTips: $updateDivisionPhasesTips
    ) {
      error
      success
      defaultPhaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateDefaultPhaseTipGQL extends Apollo.Mutation<
  UpdateDefaultPhaseTipMutation,
  UpdateDefaultPhaseTipMutationVariables
> {
  document = UpdateDefaultPhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDefaultPhaseTipDocument = gql`
  mutation createDefaultPhaseTip($createDefaultPhaseTipInput: CreateDefaultPhaseTipInput!) {
    createDefaultPhaseTip(createDefaultPhaseTipInput: $createDefaultPhaseTipInput) {
      error
      success
      defaultPhaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateDefaultPhaseTipGQL extends Apollo.Mutation<
  CreateDefaultPhaseTipMutation,
  CreateDefaultPhaseTipMutationVariables
> {
  document = CreateDefaultPhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDefaultPhaseTipDocument = gql`
  mutation archiveDefaultPhaseTip($archive: Boolean!, $id: Int!) {
    archiveDefaultPhaseTip(archive: $archive, id: $id) {
      statusCode
      error
      defaultPhaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveDefaultPhaseTipGQL extends Apollo.Mutation<
  ArchiveDefaultPhaseTipMutation,
  ArchiveDefaultPhaseTipMutationVariables
> {
  document = ArchiveDefaultPhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteDefaultPhaseTipDocument = gql`
  mutation deleteDefaultPhaseTip($id: Int!, $deleteRelatedPhaseTips: Boolean) {
    deleteDefaultPhaseTip(id: $id, deleteRelatedPhaseTips: $deleteRelatedPhaseTips) {
      error
      statusCode
      defaultPhaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteDefaultPhaseTipGQL extends Apollo.Mutation<
  DeleteDefaultPhaseTipMutation,
  DeleteDefaultPhaseTipMutationVariables
> {
  document = DeleteDefaultPhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDefaultPhaseTipsDocument = gql`
  mutation exportDefaultPhaseTips(
    $defaultPhaseId: Int!
    $archived: Boolean
    $name: String
    $description: String
    $sortBy: DefaultPhaseTipsSortFields
    $order: SortOrder
    $exportType: DefaultPhaseTipsExportTypes!
  ) {
    exportResponse: exportDefaultPhaseTips(
      defaultPhaseId: $defaultPhaseId
      archived: $archived
      name: $name
      description: $description
      sortBy: $sortBy
      order: $order
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportDefaultPhaseTipsGQL extends Apollo.Mutation<
  ExportDefaultPhaseTipsMutation,
  ExportDefaultPhaseTipsMutationVariables
> {
  document = ExportDefaultPhaseTipsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindDivisionsDocument = gql`
  query findDivisions(
    $withCommunities: Boolean = false
    $withPhases: Boolean = false
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedDivisionsSortFields = name
  ) {
    findDivisions(archived: $archived, order: $order, sortBy: $sortBy) {
      error
      divisions {
        id
        name
        country {
          id
          label
        }
        communities @include(if: $withCommunities) {
          id
          name
          city
          zip
          stateId
        }
        phases @include(if: $withPhases) {
          id
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindDivisionsGQL extends Apollo.Query<
  FindDivisionsQuery,
  FindDivisionsQueryVariables
> {
  document = FindDivisionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindDivisionsWithHomesDocument = gql`
  query findDivisionsWithHomes {
    findDivisionsWithHomes {
      error
      divisions {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindDivisionsWithHomesGQL extends Apollo.Query<
  FindDivisionsWithHomesQuery,
  FindDivisionsWithHomesQueryVariables
> {
  document = FindDivisionsWithHomesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDivisionsDocument = gql`
  query getDivisions(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: AllowedDivisionsSortFields
    $divisionIds: [Int!]
    $city: String
    $statesIds: [Int!]
    $phone: String
    $archived: Boolean
  ) {
    getDivisions(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      divisionIds: $divisionIds
      city: $city
      statesIds: $statesIds
      phone: $phone
      archived: $archived
    ) {
      error
      items {
        id
        name
        city
        phone
        state {
          id
          label
        }
        division149PhotosId
        division149photosSync {
          syncInProgress
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetDivisionsGQL extends Apollo.Query<GetDivisionsQuery, GetDivisionsQueryVariables> {
  document = GetDivisionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindDivisionByIdDocument = gql`
  query findDivisionById($id: Int!, $withPhases: Boolean = false) {
    findDivisionById(id: $id) {
      error
      division {
        id
        name
        url
        designStudioUrl
        phone
        zip
        address
        city
        country {
          id
        }
        state {
          id
        }
        contactUser {
          id
          fullName
        }
        contactPhone
        contactEmail
        logo
        phases @include(if: $withPhases) {
          id
          name
          defaultPhaseId
        }
        division149PhotosId
        timeZone
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindDivisionByIdGQL extends Apollo.Query<
  FindDivisionByIdQuery,
  FindDivisionByIdQueryVariables
> {
  document = FindDivisionByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDivisionsForAutoCompleteDocument = gql`
  query searchDivisionsForAutoComplete(
    $city: String
    $phone: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedDivisionsSortFields = name
  ) {
    getDivisions(city: $city, phone: $phone, archived: $archived, order: $order, sortBy: $sortBy) {
      error
      items {
        id
        name
        city
        phone
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchDivisionsForAutoCompleteGQL extends Apollo.Query<
  SearchDivisionsForAutoCompleteQuery,
  SearchDivisionsForAutoCompleteQueryVariables
> {
  document = SearchDivisionsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDivisionsCountDocument = gql`
  query fetchDivisionsCount {
    fetchDivisionsCount {
      error
      statsCount: divisionsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchDivisionsCountGQL extends Apollo.Query<
  FetchDivisionsCountQuery,
  FetchDivisionsCountQueryVariables
> {
  document = FetchDivisionsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDivisionStatesDocument = gql`
  query getDivisionStates($archived: Boolean) {
    getDivisionStates(archived: $archived) {
      error
      states {
        id
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetDivisionStatesGQL extends Apollo.Query<
  GetDivisionStatesQuery,
  GetDivisionStatesQueryVariables
> {
  document = GetDivisionStatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDivisionsDocument = gql`
  mutation exportDivisions(
    $divisionIds: [Int!]
    $statesIds: [Int!]
    $city: String
    $phone: String
    $archived: Boolean
    $order: SortOrder
    $sortBy: AllowedDivisionsSortFields
    $exportType: DivisionsExportTypes!
  ) {
    exportResponse: exportDivisions(
      divisionIds: $divisionIds
      statesIds: $statesIds
      city: $city
      phone: $phone
      archived: $archived
      order: $order
      sortBy: $sortBy
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportDivisionsGQL extends Apollo.Mutation<
  ExportDivisionsMutation,
  ExportDivisionsMutationVariables
> {
  document = ExportDivisionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDivisionDocument = gql`
  mutation archiveDivision($archive: Boolean!, $id: Int!) {
    archiveDivision(archive: $archive, id: $id) {
      error
      division {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveDivisionGQL extends Apollo.Mutation<
  ArchiveDivisionMutation,
  ArchiveDivisionMutationVariables
> {
  document = ArchiveDivisionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteDivisionDocument = gql`
  mutation deleteDivision($id: Int!) {
    deleteDivision(id: $id) {
      error
      division {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteDivisionGQL extends Apollo.Mutation<
  DeleteDivisionMutation,
  DeleteDivisionMutationVariables
> {
  document = DeleteDivisionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDivisionDocument = gql`
  mutation createDivision($createDivisionInput: CreateDivisionInput!) {
    createDivision(createDivisionInput: $createDivisionInput) {
      error
      division {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateDivisionGQL extends Apollo.Mutation<
  CreateDivisionMutation,
  CreateDivisionMutationVariables
> {
  document = CreateDivisionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDivisionDocument = gql`
  mutation updateDivision($updateDivisionInput: UpdateDivisionInput!, $id: Int!) {
    updateDivision(updateDivisionInput: $updateDivisionInput, id: $id) {
      error
      division {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateDivisionGQL extends Apollo.Mutation<
  UpdateDivisionMutation,
  UpdateDivisionMutationVariables
> {
  document = UpdateDivisionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const Sync149PhotosWithRemoteDocument = gql`
  mutation sync149PhotosWithRemote($divisionId: Int!) {
    sync149PhotosWithRemote(divisionId: $divisionId) {
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class Sync149PhotosWithRemoteGQL extends Apollo.Mutation<
  Sync149PhotosWithRemoteMutation,
  Sync149PhotosWithRemoteMutationVariables
> {
  document = Sync149PhotosWithRemoteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDocumentsWithPaginationDocument = gql`
  query getDocumentsWithPagination(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: DocumentsSortingFields
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $name: String
    $phaseNames: [String!]
    $description: String
    $archived: Boolean
  ) {
    getDocumentsWithPagination(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      divisionIds: $divisionIds
      communityIds: $communityIds
      name: $name
      phaseNames: $phaseNames
      description: $description
      archived: $archived
    ) {
      items {
        id
        name
        description
        fileSize
        fileName
        fileUrl
        editable
        communities {
          id
          name
          division {
            id
            name
          }
        }
        phases {
          id
          name
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetDocumentsWithPaginationGQL extends Apollo.Query<
  GetDocumentsWithPaginationQuery,
  GetDocumentsWithPaginationQueryVariables
> {
  document = GetDocumentsWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDocumentsCountDocument = gql`
  query getDocumentsCount {
    getDocumentsCount {
      error
      statsCount: documentsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetDocumentsCountGQL extends Apollo.Query<
  GetDocumentsCountQuery,
  GetDocumentsCountQueryVariables
> {
  document = GetDocumentsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDocumentsForAutoCompleteDocument = gql`
  query searchDocumentsForAutoComplete(
    $name: String
    $description: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: DocumentsSortingFields = name
  ) {
    getDocumentsWithPagination(
      name: $name
      description: $description
      archived: $archived
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchDocumentsForAutoCompleteGQL extends Apollo.Query<
  SearchDocumentsForAutoCompleteQuery,
  SearchDocumentsForAutoCompleteQueryVariables
> {
  document = SearchDocumentsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseNamesFromDocumentsDocument = gql`
  query getPhaseNamesFromDocuments(
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $name: String
    $description: String
    $archived: Boolean
  ) {
    getPhaseNamesFromDocuments(
      divisionIds: $divisionIds
      communityIds: $communityIds
      name: $name
      description: $description
      archived: $archived
    ) {
      error
      phaseNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseNamesFromDocumentsGQL extends Apollo.Query<
  GetPhaseNamesFromDocumentsQuery,
  GetPhaseNamesFromDocumentsQueryVariables
> {
  document = GetPhaseNamesFromDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDocumentByIdDocument = gql`
  query getDocumentById($documentId: Int!) {
    getDocument(documentId: $documentId) {
      error
      document {
        id
        name
        description
        fileName
        fileUrl
        fileSize
        communityPhaseAssignments {
          phase {
            id
          }
          community {
            id
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetDocumentByIdGQL extends Apollo.Query<
  GetDocumentByIdQuery,
  GetDocumentByIdQueryVariables
> {
  document = GetDocumentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDocumentDocument = gql`
  mutation archiveDocument($archive: Boolean!, $documentId: Int!) {
    archiveDocument(archive: $archive, documentId: $documentId) {
      error
      document {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveDocumentGQL extends Apollo.Mutation<
  ArchiveDocumentMutation,
  ArchiveDocumentMutationVariables
> {
  document = ArchiveDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDocumentDocument = gql`
  mutation CreateDocument($createDocumentInput: CreateDocumentInput!) {
    createDocument(createDocumentInput: $createDocumentInput) {
      error
      document {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateDocumentGQL extends Apollo.Mutation<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
> {
  document = CreateDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteDocumentDocument = gql`
  mutation deleteDocument($documentId: Int!) {
    deleteDocument(documentId: $documentId) {
      error
      document {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteDocumentGQL extends Apollo.Mutation<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
> {
  document = DeleteDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDocumentDocument = gql`
  mutation updateDocument($updateDocumentInput: UpdateDocumentInput!, $documentId: Int!) {
    updateDocument(updateDocumentInput: $updateDocumentInput, documentId: $documentId) {
      error
      document {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateDocumentGQL extends Apollo.Mutation<
  UpdateDocumentMutation,
  UpdateDocumentMutationVariables
> {
  document = UpdateDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDocumentsDocument = gql`
  mutation exportDocuments(
    $order: SortOrder
    $sortBy: DocumentsSortingFields
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $name: String
    $phaseNames: [String!]
    $description: String
    $archived: Boolean
    $exportType: DocumentsExportTypes!
  ) {
    exportResponse: exportDocuments(
      order: $order
      sortBy: $sortBy
      divisionIds: $divisionIds
      communityIds: $communityIds
      name: $name
      phaseNames: $phaseNames
      description: $description
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportDocumentsGQL extends Apollo.Mutation<
  ExportDocumentsMutation,
  ExportDocumentsMutationVariables
> {
  document = ExportDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEventsWithPaginationDocument = gql`
  query getEventsWithPagination(
    $order: SortOrder
    $sortBy: EventListSortByField
    $name: String
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $phaseNames: [String!]
    $page: Int
    $limit: Int
    $archived: Boolean
  ) {
    getEventsWithPagination(
      order: $order
      sortBy: $sortBy
      name: $name
      divisionIds: $divisionIds
      communityIds: $communityIds
      phaseNames: $phaseNames
      page: $page
      limit: $limit
      archived: $archived
    ) {
      error
      items {
        id
        name
        description
        rsvpRequired
        estimatedDuration
        editable
        communityPhaseAssignments {
          id
          community {
            id
            name
            division {
              id
              name
            }
          }
          phase {
            id
            name
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetEventsWithPaginationGQL extends Apollo.Query<
  GetEventsWithPaginationQuery,
  GetEventsWithPaginationQueryVariables
> {
  document = GetEventsWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEventsDocument = gql`
  query getEvents(
    $name: String
    $archived: Boolean
    $sortBy: EventListSortByField = name
    $order: SortOrder = asc
  ) {
    getEvents(name: $name, archived: $archived, sortBy: $sortBy, order: $order) {
      error
      events {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetEventsGQL extends Apollo.Query<GetEventsQuery, GetEventsQueryVariables> {
  document = GetEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportEventsDocument = gql`
  mutation exportEvents(
    $order: SortOrder
    $sortBy: EventListSortByField
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $phaseNames: [String!]
    $name: String
    $archived: Boolean
    $exportType: EventsExportTypes!
  ) {
    exportResponse: exportEvents(
      order: $order
      sortBy: $sortBy
      divisionIds: $divisionIds
      communityIds: $communityIds
      phaseNames: $phaseNames
      name: $name
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportEventsGQL extends Apollo.Mutation<
  ExportEventsMutation,
  ExportEventsMutationVariables
> {
  document = ExportEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunitiesByDivisionIdDocument = gql`
  query getCommunitiesByDivisionId($id: Int!) {
    getCommunitiesByDivisionId(id: $id) {
      success
      error
      statusCode
      communities {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetCommunitiesByDivisionIdGQL extends Apollo.Query<
  GetCommunitiesByDivisionIdQuery,
  GetCommunitiesByDivisionIdQueryVariables
> {
  document = GetCommunitiesByDivisionIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindEventByIdDocument = gql`
  query findEventById($id: Int!) {
    findEventById(id: $id) {
      error
      event {
        id
        name
        description
        rsvpRequired
        estimatedDuration
        communityPhaseAssignments {
          id
          community {
            id
            name
          }
          phase {
            id
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindEventByIdGQL extends Apollo.Query<
  FindEventByIdQuery,
  FindEventByIdQueryVariables
> {
  document = FindEventByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomesByCommunityIdDocument = gql`
  query getHomesByCommunityId($id: Int!) {
    getHomesByCommunityId(id: $id) {
      success
      error
      statusCode
      lots {
        id
        address
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetHomesByCommunityIdGQL extends Apollo.Query<
  GetHomesByCommunityIdQuery,
  GetHomesByCommunityIdQueryVariables
> {
  document = GetHomesByCommunityIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchEventsCountDocument = gql`
  query fetchEventsCount {
    fetchEventsCount {
      error
      statsCount: eventsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchEventsCountGQL extends Apollo.Query<
  FetchEventsCountQuery,
  FetchEventsCountQueryVariables
> {
  document = FetchEventsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateEventDocument = gql`
  mutation createEvent($createEventInput: CreateEventInput!) {
    createEvent(createEventInput: $createEventInput) {
      error
      event {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateEventGQL extends Apollo.Mutation<
  CreateEventMutation,
  CreateEventMutationVariables
> {
  document = CreateEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateEventDocument = gql`
  mutation updateEvent($updateEventInput: UpdateEventInput!, $id: Int!) {
    updateEvent(updateEventInput: $updateEventInput, id: $id) {
      error
      event {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateEventGQL extends Apollo.Mutation<
  UpdateEventMutation,
  UpdateEventMutationVariables
> {
  document = UpdateEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveEventDocument = gql`
  mutation archiveEvent($archive: Boolean!, $id: Int!) {
    archiveEvent(archive: $archive, id: $id) {
      statusCode
      error
      event {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveEventGQL extends Apollo.Mutation<
  ArchiveEventMutation,
  ArchiveEventMutationVariables
> {
  document = ArchiveEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteEventDocument = gql`
  mutation deleteEvent($id: Int!) {
    deleteEvent(id: $id) {
      error
      statusCode
      event {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteEventGQL extends Apollo.Mutation<
  DeleteEventMutation,
  DeleteEventMutationVariables
> {
  document = DeleteEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchEventsForAutoCompleteDocument = gql`
  query searchEventsForAutoComplete(
    $name: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: EventListSortByField = name
  ) {
    getEvents(name: $name, archived: $archived, order: $order, sortBy: $sortBy) {
      error
      events {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchEventsForAutoCompleteGQL extends Apollo.Query<
  SearchEventsForAutoCompleteQuery,
  SearchEventsForAutoCompleteQueryVariables
> {
  document = SearchEventsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseNamesFromEventsDocument = gql`
  query getPhaseNamesFromEvents(
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $name: String
    $archived: Boolean
  ) {
    getPhaseNamesFromEvents(
      divisionIds: $divisionIds
      communityIds: $communityIds
      name: $name
      archived: $archived
    ) {
      error
      phaseNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseNamesFromEventsGQL extends Apollo.Query<
  GetPhaseNamesFromEventsQuery,
  GetPhaseNamesFromEventsQueryVariables
> {
  document = GetPhaseNamesFromEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomeDocumentsWithPaginationDocument = gql`
  query getHomeDocumentsWithPagination(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: LotDocumentsSortTypes
    $lotId: Int!
    $name: String
    $phaseNames: [String!]
    $description: String
    $archived: Boolean
  ) {
    getHomeDocumentsWithPagination: findLotDocumentsPaginated(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      lotId: $lotId
      name: $name
      phaseNames: $phaseNames
      description: $description
      archived: $archived
    ) {
      items {
        id
        name
        description
        fileSize
        fileName
        fileUrl
        ... on LotDocument {
          phases {
            id
            name
          }
        }
        ... on Document {
          phases {
            id
            name
          }
          lotDocumentAssignments {
            visible
            lotId
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetHomeDocumentsWithPaginationGQL extends Apollo.Query<
  GetHomeDocumentsWithPaginationQuery,
  GetHomeDocumentsWithPaginationQueryVariables
> {
  document = GetHomeDocumentsWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangeDocumentVisibilityDocument = gql`
  mutation changeDocumentVisibility($documentId: Int!, $lotId: Int!) {
    changeDocumentVisibility(documentId: $documentId, lotId: $lotId) {
      success
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ChangeDocumentVisibilityGQL extends Apollo.Mutation<
  ChangeDocumentVisibilityMutation,
  ChangeDocumentVisibilityMutationVariables
> {
  document = ChangeDocumentVisibilityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomeDocumentsCountDocument = gql`
  query getHomeDocumentsCount($lotId: Int!) {
    getHomeDocumentsCount: getLotDocumentsCount(lotId: $lotId) {
      error
      statsCount: lotDocumentsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetHomeDocumentsCountGQL extends Apollo.Query<
  GetHomeDocumentsCountQuery,
  GetHomeDocumentsCountQueryVariables
> {
  document = GetHomeDocumentsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchHomeDocumentsForAutoCompleteDocument = gql`
  query searchHomeDocumentsForAutoComplete(
    $lotId: Int!
    $name: String
    $description: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: LotDocumentsSortTypes = name
  ) {
    searchHomeDocumentsForAutoComplete: getLotDocumentsForAutocomplete(
      lotId: $lotId
      name: $name
      description: $description
      archived: $archived
      order: $order
      sortBy: $sortBy
    ) {
      error
      lotDocuments {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchHomeDocumentsForAutoCompleteGQL extends Apollo.Query<
  SearchHomeDocumentsForAutoCompleteQuery,
  SearchHomeDocumentsForAutoCompleteQueryVariables
> {
  document = SearchHomeDocumentsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseNamesFromHomeDocumentsDocument = gql`
  query getPhaseNamesFromHomeDocuments(
    $lotId: Int!
    $name: String
    $description: String
    $archived: Boolean
  ) {
    getPhaseNamesFromHomeDocuments: getPhaseNamesFromLotDocuments(
      lotId: $lotId
      name: $name
      description: $description
      archived: $archived
    ) {
      error
      phaseNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseNamesFromHomeDocumentsGQL extends Apollo.Query<
  GetPhaseNamesFromHomeDocumentsQuery,
  GetPhaseNamesFromHomeDocumentsQueryVariables
> {
  document = GetPhaseNamesFromHomeDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomeDocumentByIdDocument = gql`
  query getHomeDocumentById($documentId: Int!) {
    getHomeDocument: findLotDocumentById(lotDocumentId: $documentId) {
      error
      lotDocument {
        id
        name
        description
        fileName
        fileUrl
        fileSize
        phaseAssignments {
          phase {
            id
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetHomeDocumentByIdGQL extends Apollo.Query<
  GetHomeDocumentByIdQuery,
  GetHomeDocumentByIdQueryVariables
> {
  document = GetHomeDocumentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveHomeDocumentDocument = gql`
  mutation archiveHomeDocument($archive: Boolean!, $documentId: Int!) {
    archiveHomeDocument: archiveLotDocument(archive: $archive, lotDocumentId: $documentId) {
      error
      lotDocument {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveHomeDocumentGQL extends Apollo.Mutation<
  ArchiveHomeDocumentMutation,
  ArchiveHomeDocumentMutationVariables
> {
  document = ArchiveHomeDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateHomeDocumentDocument = gql`
  mutation createHomeDocument($lotId: Int!, $createHomeDocumentInput: [CreateLotDocumentInput!]!) {
    createHomeDocument: createLotDocuments(
      lotId: $lotId
      createLotDocumentsInputs: $createHomeDocumentInput
    ) {
      error
      lotDocuments {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateHomeDocumentGQL extends Apollo.Mutation<
  CreateHomeDocumentMutation,
  CreateHomeDocumentMutationVariables
> {
  document = CreateHomeDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteHomeDocumentDocument = gql`
  mutation deleteHomeDocument($documentId: Int!) {
    deleteHomeDocument: deleteLotDocument(lotDocumentId: $documentId) {
      error
      lotDocument {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteHomeDocumentGQL extends Apollo.Mutation<
  DeleteHomeDocumentMutation,
  DeleteHomeDocumentMutationVariables
> {
  document = DeleteHomeDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateHomeDocumentDocument = gql`
  mutation updateHomeDocument(
    $updateHomeDocumentInput: UpdateLotDocumentInput!
    $documentId: Int!
  ) {
    updateHomeDocument: updateLotDocument(
      updateLotDocumentInput: $updateHomeDocumentInput
      lotDocumentId: $documentId
    ) {
      error
      lotDocument {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateHomeDocumentGQL extends Apollo.Mutation<
  UpdateHomeDocumentMutation,
  UpdateHomeDocumentMutationVariables
> {
  document = UpdateHomeDocumentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportHomeDocumentsDocument = gql`
  mutation exportHomeDocuments(
    $order: SortOrder
    $sortBy: LotDocumentsSortTypes
    $lotId: Int!
    $name: String
    $phaseNames: [String!]
    $description: String
    $archived: Boolean
    $exportType: LotDocumentsExportTypes!
  ) {
    exportResponse: exportLotDocuments(
      order: $order
      sortBy: $sortBy
      lotId: $lotId
      name: $name
      phaseNames: $phaseNames
      description: $description
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportHomeDocumentsGQL extends Apollo.Mutation<
  ExportHomeDocumentsMutation,
  ExportHomeDocumentsMutationVariables
> {
  document = ExportHomeDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLotGalleryImagesDocument = gql`
  query getLotGalleryImages($lotId: Int!) {
    getLotGalleryImages(lotId: $lotId) {
      error
      success
      items: lotGallery {
        id
        order
        fullImgSrc
        smallImgSrc
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetLotGalleryImagesGQL extends Apollo.Query<
  GetLotGalleryImagesQuery,
  GetLotGalleryImagesQueryVariables
> {
  document = GetLotGalleryImagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateLotGalleryOrderDocument = gql`
  mutation updateLotGalleryOrder($lotGalleryIds: [Int!]!, $lotId: Int!) {
    updateLotGalleryOrder(lotGalleryIds: $lotGalleryIds, lotId: $lotId) {
      success
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateLotGalleryOrderGQL extends Apollo.Mutation<
  UpdateLotGalleryOrderMutation,
  UpdateLotGalleryOrderMutationVariables
> {
  document = UpdateLotGalleryOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveLotGalleryImagesDocument = gql`
  mutation removeLotGalleryImages($lotPhotosIds: [Int!]!) {
    removeLotGalleryImages(lotPhotosIds: $lotPhotosIds) {
      success
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RemoveLotGalleryImagesGQL extends Apollo.Mutation<
  RemoveLotGalleryImagesMutation,
  RemoveLotGalleryImagesMutationVariables
> {
  document = RemoveLotGalleryImagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateLotGalleryImagesDocument = gql`
  mutation createLotGalleryImages(
    $createLotGalleryImagesInput: [CreateLotGalleryImageInput!]!
    $lotId: Int!
  ) {
    createLotGalleryImages(
      createLotGalleryImagesInput: $createLotGalleryImagesInput
      lotId: $lotId
    ) {
      success
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateLotGalleryImagesGQL extends Apollo.Mutation<
  CreateLotGalleryImagesMutation,
  CreateLotGalleryImagesMutationVariables
> {
  document = CreateLotGalleryImagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLotPhotos149ListDocument = gql`
  query getLotPhotos149List($lotId: Int!) {
    getLotPhotos149List(lotId: $lotId) {
      error
      success
      items: lot149PhotosGallery {
        url
        stage
        updatedAt
        type
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetLotPhotos149ListGQL extends Apollo.Query<
  GetLotPhotos149ListQuery,
  GetLotPhotos149ListQueryVariables
> {
  document = GetLotPhotos149ListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindLotAppointmentsWithPaginationDocument = gql`
  query FindLotAppointmentsWithPagination(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: LotAppointmentsSortFields
    $lotId: Int
    $name: String
    $start: DateTime
    $end: DateTime
    $statuses: [LotAppointmentStatus!]
    $phaseNames: [String!]
    $attendees: [String!]
  ) {
    findLotAppointmentsWithPagination(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      lotId: $lotId
      name: $name
      start: $start
      end: $end
      statuses: $statuses
      phaseNames: $phaseNames
      attendees: $attendees
    ) {
      error
      items {
        id
        name
        description
        status
        startDate
        startTime
        start
        end
        phase {
          name
        }
        attendees {
          ... on Buyer {
            fullName
          }
          ... on TeamMember {
            fullName
          }
        }
        lot {
          id
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindLotAppointmentsWithPaginationGQL extends Apollo.Query<
  FindLotAppointmentsWithPaginationQuery,
  FindLotAppointmentsWithPaginationQueryVariables
> {
  document = FindLotAppointmentsWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindLotAppointmentByIdDocument = gql`
  query findLotAppointmentById($id: Int!) {
    findLotAppointmentById(lotAppointmentId: $id) {
      error
      lotAppointment {
        name
        eventId
        phaseId
        phase {
          name
        }
        description
        startDate
        startTime
        start
        end
        event {
          communityPhaseAssignments {
            phase {
              id
            }
          }
        }
        lotAppointmentBuyers {
          buyer {
            id
            fullName
          }
        }
        lotAppointmentTeamMembers {
          teamMember {
            id
            fullName
          }
        }
        rsvpRequired
        address
        address2
        city
        stateId
        state {
          label
        }
        lot {
          id
          community {
            division {
              timeZone
            }
          }
        }
        zip
        requestedBy
        status
        newEvent {
          startDate
          startTime
          start
          end
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindLotAppointmentByIdGQL extends Apollo.Query<
  FindLotAppointmentByIdQuery,
  FindLotAppointmentByIdQueryVariables
> {
  document = FindLotAppointmentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetEventsForAutocompleteDocument = gql`
  query getEventsForAutocomplete(
    $name: String!
    $lotId: Int!
    $phaseId: Int
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: EventListSortByField = name
  ) {
    getEventsForLotAppointmentAutocomplete(
      name: $name
      lotId: $lotId
      phaseId: $phaseId
      archived: $archived
      order: $order
      sortBy: $sortBy
    ) {
      events {
        id
        name
        description
        rsvpRequired
        estimatedDuration
        communityPhaseAssignments {
          phase {
            id
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetEventsForAutocompleteGQL extends Apollo.Query<
  GetEventsForAutocompleteQuery,
  GetEventsForAutocompleteQueryVariables
> {
  document = GetEventsForAutocompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCommunityTeamMembersNamesForLotDocument = gql`
  query getCommunityTeamMembersNamesForLot($id: Int!) {
    getCommunityTeamMembersNamesForLot(lotId: $id) {
      error
      teamMembersNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetCommunityTeamMembersNamesForLotGQL extends Apollo.Query<
  GetCommunityTeamMembersNamesForLotQuery,
  GetCommunityTeamMembersNamesForLotQueryVariables
> {
  document = GetCommunityTeamMembersNamesForLotDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseNamesFromLotAppointmentsDocument = gql`
  query getPhaseNamesFromLotAppointments($lotId: Int!) {
    getPhaseNamesFromLotAppointments(lotId: $lotId) {
      error
      phaseNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseNamesFromLotAppointmentsGQL extends Apollo.Query<
  GetPhaseNamesFromLotAppointmentsQuery,
  GetPhaseNamesFromLotAppointmentsQueryVariables
> {
  document = GetPhaseNamesFromLotAppointmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAttendeesFromLotAppointmentsDocument = gql`
  query getAttendeesFromLotAppointments($lotId: Int!) {
    findLotAppointmentsAttendees(lotId: $lotId) {
      error
      attendees {
        ... on Buyer {
          fullName
        }
        ... on TeamMember {
          fullName
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetAttendeesFromLotAppointmentsGQL extends Apollo.Query<
  GetAttendeesFromLotAppointmentsQuery,
  GetAttendeesFromLotAppointmentsQueryVariables
> {
  document = GetAttendeesFromLotAppointmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchLotAppointmentsForAutoCompleteDocument = gql`
  query searchLotAppointmentsForAutoComplete(
    $lotId: Int!
    $name: String
    $order: SortOrder = asc
    $sortBy: LotAppointmentsSortFields = name
  ) {
    getLotAppointmentNamesForAutocomplete(lotId: $lotId, name: $name) {
      error
      names
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchLotAppointmentsForAutoCompleteGQL extends Apollo.Query<
  SearchLotAppointmentsForAutoCompleteQuery,
  SearchLotAppointmentsForAutoCompleteQueryVariables
> {
  document = SearchLotAppointmentsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportLotAppointmentsDocument = gql`
  mutation exportLotAppointments(
    $lotId: Int!
    $name: String
    $start: DateTime
    $end: DateTime
    $statuses: [LotAppointmentStatus!]
    $phaseNames: [String!]
    $attendees: [String!]
    $exportType: LotAppointmentsExportTypes!
    $order: SortOrder
    $sortBy: LotAppointmentsSortFields
  ) {
    exportResponse: exportLotAppointments(
      lotId: $lotId
      name: $name
      start: $start
      end: $end
      statuses: $statuses
      phaseNames: $phaseNames
      attendees: $attendees
      exportType: $exportType
      order: $order
      sortBy: $sortBy
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportLotAppointmentsGQL extends Apollo.Mutation<
  ExportLotAppointmentsMutation,
  ExportLotAppointmentsMutationVariables
> {
  document = ExportLotAppointmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportLotAppointmentDocument = gql`
  mutation exportLotAppointment($id: Int!, $exportType: LotAppointmentsExportTypes!) {
    exportResponse: exportLotAppointment(lotAppointmentId: $id, exportType: $exportType) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportLotAppointmentGQL extends Apollo.Mutation<
  ExportLotAppointmentMutation,
  ExportLotAppointmentMutationVariables
> {
  document = ExportLotAppointmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteLotAppointmentDocument = gql`
  mutation deleteLotAppointment($id: Int!) {
    deleteLotAppointment(lotAppointmentId: $id) {
      error
      success
      lotAppointment {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteLotAppointmentGQL extends Apollo.Mutation<
  DeleteLotAppointmentMutation,
  DeleteLotAppointmentMutationVariables
> {
  document = DeleteLotAppointmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateHomeAppointmentDocument = gql`
  mutation createHomeAppointment($createHomeAppointmentInput: CreateLotAppointmentInput!) {
    createHomeAppointment: createLotAppointment(
      createLotAppointmentInput: $createHomeAppointmentInput
    ) {
      error
      success
      lotAppointment {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateHomeAppointmentGQL extends Apollo.Mutation<
  CreateHomeAppointmentMutation,
  CreateHomeAppointmentMutationVariables
> {
  document = CreateHomeAppointmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateLotAppointmentDocument = gql`
  mutation updateLotAppointment($id: Int!, $input: UpdateLotAppointmentInput!) {
    updateLotAppointment(lotAppointmentId: $id, updateLotAppointmentInput: $input) {
      error
      success
      lotAppointment {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateLotAppointmentGQL extends Apollo.Mutation<
  UpdateLotAppointmentMutation,
  UpdateLotAppointmentMutationVariables
> {
  document = UpdateLotAppointmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RescheduleLotAppointmentDocument = gql`
  mutation rescheduleLotAppointment($id: Int!, $input: RescheduleLotAppointmentInput!) {
    rescheduleLotAppointmentFromCMS(lotAppointmentId: $id, rescheduleLotAppointmentInput: $input) {
      error
      success
      lotAppointment {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RescheduleLotAppointmentGQL extends Apollo.Mutation<
  RescheduleLotAppointmentMutation,
  RescheduleLotAppointmentMutationVariables
> {
  document = RescheduleLotAppointmentDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomesDocument = gql`
  query getHomes(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: AllowedLotsSortFields
    $contractDateFrom: DateTime
    $contractDateTo: DateTime
    $lastLoginDateFrom: DateTime
    $lastLoginDateTo: DateTime
    $contractCancelledDateFrom: DateTime
    $contractCancelledDateTo: DateTime
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $planId: Int
    $planName: String
    $address: String
    $homesite: String
    $buyerNames: String
    $phasesIds: [Int!]
    $phasesNames: [String!]
    $archived: Boolean
  ) {
    getHomes: getLots(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      contractDateFrom: $contractDateFrom
      contractDateTo: $contractDateTo
      lastLoginDateFrom: $lastLoginDateFrom
      lastLoginDateTo: $lastLoginDateTo
      contractCancelledDateFrom: $contractCancelledDateFrom
      contractCancelledDateTo: $contractCancelledDateTo
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      planId: $planId
      planName: $planName
      address: $address
      homesite: $homesite
      buyerNames: $buyerNames
      phasesIds: $phasesIds
      phasesNames: $phasesNames
      archived: $archived
    ) {
      error
      items {
        id
        address
        homesite
        elevation {
          id
          plan {
            id
            name
          }
        }
        contractDate
        estimatedDeliveryDate
        closingDate
        buyerFirstName
        buyerLastName
        lastLoginDate
        contractCancelledDate
        buyers {
          id
          user {
            id
            fullName
          }
        }
        phase {
          id
          name
        }
        community {
          id
          name
          division {
            id
            name
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetHomesGQL extends Apollo.Query<GetHomesQuery, GetHomesQueryVariables> {
  document = GetHomesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindHomeByIdDocument = gql`
  query findHomeById($id: Int!) {
    findHomeById: findLotById(id: $id) {
      error
      lot {
        id
        address
        homesite
        city
        stateId
        zip
        elevationRendering
        elevation {
          id
          name
          imageUrl
          plan {
            id
            name
          }
        }
        contractDate
        estimatedDeliveryDate
        closingDate
        buyerFirstName
        buyerLastName
        buyerEmail
        buyerHomePhone
        lot149PhotosLotNum
        teamMembersAssignments {
          teamMember {
            groupName
            groupMembersNames
            status
          }
        }
        buyers {
          id
          activated
          user {
            id
            fullName
          }
        }
        phase {
          id
          name
        }
        community {
          id
          name
          division {
            id
            name
            timeZone
            country {
              id
              label
            }
            division149PhotosId
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindHomeByIdGQL extends Apollo.Query<FindHomeByIdQuery, FindHomeByIdQueryVariables> {
  document = FindHomeByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLotCommunityDataDocument = gql`
  query getLotCommunityData($id: Int!) {
    getLotCommunityData: findLotById(id: $id) {
      error
      lot {
        id
        community {
          id
          stateId
          address
          address2
          zip
          city
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetLotCommunityDataGQL extends Apollo.Query<
  GetLotCommunityDataQuery,
  GetLotCommunityDataQueryVariables
> {
  document = GetLotCommunityDataDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPageContextDataForHomeDocument = gql`
  query getPageContextDataForHome($id: Int!) {
    getPageContextDataForHome: findLotById(id: $id) {
      error
      lot {
        id
        address
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPageContextDataForHomeGQL extends Apollo.Query<
  GetPageContextDataForHomeQuery,
  GetPageContextDataForHomeQueryVariables
> {
  document = GetPageContextDataForHomeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchHomesForAutoCompleteDocument = gql`
  query searchHomesForAutoComplete(
    $planName: String
    $address: String
    $homesite: String
    $buyerNames: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedLotsSortFields = address
  ) {
    getHomes: findLots(
      planName: $planName
      address: $address
      homesite: $homesite
      buyerNames: $buyerNames
      archived: $archived
      order: $order
      sortBy: $sortBy
    ) {
      error
      items: lots {
        id
        address
        homesite
        planName
        buyerFirstName
        buyerLastName
        buyers {
          user {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchHomesForAutoCompleteGQL extends Apollo.Query<
  SearchHomesForAutoCompleteQuery,
  SearchHomesForAutoCompleteQueryVariables
> {
  document = SearchHomesForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetHomeTeamMembersIdsDocument = gql`
  query getHomeTeamMembersIds($lotId: Int!) {
    getHomeTeamMembersIds: getLotTeamMembersIds(lotId: $lotId) {
      error
      success
      teamMemberIds
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetHomeTeamMembersIdsGQL extends Apollo.Query<
  GetHomeTeamMembersIdsQuery,
  GetHomeTeamMembersIdsQueryVariables
> {
  document = GetHomeTeamMembersIdsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindCommunityTeamMembersForLotDocument = gql`
  query findCommunityTeamMembersForLot(
    $communityId: Int!
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: TeamMembersSortFields
    $getAll: Boolean
  ) {
    findCommunityTeamMembersForLot(
      communityId: $communityId
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      getAll: $getAll
    ) {
      error
      success
      items {
        id
        fullName
        title
        type {
          label
        }
        affiliation
        company {
          name
        }
        email
        mobilePhone
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindCommunityTeamMembersForLotGQL extends Apollo.Query<
  FindCommunityTeamMembersForLotQuery,
  FindCommunityTeamMembersForLotQueryVariables
> {
  document = FindCommunityTeamMembersForLotDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindLotAttendeesDocument = gql`
  query findLotAttendees($lotId: Int!) {
    findLotAttendees(lotId: $lotId) {
      error
      attendees {
        __typename
        ...BuyerCore
        ...TeamMemberCore
      }
    }
  }
  ${BuyerCoreFragmentDoc}
  ${TeamMemberCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindLotAttendeesGQL extends Apollo.Query<
  FindLotAttendeesQuery,
  FindLotAttendeesQueryVariables
> {
  document = FindLotAttendeesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchHomesCountDocument = gql`
  query fetchHomesCount {
    fetchHomesCount: fetchLotsCount {
      error
      statsCount: lotsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchHomesCountGQL extends Apollo.Query<
  FetchHomesCountQuery,
  FetchHomesCountQueryVariables
> {
  document = FetchHomesCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetLotUpdatesDocument = gql`
  query GetLotUpdates($lotId: Int!, $page: Int, $limit: Int) {
    getLotUpdates(lotId: $lotId, page: $page, limit: $limit) {
      success
      error
      statusCode
      items {
        id
        title
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetLotUpdatesGQL extends Apollo.Query<
  GetLotUpdatesQuery,
  GetLotUpdatesQueryVariables
> {
  document = GetLotUpdatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportLotUpdatesDocument = gql`
  mutation exportLotUpdates($lotId: Int!, $exportType: LotUpdatesExportTypes!) {
    exportResponse: exportLotUpdates(lotId: $lotId, exportType: $exportType) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportLotUpdatesGQL extends Apollo.Mutation<
  ExportLotUpdatesMutation,
  ExportLotUpdatesMutationVariables
> {
  document = ExportLotUpdatesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseNamesFromLotsDocument = gql`
  query getPhaseNamesFromLots(
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $planId: Int
    $address: String
    $homesite: String
    $buyerNames: String
    $archived: Boolean
  ) {
    getPhaseNamesFromLots(
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      planId: $planId
      address: $address
      homesite: $homesite
      buyerNames: $buyerNames
      archived: $archived
    ) {
      error
      phaseNames
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseNamesFromLotsGQL extends Apollo.Query<
  GetPhaseNamesFromLotsQuery,
  GetPhaseNamesFromLotsQueryVariables
> {
  document = GetPhaseNamesFromLotsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportHomesDocument = gql`
  mutation exportHomes(
    $order: SortOrder
    $sortBy: AllowedLotsSortFields
    $contractDateFrom: DateTime
    $contractDateTo: DateTime
    $lastLoginDateFrom: DateTime
    $lastLoginDateTo: DateTime
    $contractCancelledDateFrom: DateTime
    $contractCancelledDateTo: DateTime
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $planId: Int
    $planName: String
    $address: String
    $homesite: String
    $buyerNames: String
    $phasesNames: [String!]
    $archived: Boolean
    $exportType: LotsExportTypes!
    $requestUserTimezone: String!
  ) {
    exportResponse: exportLots(
      order: $order
      sortBy: $sortBy
      contractDateFrom: $contractDateFrom
      contractDateTo: $contractDateTo
      lastLoginDateFrom: $lastLoginDateFrom
      lastLoginDateTo: $lastLoginDateTo
      contractCancelledDateFrom: $contractCancelledDateFrom
      contractCancelledDateTo: $contractCancelledDateTo
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      planId: $planId
      planName: $planName
      address: $address
      homesite: $homesite
      buyerNames: $buyerNames
      phasesNames: $phasesNames
      archived: $archived
      exportType: $exportType
      requestUserTimezone: $requestUserTimezone
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportHomesGQL extends Apollo.Mutation<
  ExportHomesMutation,
  ExportHomesMutationVariables
> {
  document = ExportHomesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportHomeTeamMembersDocument = gql`
  mutation exportHomeTeamMembers(
    $lotId: Int!
    $order: SortOrder
    $sortBy: TeamMembersSortFields
    $exportType: TeamMembersExportTypes!
  ) {
    exportResponse: exportLotTeamMembers(
      lotId: $lotId
      order: $order
      sortBy: $sortBy
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportHomeTeamMembersGQL extends Apollo.Mutation<
  ExportHomeTeamMembersMutation,
  ExportHomeTeamMembersMutationVariables
> {
  document = ExportHomeTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateHomeDocument = gql`
  mutation createHome($createHomeInput: CreateLotInput!) {
    createHome: createLot(createLotInput: $createHomeInput) {
      error
      success
      lot {
        address
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateHomeGQL extends Apollo.Mutation<
  CreateHomeMutation,
  CreateHomeMutationVariables
> {
  document = CreateHomeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateHomeDocument = gql`
  mutation updateHome($updateHomeInput: UpdateLotInput!, $id: Int!) {
    updateHome: updateLot(updateLotInput: $updateHomeInput, id: $id) {
      error
      lot {
        id
        address
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateHomeGQL extends Apollo.Mutation<
  UpdateHomeMutation,
  UpdateHomeMutationVariables
> {
  document = UpdateHomeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveHomeDocument = gql`
  mutation archiveHome($archive: Boolean!, $id: Int!) {
    archiveHome: archiveLot(archive: $archive, id: $id) {
      error
      lot {
        id
        address
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveHomeGQL extends Apollo.Mutation<
  ArchiveHomeMutation,
  ArchiveHomeMutationVariables
> {
  document = ArchiveHomeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteHomeDocument = gql`
  mutation deleteHome($id: Int!) {
    deleteHome: deleteLot(id: $id) {
      error
      lot {
        id
        address
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteHomeGQL extends Apollo.Mutation<
  DeleteHomeMutation,
  DeleteHomeMutationVariables
> {
  document = DeleteHomeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateHomeTeamMembersDocument = gql`
  mutation updateHomeTeamMembers(
    $updateHomeTeamMembersInput: UpdateLotTeamMembersInput!
    $lotId: Int!
    $skipCheck: Boolean
  ) {
    updateHomeTeamMembers: updateLotTeamMembers(
      updateLotTeamMembersInput: $updateHomeTeamMembersInput
      lotId: $lotId
      skipCheck: $skipCheck
    ) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateHomeTeamMembersGQL extends Apollo.Mutation<
  UpdateHomeTeamMembersMutation,
  UpdateHomeTeamMembersMutationVariables
> {
  document = UpdateHomeTeamMembersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBuyersWithPaginationDocument = gql`
  query getBuyersWithPagination(
    $order: SortOrder
    $sortBy: AllowedBuyersSortFields
    $page: Int
    $limit: Int
    $lotId: Int!
  ) {
    getBuyersWithPagination: getBuyersWithPagination(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      lotId: $lotId
    ) {
      error
      items {
        id
        activated
        lotId
        fullName
        email
        phone
        status
        type
        lastLoginDate
        user {
          id
          conversations {
            id
            status
            lot {
              id
            }
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetBuyersWithPaginationGQL extends Apollo.Query<
  GetBuyersWithPaginationQuery,
  GetBuyersWithPaginationQueryVariables
> {
  document = GetBuyersWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBuyerByIdDocument = gql`
  query getBuyerById($id: Int!) {
    getBuyerById(id: $id) {
      error
      buyer {
        id
        activated
        lotId
        fullName
        firstName
        lastName
        email
        phone
        type
        relationship
        avatar
        user {
          notificationsSettings {
            email
            text
            id
            label
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetBuyerByIdGQL extends Apollo.Query<GetBuyerByIdQuery, GetBuyerByIdQueryVariables> {
  document = GetBuyerByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPageContextDataForLoginDocument = gql`
  query getPageContextDataForLogin($id: Int!) {
    getPageContextDataForLogin: getBuyerById(id: $id) {
      error
      buyer {
        id
        fullName
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPageContextDataForLoginGQL extends Apollo.Query<
  GetPageContextDataForLoginQuery,
  GetPageContextDataForLoginQueryVariables
> {
  document = GetPageContextDataForLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportBuyersDocument = gql`
  mutation exportBuyers(
    $order: SortOrder
    $sortBy: AllowedBuyersSortFields
    $lotId: Int
    $exportType: BuyersExportTypes!
    $requestUserTimezone: String!
  ) {
    exportResponse: exportBuyers(
      order: $order
      sortBy: $sortBy
      lotId: $lotId
      exportType: $exportType
      requestUserTimezone: $requestUserTimezone
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportBuyersGQL extends Apollo.Mutation<
  ExportBuyersMutation,
  ExportBuyersMutationVariables
> {
  document = ExportBuyersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteBuyerDocument = gql`
  mutation deleteBuyer($id: Int!, $skipCheck: Boolean) {
    deleteBuyer(id: $id, skipCheck: $skipCheck) {
      error
      buyer {
        id
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteBuyerGQL extends Apollo.Mutation<
  DeleteBuyerMutation,
  DeleteBuyerMutationVariables
> {
  document = DeleteBuyerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateBuyerDocument = gql`
  mutation createBuyer($lotId: Int!, $updateBuyerInput: UpdateBuyerInput!) {
    createBuyer(lotId: $lotId, updateBuyerInput: $updateBuyerInput) {
      error
      buyer {
        id
        fullName
        activated
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateBuyerGQL extends Apollo.Mutation<
  CreateBuyerMutation,
  CreateBuyerMutationVariables
> {
  document = CreateBuyerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateBuyerDocument = gql`
  mutation updateBuyer($updateBuyerInput: UpdateBuyerInput!, $buyerId: Int!) {
    updateBuyer(updateBuyerInput: $updateBuyerInput, buyerId: $buyerId) {
      error
      buyer {
        id
        fullName
        activated
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateBuyerGQL extends Apollo.Mutation<
  UpdateBuyerMutation,
  UpdateBuyerMutationVariables
> {
  document = UpdateBuyerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendActivationEmailDocument = gql`
  mutation sendActivationEmail($id: Int!, $generateNewPassword: Boolean) {
    sendActivationEmail(id: $id, generateNewPassword: $generateNewPassword) {
      error
      buyer {
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SendActivationEmailGQL extends Apollo.Mutation<
  SendActivationEmailMutation,
  SendActivationEmailMutationVariables
> {
  document = SendActivationEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindNotificationsDocument = gql`
  query FindNotifications($type: NotificationSettingType) {
    findNotificationsSettings(type: $type) {
      error
      notificationsSettings {
        id
        name
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindNotificationsGQL extends Apollo.Query<
  FindNotificationsQuery,
  FindNotificationsQueryVariables
> {
  document = FindNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindPermissionsDocument = gql`
  query FindPermissions {
    findPermissions {
      error
      permissions {
        id
        name
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindPermissionsGQL extends Apollo.Query<
  FindPermissionsQuery,
  FindPermissionsQueryVariables
> {
  document = FindPermissionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseTipsDocument = gql`
  query getPhaseTips($phaseId: Int!, $archived: Boolean) {
    getPhaseTips(phaseId: $phaseId, archived: $archived) {
      error
      items {
        id
        name
        description
        sequence
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseTipsGQL extends Apollo.Query<GetPhaseTipsQuery, GetPhaseTipsQueryVariables> {
  document = GetPhaseTipsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseTipByIdDocument = gql`
  query getPhaseTipById($phaseTipId: Int!) {
    getPhaseTipById(phaseTipId: $phaseTipId) {
      error
      phaseTip {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseTipByIdGQL extends Apollo.Query<
  GetPhaseTipByIdQuery,
  GetPhaseTipByIdQueryVariables
> {
  document = GetPhaseTipByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseTipsWithPaginationDocument = gql`
  query getPhaseTipsWithPagination(
    $phaseId: Int!
    $archived: Boolean
    $page: Int
    $limit: Int
    $name: String
    $description: String
    $sortBy: AllowedPhaseTipsSortFields
    $order: SortOrder
  ) {
    getPhaseTipsWithPagination(
      phaseId: $phaseId
      archived: $archived
      page: $page
      limit: $limit
      name: $name
      description: $description
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        name
        description
        sequence
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseTipsWithPaginationGQL extends Apollo.Query<
  GetPhaseTipsWithPaginationQuery,
  GetPhaseTipsWithPaginationQueryVariables
> {
  document = GetPhaseTipsWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPhaseTipsCountDocument = gql`
  query fetchPhaseTipsCount($phaseId: Int!) {
    fetchPhaseTipsCount(phaseId: $phaseId) {
      error
      statsCount: phaseTipsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchPhaseTipsCountGQL extends Apollo.Query<
  FetchPhaseTipsCountQuery,
  FetchPhaseTipsCountQueryVariables
> {
  document = FetchPhaseTipsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchPhaseTipsForAutoCompleteDocument = gql`
  query searchPhaseTipsForAutoComplete(
    $phaseId: Int!
    $name: String
    $description: String
    $archived: Boolean
    $sortBy: AllowedPhaseTipsSortFields = name
    $order: SortOrder = asc
  ) {
    getPhaseTipsWithPagination(
      phaseId: $phaseId
      name: $name
      description: $description
      archived: $archived
    ) {
      error
      items {
        id
        name
        description
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchPhaseTipsForAutoCompleteGQL extends Apollo.Query<
  SearchPhaseTipsForAutoCompleteQuery,
  SearchPhaseTipsForAutoCompleteQueryVariables
> {
  document = SearchPhaseTipsForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePhaseTipsOrderDocument = gql`
  mutation updatePhaseTipsOrder($phaseTipIds: [Int!]!, $phaseId: Int!) {
    updatePhaseTipsOrder(phaseTipIds: $phaseTipIds, phaseId: $phaseId) {
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePhaseTipsOrderGQL extends Apollo.Mutation<
  UpdatePhaseTipsOrderMutation,
  UpdatePhaseTipsOrderMutationVariables
> {
  document = UpdatePhaseTipsOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePhaseTipDocument = gql`
  mutation updatePhaseTip($updatePhaseInput: UpdatePhaseInput!, $phaseTipId: Int!) {
    updatePhaseTip(updatePhaseInput: $updatePhaseInput, phaseTipId: $phaseTipId) {
      error
      success
      phaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePhaseTipGQL extends Apollo.Mutation<
  UpdatePhaseTipMutation,
  UpdatePhaseTipMutationVariables
> {
  document = UpdatePhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePhaseTipDocument = gql`
  mutation createPhaseTip($createPhaseTipInput: CreatePhaseTipInput!) {
    createPhaseTip(createPhaseTipInput: $createPhaseTipInput) {
      error
      success
      phaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreatePhaseTipGQL extends Apollo.Mutation<
  CreatePhaseTipMutation,
  CreatePhaseTipMutationVariables
> {
  document = CreatePhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchivePhaseTipDocument = gql`
  mutation archivePhaseTip($archive: Boolean!, $id: Int!) {
    archivePhaseTip(archive: $archive, id: $id) {
      statusCode
      error
      phaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchivePhaseTipGQL extends Apollo.Mutation<
  ArchivePhaseTipMutation,
  ArchivePhaseTipMutationVariables
> {
  document = ArchivePhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeletePhaseTipDocument = gql`
  mutation deletePhaseTip($id: Int!) {
    deletePhaseTip(id: $id) {
      error
      statusCode
      phaseTip {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeletePhaseTipGQL extends Apollo.Mutation<
  DeletePhaseTipMutation,
  DeletePhaseTipMutationVariables
> {
  document = DeletePhaseTipDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportPhaseTipsDocument = gql`
  mutation exportPhaseTips(
    $phaseId: Int!
    $archived: Boolean
    $name: String
    $description: String
    $sortBy: AllowedPhaseTipsSortFields
    $order: SortOrder
    $exportType: PhaseTipsExportTypes!
  ) {
    exportResponse: exportPhaseTips(
      phaseId: $phaseId
      archived: $archived
      name: $name
      description: $description
      sortBy: $sortBy
      order: $order
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportPhaseTipsGQL extends Apollo.Mutation<
  ExportPhaseTipsMutation,
  ExportPhaseTipsMutationVariables
> {
  document = ExportPhaseTipsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhasesDocument = gql`
  query getPhases(
    $divisionId: Int
    $archived: Boolean
    $sortBy: AllowedPhasesSortFields = name
    $order: SortOrder = asc
  ) {
    getPhases(divisionId: $divisionId, archived: $archived) {
      error
      success
      items: phases {
        ...PhaseCore
      }
    }
  }
  ${PhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhasesGQL extends Apollo.Query<GetPhasesQuery, GetPhasesQueryVariables> {
  document = GetPhasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseNamesDocument = gql`
  query getPhaseNames($divisionId: Int, $archived: Boolean) {
    getPhases(divisionId: $divisionId, archived: $archived) {
      error
      success
      items: phases {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseNamesGQL extends Apollo.Query<
  GetPhaseNamesQuery,
  GetPhaseNamesQueryVariables
> {
  document = GetPhaseNamesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhasesByLotIdDocument = gql`
  query getPhasesByLotId($lotId: Int!, $archived: Boolean) {
    getPhases(lotId: $lotId, archived: $archived) {
      error
      success
      items: phases {
        ...PhaseCore
      }
    }
  }
  ${PhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhasesByLotIdGQL extends Apollo.Query<
  GetPhasesByLotIdQuery,
  GetPhasesByLotIdQueryVariables
> {
  document = GetPhasesByLotIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhasesWithPaginationDocument = gql`
  query getPhasesWithPagination(
    $page: Int
    $limit: Int
    $divisionId: Int!
    $order: SortOrder
    $sortBy: AllowedPhasesSortFields
    $archived: Boolean
  ) {
    getPhasesWithPagination(
      page: $page
      limit: $limit
      divisionId: $divisionId
      order: $order
      sortBy: $sortBy
      archived: $archived
    ) {
      error
      success
      items {
        ...PhaseCore
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PhaseCoreFragmentDoc}
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhasesWithPaginationGQL extends Apollo.Query<
  GetPhasesWithPaginationQuery,
  GetPhasesWithPaginationQueryVariables
> {
  document = GetPhasesWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPhaseByIdDocument = gql`
  query getPhaseById($phaseId: Int!) {
    getPhaseById(phaseId: $phaseId) {
      error
      success
      phase {
        ...PhaseCore
        videoPreviewImage
      }
    }
  }
  ${PhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetPhaseByIdGQL extends Apollo.Query<GetPhaseByIdQuery, GetPhaseByIdQueryVariables> {
  document = GetPhaseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchPhasesCountDocument = gql`
  query fetchPhasesCount($divisionId: Int!) {
    fetchPhasesCount(divisionId: $divisionId) {
      error
      statsCount: phasesCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchPhasesCountGQL extends Apollo.Query<
  FetchPhasesCountQuery,
  FetchPhasesCountQueryVariables
> {
  document = FetchPhasesCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDefaultPhasesDocument = gql`
  query getDefaultPhases($archived: Boolean) {
    getDefaultPhases(archived: $archived) {
      error
      success
      items: defaultPhases {
        ...DefaultPhaseCore
      }
    }
  }
  ${DefaultPhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetDefaultPhasesGQL extends Apollo.Query<
  GetDefaultPhasesQuery,
  GetDefaultPhasesQueryVariables
> {
  document = GetDefaultPhasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDefaultPhasesWithPaginationDocument = gql`
  query getDefaultPhasesWithPagination(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: AllowedPhasesSortFields
    $archived: Boolean
  ) {
    getDefaultPhasesWithPagination(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      archived: $archived
    ) {
      error
      success
      items {
        ...DefaultPhaseCore
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${DefaultPhaseCoreFragmentDoc}
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetDefaultPhasesWithPaginationGQL extends Apollo.Query<
  GetDefaultPhasesWithPaginationQuery,
  GetDefaultPhasesWithPaginationQueryVariables
> {
  document = GetDefaultPhasesWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDefaultPhaseByIdDocument = gql`
  query getDefaultPhaseById($defaultPhaseId: Int!) {
    getDefaultPhaseById(defaultPhaseId: $defaultPhaseId) {
      error
      success
      defaultPhase {
        ...DefaultPhaseCore
        videoPreviewImage
      }
    }
  }
  ${DefaultPhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetDefaultPhaseByIdGQL extends Apollo.Query<
  GetDefaultPhaseByIdQuery,
  GetDefaultPhaseByIdQueryVariables
> {
  document = GetDefaultPhaseByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchDefaultPhasesCountDocument = gql`
  query fetchDefaultPhasesCount {
    fetchDefaultPhasesCount {
      error
      statsCount: defaultPhasesCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchDefaultPhasesCountGQL extends Apollo.Query<
  FetchDefaultPhasesCountQuery,
  FetchDefaultPhasesCountQueryVariables
> {
  document = FetchDefaultPhasesCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePhaseDocument = gql`
  mutation createPhase($createPhaseInput: CreatePhaseInput!) {
    createPhase(createPhaseInput: $createPhaseInput) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreatePhaseGQL extends Apollo.Mutation<
  CreatePhaseMutation,
  CreatePhaseMutationVariables
> {
  document = CreatePhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePhaseDocument = gql`
  mutation updatePhase($updatePhaseInput: UpdatePhaseInput!, $phaseId: Int!) {
    updatePhase(updatePhaseInput: $updatePhaseInput, phaseId: $phaseId) {
      error
      success
      phase {
        ...PhaseCore
        videoPreviewImage
      }
    }
  }
  ${PhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePhaseGQL extends Apollo.Mutation<
  UpdatePhaseMutation,
  UpdatePhaseMutationVariables
> {
  document = UpdatePhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePhasesOrderDocument = gql`
  mutation updatePhasesOrder($phaseIds: [Int!]!, $divisionId: Int!) {
    updatePhasesOrder(phaseIds: $phaseIds, divisionId: $divisionId) {
      error
      success
      items: phases {
        ...PhaseCore
      }
    }
  }
  ${PhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePhasesOrderGQL extends Apollo.Mutation<
  UpdatePhasesOrderMutation,
  UpdatePhasesOrderMutationVariables
> {
  document = UpdatePhasesOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeletePhaseDocument = gql`
  mutation deletePhase($phaseId: Int!) {
    deletePhase(phaseId: $phaseId) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeletePhaseGQL extends Apollo.Mutation<
  DeletePhaseMutation,
  DeletePhaseMutationVariables
> {
  document = DeletePhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchivePhaseDocument = gql`
  mutation archivePhase($archive: Boolean!, $id: Int!) {
    archivePhase(archive: $archive, id: $id) {
      error
      phase {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchivePhaseGQL extends Apollo.Mutation<
  ArchivePhaseMutation,
  ArchivePhaseMutationVariables
> {
  document = ArchivePhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportPhasesDocument = gql`
  mutation exportPhases($divisionId: Int!, $archived: Boolean, $exportType: PhasesExportTypes!) {
    exportResponse: exportPhases(
      divisionId: $divisionId
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportPhasesGQL extends Apollo.Mutation<
  ExportPhasesMutation,
  ExportPhasesMutationVariables
> {
  document = ExportPhasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDefaultPhaseDocument = gql`
  mutation createDefaultPhase($createDefaultPhaseInput: CreateDefaultPhaseInput!) {
    createDefaultPhase(createDefaultPhaseInput: $createDefaultPhaseInput) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateDefaultPhaseGQL extends Apollo.Mutation<
  CreateDefaultPhaseMutation,
  CreateDefaultPhaseMutationVariables
> {
  document = CreateDefaultPhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDefaultPhaseDocument = gql`
  mutation updateDefaultPhase(
    $updateDivisionPhases: Boolean
    $updateDefaultPhaseInput: UpdateDefaultPhaseInput!
    $defaultPhaseId: Int!
  ) {
    updateDefaultPhase(
      updateDivisionPhases: $updateDivisionPhases
      updateDefaultPhaseInput: $updateDefaultPhaseInput
      defaultPhaseId: $defaultPhaseId
    ) {
      error
      success
      defaultPhase {
        ...DefaultPhaseCore
        videoPreviewImage
      }
    }
  }
  ${DefaultPhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateDefaultPhaseGQL extends Apollo.Mutation<
  UpdateDefaultPhaseMutation,
  UpdateDefaultPhaseMutationVariables
> {
  document = UpdateDefaultPhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDefaultPhasesOrderDocument = gql`
  mutation updateDefaultPhasesOrder($defaultPhaseIds: [Int!]!) {
    updateDefaultPhasesOrder(defaultPhaseIds: $defaultPhaseIds) {
      error
      success
      items: defaultPhases {
        ...DefaultPhaseCore
      }
    }
  }
  ${DefaultPhaseCoreFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateDefaultPhasesOrderGQL extends Apollo.Mutation<
  UpdateDefaultPhasesOrderMutation,
  UpdateDefaultPhasesOrderMutationVariables
> {
  document = UpdateDefaultPhasesOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteDefaultPhaseDocument = gql`
  mutation deleteDefaultPhase($deleteDivisionPhases: Boolean, $defaultPhaseId: Int!) {
    deleteDefaultPhase(
      deleteDivisionPhases: $deleteDivisionPhases
      defaultPhaseId: $defaultPhaseId
    ) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteDefaultPhaseGQL extends Apollo.Mutation<
  DeleteDefaultPhaseMutation,
  DeleteDefaultPhaseMutationVariables
> {
  document = DeleteDefaultPhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDefaultPhaseDocument = gql`
  mutation archiveDefaultPhase($archive: Boolean!, $id: Int!) {
    archiveDefaultPhase(archive: $archive, id: $id) {
      error
      defaultPhase {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveDefaultPhaseGQL extends Apollo.Mutation<
  ArchiveDefaultPhaseMutation,
  ArchiveDefaultPhaseMutationVariables
> {
  document = ArchiveDefaultPhaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDefaultPhasesDocument = gql`
  mutation exportDefaultPhases($archived: Boolean, $exportType: PhasesExportTypes!) {
    exportResponse: exportDefaultPhases(archived: $archived, exportType: $exportType) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportDefaultPhasesGQL extends Apollo.Mutation<
  ExportDefaultPhasesMutation,
  ExportDefaultPhasesMutationVariables
> {
  document = ExportDefaultPhasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPlansWithPaginationDocument = gql`
  query getPlansWithPagination(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: AllowedPlansSortFields
    $archived: Boolean
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $name: String
    $hasElevations: Boolean
  ) {
    getPlansWithPagination(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      archived: $archived
      divisionIds: $divisionIds
      communityIds: $communityIds
      name: $name
      hasElevations: $hasElevations
    ) {
      error
      items {
        name
        id
        elevationsCount
        editable
        communities {
          name
          division {
            name
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class GetPlansWithPaginationGQL extends Apollo.Query<
  GetPlansWithPaginationQuery,
  GetPlansWithPaginationQueryVariables
> {
  document = GetPlansWithPaginationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchPlansForAutoCompleteDocument = gql`
  query searchPlansForAutoComplete(
    $name: String
    $archived: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedPlansSortFields = name
  ) {
    getPlansWithPagination(name: $name, archived: $archived, order: $order, sortBy: $sortBy) {
      error
      items {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchPlansForAutoCompleteGQL extends Apollo.Query<
  SearchPlansForAutoCompleteQuery,
  SearchPlansForAutoCompleteQueryVariables
> {
  document = SearchPlansForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPlansDocument = gql`
  query getPlans($communityIds: [Int!], $withElevations: Boolean = false, $archived: Boolean) {
    getPlans(archived: $archived, communityIds: $communityIds) {
      error
      plans {
        id
        name
        communities {
          id
        }
        elevations @include(if: $withElevations) {
          id
          name
          imageUrl
          status
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPlansGQL extends Apollo.Query<GetPlansQuery, GetPlansQueryVariables> {
  document = GetPlansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindPlanByIdDocument = gql`
  query findPlanById($planId: Int!) {
    findPlanById(planId: $planId) {
      error
      success
      plan {
        name
        id
        communities {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindPlanByIdGQL extends Apollo.Query<FindPlanByIdQuery, FindPlanByIdQueryVariables> {
  document = FindPlanByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPageContextDataForPlanDocument = gql`
  query getPageContextDataForPlan($planId: Int!) {
    getPageContextDataForPlan: findPlanById(planId: $planId) {
      error
      plan {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPageContextDataForPlanGQL extends Apollo.Query<
  GetPageContextDataForPlanQuery,
  GetPageContextDataForPlanQueryVariables
> {
  document = GetPageContextDataForPlanDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPlansCountDocument = gql`
  query getPlansCount {
    getPlansCount {
      error
      statsCount: plansCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetPlansCountGQL extends Apollo.Query<
  GetPlansCountQuery,
  GetPlansCountQueryVariables
> {
  document = GetPlansCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeletePlanDocument = gql`
  mutation deletePlan($planId: Int!) {
    deletePlan(planId: $planId) {
      success
      error
      plan {
        name
        status
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeletePlanGQL extends Apollo.Mutation<
  DeletePlanMutation,
  DeletePlanMutationVariables
> {
  document = DeletePlanDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchivePlanDocument = gql`
  mutation archivePlan($planId: Int!, $archive: Boolean!) {
    archivePlan(planId: $planId, archive: $archive) {
      success
      error
      plan {
        name
        status
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchivePlanGQL extends Apollo.Mutation<
  ArchivePlanMutation,
  ArchivePlanMutationVariables
> {
  document = ArchivePlanDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePlanDocument = gql`
  mutation createPlan($createPlanInput: CreatePlanInput!) {
    createPlan(createPlanInput: $createPlanInput) {
      error
      success
      plan {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreatePlanGQL extends Apollo.Mutation<
  CreatePlanMutation,
  CreatePlanMutationVariables
> {
  document = CreatePlanDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePlanDocument = gql`
  mutation updatePlan($planId: Int!, $updatePlanInput: UpdatePlanInput!) {
    updatePlan(planId: $planId, updatePlanInput: $updatePlanInput) {
      error
      success
      plan {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePlanGQL extends Apollo.Mutation<
  UpdatePlanMutation,
  UpdatePlanMutationVariables
> {
  document = UpdatePlanDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindElevationsPaginatedDocument = gql`
  query findElevationsPaginated($planId: Int!, $archived: Boolean, $page: Int, $limit: Int) {
    findElevationsPaginated(planId: $planId, archived: $archived, page: $page, limit: $limit) {
      error
      success
      meta {
        ...PaginationCoreInfo
      }
      items {
        id
        name
        sequence
        imageUrl
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindElevationsPaginatedGQL extends Apollo.Query<
  FindElevationsPaginatedQuery,
  FindElevationsPaginatedQueryVariables
> {
  document = FindElevationsPaginatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchElevationsCountDocument = gql`
  query fetchElevationsCount($planId: Int!) {
    fetchElevationsCount(planId: $planId) {
      error
      success
      statsCount: elevationsCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchElevationsCountGQL extends Apollo.Query<
  FetchElevationsCountQuery,
  FetchElevationsCountQueryVariables
> {
  document = FetchElevationsCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindElevationDocument = gql`
  query findElevation($elevationId: Int!) {
    findElevation(elevationId: $elevationId) {
      success
      error
      elevation {
        name
        imageUrl
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindElevationGQL extends Apollo.Query<
  FindElevationQuery,
  FindElevationQueryVariables
> {
  document = FindElevationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportPlansDocument = gql`
  mutation exportPlans(
    $order: SortOrder
    $sortBy: AllowedPlansSortFields
    $archived: Boolean
    $divisionIds: [Int!]
    $communityIds: [Int!]
    $name: String
    $hasElevations: Boolean
    $exportType: PlansExportTypes!
  ) {
    exportResponse: exportPlans(
      order: $order
      sortBy: $sortBy
      archived: $archived
      divisionIds: $divisionIds
      communityIds: $communityIds
      name: $name
      hasElevations: $hasElevations
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportPlansGQL extends Apollo.Mutation<
  ExportPlansMutation,
  ExportPlansMutationVariables
> {
  document = ExportPlansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveElevationsDocument = gql`
  mutation removeElevations($elevationsIds: [Int!]!) {
    removeElevations(elevationsIds: $elevationsIds) {
      error
      success
      elevations {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RemoveElevationsGQL extends Apollo.Mutation<
  RemoveElevationsMutation,
  RemoveElevationsMutationVariables
> {
  document = RemoveElevationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveElevationDocument = gql`
  mutation archiveElevation($archive: Boolean!, $elevationId: Int!) {
    archiveElevation(elevationId: $elevationId, archive: $archive) {
      success
      error
      elevation {
        name
        status
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveElevationGQL extends Apollo.Mutation<
  ArchiveElevationMutation,
  ArchiveElevationMutationVariables
> {
  document = ArchiveElevationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateElevationDocument = gql`
  mutation updateElevation($updateElevationInput: UpdateElevationInput!, $elevationId: Int!) {
    updateElevation(updateElevationInput: $updateElevationInput, elevationId: $elevationId) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateElevationGQL extends Apollo.Mutation<
  UpdateElevationMutation,
  UpdateElevationMutationVariables
> {
  document = UpdateElevationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateElevationsOrderDocument = gql`
  mutation updateElevationsOrder($elevationsIds: [Int!]!, $planId: Int!) {
    updateElevationsOrder(elevationsIds: $elevationsIds, planId: $planId) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateElevationsOrderGQL extends Apollo.Mutation<
  UpdateElevationsOrderMutation,
  UpdateElevationsOrderMutationVariables
> {
  document = UpdateElevationsOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateElevationsDocument = gql`
  mutation createElevations($createElevationInput: [CreateElevationInput!]!, $planId: Int!) {
    createElevations(createElevationInput: $createElevationInput, planId: $planId) {
      success
      error
      elevations {
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateElevationsGQL extends Apollo.Mutation<
  CreateElevationsMutation,
  CreateElevationsMutationVariables
> {
  document = CreateElevationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportElevationsDocument = gql`
  mutation exportElevations(
    $planId: Int!
    $archived: Boolean
    $exportType: ElevationsExportTypes!
  ) {
    exportResponse: exportElevations(
      planId: $planId
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportElevationsGQL extends Apollo.Mutation<
  ExportElevationsMutation,
  ExportElevationsMutationVariables
> {
  document = ExportElevationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchProfileDocument = gql`
  query fetchProfile {
    fetchProfile {
      success
      error
      user {
        id
        firstName
        lastName
        email
        jobTitle
        phone
        avatar
        workPhone
        teamMember {
          id
          groupName
          groupMembersNames
        }
        permissions {
          id
          name
          label
        }
        role {
          name
          label
        }
        homepage {
          label
          name
          id
        }
        notificationsSettings {
          email
          text
          name
          label
        }
        app {
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchProfileGQL extends Apollo.Query<FetchProfileQuery, FetchProfileQueryVariables> {
  document = FetchProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProfileDocument = gql`
  mutation updateProfile($updateProfileInput: UpdateProfileInput!) {
    updateProfile(updateProfileInput: $updateProfileInput) {
      success
      error
      user {
        firstName
        lastName
        email
        jobTitle
        phone
        avatar
        workPhone
        teamMember {
          id
          groupName
          groupMembersNames
        }
        role {
          name
          label
        }
        homepage {
          label
          name
          id
        }
        notificationsSettings {
          email
          text
          name
          label
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateProfileGQL extends Apollo.Mutation<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
> {
  document = UpdateProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateContactProfileDocument = gql`
  mutation updateContactProfile($updateContactProfileInput: UpdateGroupContactProfileInput!) {
    updateContactProfile(updateContactProfileInput: $updateContactProfileInput) {
      success
      error
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateContactProfileGQL extends Apollo.Mutation<
  UpdateContactProfileMutation,
  UpdateContactProfileMutationVariables
> {
  document = UpdateContactProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangePasswordDocument = gql`
  mutation changePassword($setPasswordInput: SetPasswordInput) {
    changePassword(setPasswordInput: $setPasswordInput) {
      error
      success
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordGQL extends Apollo.Mutation<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
> {
  document = ChangePasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetReportsDocument = gql`
  query getReports(
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $phaseNames: [String!]
    $date: String
  ) {
    getReports(
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      phaseNames: $phaseNames
      date: $date
    ) {
      totalHomeownerAccounts {
        name
        id
        activeLogins
        totalHomes
      }
      totalHomesByConstructionPhase {
        name
        id
        items {
          name
          id
          count
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class GetReportsGQL extends Apollo.Query<GetReportsQuery, GetReportsQueryVariables> {
  document = GetReportsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportReportsDocument = gql`
  mutation exportReports(
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $phaseNames: [String!]
    $date: String
    $charts: [ReportChartInput!]
    $exportType: ReportsExportTypes!
  ) {
    exportResponse: exportReports(
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      phaseNames: $phaseNames
      date: $date
      charts: $charts
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportReportsGQL extends Apollo.Mutation<
  ExportReportsMutation,
  ExportReportsMutationVariables
> {
  document = ExportReportsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindUsersDocument = gql`
  query findUsers(
    $page: Int
    $limit: Int
    $order: SortOrder
    $sortBy: AllowedUsersSortFields
    $rolesIds: [Int!]
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $jobTitle: String
    $email: String
    $name: String
    $archived: Boolean
  ) {
    findUsers(
      page: $page
      limit: $limit
      order: $order
      sortBy: $sortBy
      rolesIds: $rolesIds
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      jobTitle: $jobTitle
      email: $email
      name: $name
      archived: $archived
    ) {
      error
      items {
        id
        firstName
        lastName
        email
        phone
        jobTitle
        initialPasswordSet
        role {
          label
        }
        divisions {
          id
          name
        }
        communities {
          id
          division {
            id
            name
          }
        }
      }
      meta {
        ...PaginationCoreInfo
      }
    }
  }
  ${PaginationCoreInfoFragmentDoc}
`;

@Injectable({
  providedIn: 'root'
})
export class FindUsersGQL extends Apollo.Query<FindUsersQuery, FindUsersQueryVariables> {
  document = FindUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchUsersForAutoCompleteDocument = gql`
  query searchUsersForAutoComplete(
    $name: String
    $email: String
    $jobTitle: String
    $archived: Boolean
    $includeSelf: Boolean
    $order: SortOrder = asc
    $sortBy: AllowedUsersSortFields = name
  ) {
    findUsers(
      name: $name
      email: $email
      jobTitle: $jobTitle
      archived: $archived
      includeSelf: $includeSelf
      order: $order
      sortBy: $sortBy
    ) {
      error
      items {
        id
        fullName
        firstName
        lastName
        email
        jobTitle
        phone
        workPhone
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SearchUsersForAutoCompleteGQL extends Apollo.Query<
  SearchUsersForAutoCompleteQuery,
  SearchUsersForAutoCompleteQueryVariables
> {
  document = SearchUsersForAutoCompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindUserByIdDocument = gql`
  query findUserById($id: Int!) {
    findUserById(id: $id) {
      error
      user {
        id
        firstName
        lastName
        fullName
        email
        jobTitle
        phone
        workPhone
        avatar
        role {
          id
          label
        }
        divisions {
          id
        }
        communities {
          id
        }
        permissions {
          id
        }
        notificationsSettings {
          email
          text
          id
          label
          name
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindUserByIdGQL extends Apollo.Query<FindUserByIdQuery, FindUserByIdQueryVariables> {
  document = FindUserByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindRolesDocument = gql`
  query findRoles {
    findRoles {
      error
      roles {
        id
        label
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindRolesGQL extends Apollo.Query<FindRolesQuery, FindRolesQueryVariables> {
  document = FindRolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FetchUsersCountDocument = gql`
  query fetchUsersCount {
    fetchUsersCount {
      error
      statsCount: usersCount {
        active
        archived
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FetchUsersCountGQL extends Apollo.Query<
  FetchUsersCountQuery,
  FetchUsersCountQueryVariables
> {
  document = FetchUsersCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateUserCommunityAssignmentsDocument = gql`
  query validateUserCommunityAssignments($divisionId: Int!) {
    validateUserCommunityAssignments(divisionId: $divisionId) {
      hasAtLeastOneUserWithAllCommunityAssignments
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ValidateUserCommunityAssignmentsGQL extends Apollo.Query<
  ValidateUserCommunityAssignmentsQuery,
  ValidateUserCommunityAssignmentsQueryVariables
> {
  document = ValidateUserCommunityAssignmentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteUserDocument = gql`
  mutation deleteUser($id: Int!) {
    deleteUser(id: $id) {
      error
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteUserGQL extends Apollo.Mutation<
  DeleteUserMutation,
  DeleteUserMutationVariables
> {
  document = DeleteUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateUserDocument = gql`
  mutation createUser($createUserInput: CreateUserInput!) {
    createUser(createUserInput: $createUserInput) {
      error
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateUserGQL extends Apollo.Mutation<
  CreateUserMutation,
  CreateUserMutationVariables
> {
  document = CreateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveUserDocument = gql`
  mutation archiveUser($archive: Boolean!, $id: Int!) {
    archiveUser(archive: $archive, id: $id) {
      error
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ArchiveUserGQL extends Apollo.Mutation<
  ArchiveUserMutation,
  ArchiveUserMutationVariables
> {
  document = ArchiveUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateUserDocument = gql`
  mutation updateUser($updateUserInput: UpdateUserInput!, $id: Int!) {
    updateUser(updateUserInput: $updateUserInput, id: $id) {
      error
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateUserGQL extends Apollo.Mutation<
  UpdateUserMutation,
  UpdateUserMutationVariables
> {
  document = UpdateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendWelcomeEmailDocument = gql`
  mutation sendWelcomeEmail($id: Int!) {
    sendWelcomeEmail(id: $id) {
      error
      user {
        fullName
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class SendWelcomeEmailGQL extends Apollo.Mutation<
  SendWelcomeEmailMutation,
  SendWelcomeEmailMutationVariables
> {
  document = SendWelcomeEmailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportUsersDocument = gql`
  mutation exportUsers(
    $order: SortOrder
    $sortBy: AllowedUsersSortFields
    $rolesIds: [Int!]
    $divisionsIds: [Int!]
    $communitiesIds: [Int!]
    $jobTitle: String
    $email: String
    $name: String
    $archived: Boolean
    $exportType: UsersExportTypes!
  ) {
    exportResponse: exportUsers(
      order: $order
      sortBy: $sortBy
      rolesIds: $rolesIds
      divisionsIds: $divisionsIds
      communitiesIds: $communitiesIds
      jobTitle: $jobTitle
      email: $email
      name: $name
      archived: $archived
      exportType: $exportType
    ) {
      error
      content
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class ExportUsersGQL extends Apollo.Mutation<
  ExportUsersMutation,
  ExportUsersMutationVariables
> {
  document = ExportUsersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FindUsersForContactAutocompleteDocument = gql`
  query findUsersForContactAutocomplete(
    $name: String
    $divisionId: Int
    $action: DivisionAction
    $withoutContacts: Boolean
  ) {
    findUsersForContactAutocomplete(
      name: $name
      divisionId: $divisionId
      action: $action
      withoutContacts: $withoutContacts
    ) {
      error
      users {
        id
        firstName
        lastName
        jobTitle
        fullName
        email
        phone
        workPhone
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FindUsersForContactAutocompleteGQL extends Apollo.Query<
  FindUsersForContactAutocompleteQuery,
  FindUsersForContactAutocompleteQueryVariables
> {
  document = FindUsersForContactAutocompleteDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
